import { jsx as s, jsxs as b, Fragment as Ie } from "react/jsx-runtime";
import be, { useState as R, useRef as jt, useMemo as L, useEffect as ye, createContext as Go, useContext as bn, useSyncExternalStore as qr, useCallback as _ } from "react";
import { M as k } from "./MaterialSymbol-hT2awJjQ.js";
import { T as Zr, i as Yo, l as dt, a as Rn, n as eo, m as to, o as zr, q as Xo, c as mr, r as Ln, p as Ut, f as Qo, k as no, d as ar, s as Jo, g as Br, t as qo, u as Zo, j as sn, v as ea } from "./collabTree-CAWl6jZl.js";
import { a as w, b as J, s as f, C as ta, i as ro, P as na, u as j, c as vr } from "./index-CgGCtE61.js";
import { p as oo, f as ra, g as oa, h as aa, i as sa, v as xr, u as cn, c as sr } from "./EditorHeaderBar-H6fYofbz.js";
import { F as Vt, u as ia, a as la, o as ca, f as da, s as ua, l as pa, c as ma, d as fa, e as ha } from "./floating-ui.react-87bo4V3_.js";
import { w as ya } from "./windowControlsClearance-BonpJzP6.js";
import "./syncClientInfo-D4E7fbgz.js";
const ba = ["draft", "current", "outdated"], ga = 32, va = 280, xa = /^[^\s@]+@[^\s@]+$/;
function dn(n) {
  if (!n || typeof n != "object" || Array.isArray(n)) return {};
  const e = n, t = {}, r = (l) => typeof l == "string" ? l.trim().slice(0, va) : "", o = r(e.owner);
  o && xa.test(o) && (t.owner = o), typeof e.status == "string" && ba.includes(e.status) && (t.status = e.status);
  const a = r(e.summary);
  if (a && (t.summary = a), Array.isArray(e.tags)) {
    const l = [...new Set(e.tags.map(r).filter(Boolean))].slice(0, ga);
    l.length > 0 && (t.tags = l);
  }
  return t;
}
function wa(n, e) {
  const t = { ...dn(n) };
  for (const [r, o] of Object.entries(e)) {
    if (o == null || o === "") {
      delete t[r];
      continue;
    }
    const a = dn({ [r]: o });
    r in a && (t[r] = a[r]);
  }
  return dn(t);
}
function ri(n, e) {
  const t = dn(n), r = dn(e);
  return t.owner === r.owner && t.status === r.status && t.summary === r.summary && (t.tags ?? []).join("\0") === (r.tags ?? []).join("\0");
}
function Bn(n, e, t) {
  return t && n.lastChangeActorId && n.lastChangeActorId === t ? !1 : e ? n.currentVersion != null && e.lastSeenVersion != null ? e.lastSeenVersion < n.currentVersion : n.currentVersionTimestamp > e.lastViewedAt : !0;
}
function fn(n, e) {
  if (!n)
    return { lastSeenVersion: e.lastSeenVersion, lastViewedAt: e.lastViewedAt };
  const t = Math.max(n.lastViewedAt, e.lastViewedAt);
  let r;
  return n.lastSeenVersion == null ? r = e.lastSeenVersion : e.lastSeenVersion == null ? r = n.lastSeenVersion : r = Math.max(n.lastSeenVersion, e.lastSeenVersion), { lastSeenVersion: r, lastViewedAt: t };
}
const Ia = 20;
function ao(n, e) {
  if (n.length === 0) return [];
  const t = new Map(e.map((o) => [o.documentId, o])), r = [];
  for (const o of n) {
    const a = t.get(o);
    a && r.push(a);
  }
  return r;
}
function so(n, e, t = Ia) {
  return n.map((r) => ({ doc: r, openedAt: e[r.documentId] ?? 0 })).filter((r) => r.openedAt > 0).sort((r, o) => o.openedAt - r.openedAt).slice(0, t).map((r) => r.doc);
}
function wr(n, e) {
  const t = [];
  for (const r of n) {
    if (r.decryptFailed) continue;
    const { unread: o, hasReceipt: a } = e(r);
    o && t.push({ doc: r, freshness: a ? "updated" : "new" });
  }
  return t.sort((r, o) => (o.doc.updatedAt ?? 0) - (r.doc.updatedAt ?? 0)), t;
}
function Ur(n) {
  return n.replace(/\r\n?/g, `
`).split(`
`).map((e) => e.replace(/[ \t]+$/, "")).join(`
`).replace(/\n{3,}/g, `

`).trim();
}
function Sa(n) {
  return /!\[[^\]]*\]\([^)]+\)/.test(n) || /<img\b/i.test(n);
}
function* fr(n, e) {
  yield { node: n, parentId: e };
  for (const t of n.children) yield* fr(t, n.documentId);
}
async function oi(n, e) {
  const t = e.readTree(n);
  if (!t.ok) return t;
  const r = /* @__PURE__ */ new Map();
  for (const { node: p } of fr(t.root, null)) {
    const h = await e.readSource(p.documentId);
    if (Sa(h.markdown))
      return { ok: !1, error: `"${p.title}" has images, which can't move between sections yet.` };
    r.set(p.documentId, h);
  }
  const o = /* @__PURE__ */ new Map();
  let a = null;
  const l = async (p) => (a && await e.trashDestination(a).catch(() => {
  }), { ok: !1, error: p });
  try {
    for (const { node: p, parentId: h } of fr(t.root, null)) {
      const y = r.get(p.documentId), C = await e.createDestination({
        title: p.title,
        markdown: y.markdown,
        parentId: h ? o.get(h) ?? null : null,
        ...p.fields ? { fields: p.fields } : {}
      });
      o.set(p.documentId, C), a ??= C;
      const M = await e.readDestination(C);
      if (Ur(M) !== Ur(y.markdown))
        return await l(`"${p.title}" did not arrive intact, so nothing was moved.`);
    }
    for (const [p, h] of r)
      if (!await e.sourceUnchanged(p, h))
        return await l("A page changed while it was being moved, so nothing was moved. Try again.");
  } catch (p) {
    return l(`The move did not finish, so nothing was moved: ${p instanceof Error ? p.message : String(p)}`);
  }
  const c = await e.trashSource(n);
  return c.ok ? { ok: !0, pageId: a, moved: r.size } : { ok: !1, error: `The pages were copied, but the originals could not be moved to Trash: ${c.error}` };
}
function ai(n, e, t) {
  const r = e.filter((p) => !p.trashedAt), o = new Map(r.map((p) => [p.documentId, p])), a = (p) => {
    if (p.documentId.startsWith(Zr)) return `"${p.title}" is a type's description and stays with its type.`;
    if (p.documentType !== "markdown") return `"${p.title}" is not a markdown page.`;
    if (t.items.some((y) => y.parentId === p.documentId) || t.types.some((y) => y.parentFolderId === p.documentId))
      return `"${p.title}" holds typed pages or a type, which belong to their own section.`;
    const h = [];
    for (const y of r.filter((C) => C.parentFolderId === p.documentId && C.parentKind !== "item")) {
      const C = a(y);
      if (typeof C == "string") return C;
      h.push(C);
    }
    return { documentId: p.documentId, title: p.title, ...p.fields ? { fields: p.fields } : {}, children: h };
  }, l = o.get(n);
  if (!l) return { ok: !1, error: "The page is no longer here." };
  const c = a(l);
  return typeof c == "string" ? { ok: !1, error: c } : { ok: !0, root: c };
}
function ka(n, e) {
  const t = ra(n);
  return t.terms.length === 0 ? [] : e.filter((r) => oa(r.title, t)).map((r) => ({
    ...sa(r.documentId),
    documentId: r.documentId,
    title: r.title,
    issueKey: r.issueKey ?? null,
    snippet: "",
    highlights: [],
    updatedAt: r.updatedAt ?? null,
    score: aa
  }));
}
function Ca(n, e, t) {
  const r = /* @__PURE__ */ new Map();
  for (const o of n) r.set(o.documentId, { ...o });
  for (const o of e) {
    const a = r.get(o.documentId);
    r.set(o.documentId, a ? { ...a, title: a.title ?? o.title, issueKey: a.issueKey ?? o.issueKey, score: a.score + o.score } : o);
  }
  return [...r.values()].sort((o, a) => a.score - o.score || (a.updatedAt ?? 0) - (o.updatedAt ?? 0) || o.documentId.localeCompare(a.documentId)).slice(0, oo(t));
}
function si(n, e) {
  const t = [];
  for (const r of n) {
    if (r.kind !== "typed") {
      t.push(r);
      continue;
    }
    const o = e(r.id);
    o && t.push({ ...r, title: r.title ?? o.title, issueKey: r.issueKey ?? o.issueKey ?? null });
  }
  return t;
}
function Na(n) {
  return n.filter((e) => e.trashedAt == null && e.title).map((e) => ({ documentId: e.documentId, title: e.title, updatedAt: e.updatedAt ?? null }));
}
async function Ta(n, e, t) {
  const r = Na(e), o = new Map(r.map((c) => [c.documentId, c])), a = n.searchPages ? await n.searchPages({ ...t, limit: oo(t.limit) }) : null;
  if (n.searchPages && !a) return null;
  const l = (a?.hits ?? []).flatMap((c) => {
    if (c.kind === "typed") return [c];
    const p = o.get(c.documentId);
    return p ? [{ ...c, title: c.title ?? p.title }] : [];
  });
  return {
    hits: Ca(l, ka(t.query, r), t.limit),
    status: a?.status ?? "ready"
  };
}
function io(n, e) {
  const t = n.find((o) => o.documentId === e)?.trashedAt, r = [e];
  for (let o = 0; t != null && o < r.length; o++)
    for (const a of n)
      a.parentFolderId === r[o] && (a.parentKind ?? "page") === "page" && a.trashedAt === t && !r.includes(a.documentId) && r.push(a.documentId);
  return r;
}
function Da(n, e, t) {
  const r = n.find((a) => a.documentId === e);
  if (!r?.parentFolderId || r.parentKind === "item") return !1;
  const o = n.find((a) => a.documentId === r.parentFolderId);
  return !o || o.trashedAt != null && !t.has(o.documentId);
}
function Pa(n) {
  const e = new Map(n.map((t) => [t.documentId, t]));
  return n.filter((t) => {
    if (t.trashedAt == null) return !1;
    const r = t.parentFolderId && (t.parentKind ?? "page") === "page" ? e.get(t.parentFolderId) : void 0;
    return !r || r.trashedAt !== t.trashedAt;
  }).sort((t, r) => (r.trashedAt ?? 0) - (t.trashedAt ?? 0)).map((t) => ({
    document: t,
    insideCount: io(n, t.documentId).filter((r) => r !== t.documentId && !Yo(r)).length
  }));
}
const te = J((n) => w([])), et = J((n) => w([])), un = J((n) => w(null)), We = J((n) => w([])), He = J((n) => w([])), pn = J((n) => w([])), hn = J((n) => w(!1)), On = J((n) => w(!1)), gn = J((n) => {
  let e = [];
  return w(
    (t) => {
      if (!t(hn(n))) return t(We(n));
      const r = to(t(te(n)));
      return r.length === e.length && r.every((a, l) => {
        const c = e[l];
        return c.folderId === a.folderId && c.name === a.name && (c.parentFolderId ?? null) === (a.parentFolderId ?? null) && c.parentKind === a.parentKind && c.decryptFailed === a.decryptFailed;
      }) || (e = r), e;
    },
    (t, r, o) => {
      const a = We(n);
      r(a, typeof o == "function" ? o(t(a)) : o);
    }
  );
}), St = J((n) => w("disconnected")), Wt = J((n) => w(!1)), mn = J((n) => w(null)), Aa = 2, Nt = J((n) => w(!1)), Ir = J((n) => w(null)), Un = J((n) => w(null)), kt = J((n) => w([])), Kn = J((n) => w({})), Ht = J((n) => w({})), Tt = J((n) => w("all")), Dt = J((n) => w(!0)), hr = J((n) => w(null)), tt = J((n) => w(/* @__PURE__ */ new Map())), yr = J((n) => w(/* @__PURE__ */ new Map())), Pt = J((n) => w(!1)), Ct = /* @__PURE__ */ new Map(), Fa = /* @__PURE__ */ new Map(), Ge = /* @__PURE__ */ new Map(), jr = w(null), le = w(
  (n) => n(jr),
  (n, e, t) => {
    if (t && Ge.get(t.scopeKey)?.uiCapabilities.readReceipts !== !1) {
      const r = yr(t.orgId), o = n(r);
      if (o.size > 0) {
        const a = tt(t.scopeKey), l = new Map(n(a));
        let c = n($n), p = Ct.get(t.scopeKey);
        p || (p = /* @__PURE__ */ new Set(), Ct.set(t.scopeKey, p));
        for (const [h, y] of o)
          l.set(h, fn(l.get(h), y)), p.add(h), e(Pt(Ft(t.scopeKey, h)), !1), c = co(c, t.orgId, h, !1);
        e(a, l), e($n, c), yr.remove(t.orgId);
      }
    }
    e(jr, t);
  }
);
function Sr(n) {
  return w(
    (e) => {
      const t = e(le);
      return t ? e(n(t.scopeKey)) : [];
    },
    (e, t, r) => {
      const o = e(le);
      if (!o) return;
      const a = n(o.scopeKey);
      t(a, typeof r == "function" ? r(e(a)) : r);
    }
  );
}
const Mn = Sr(te), jn = w(
  (n) => n(Mn).filter((e) => e.trashedAt == null),
  (n, e, t) => {
    e(Mn, typeof t == "function" ? t(n(Mn)) : t);
  }
), ii = w(
  (n) => n(Mn).filter((e) => e.trashedAt != null).sort((e, t) => (t.trashedAt ?? 0) - (e.trashedAt ?? 0))
), kr = J(
  (n) => w((e) => [...e(te(n)), ...e(et(n))].filter((t) => t.trashedAt == null))
), li = w((n) => {
  const e = n(le);
  return e ? n(kr(e.scopeKey)) : [];
}), ci = Sr(gn), di = Sr(He), ui = w(
  (n) => {
    const e = n(le);
    return e ? n(St(e.scopeKey)) : "disconnected";
  },
  (n, e, t) => {
    const r = n(le);
    r && e(St(r.scopeKey), t);
  }
), pi = w(
  (n) => {
    const e = n(le);
    return e ? n(Nt(e.scopeKey)) : !1;
  },
  (n, e, t) => {
    const r = n(le);
    r && e(Nt(r.scopeKey), t);
  }
), mi = w((n) => {
  const e = n(le);
  return e ? n(Ir(e.scopeKey)) : null;
}), _a = w((n) => {
  const e = n(le);
  return e ? n(Un(e.scopeKey)) : null;
}), lo = w(null), fi = w(null, (n, e, t) => {
  e(jn, (r) => [
    t,
    ...r.filter((o) => o.documentId !== t.documentId)
  ]);
}), Ea = w((n) => {
  const e = n(le);
  return e ? n(kt(e.scopeKey)) : [];
}), Ka = w((n) => {
  const e = n(le);
  return e ? n(Ht(e.scopeKey)) : {};
}), hi = w(
  (n) => {
    const e = n(le);
    return e ? n(Tt(e.scopeKey)) : "all";
  },
  (n, e, t) => {
    const r = n(le);
    r && (e(Tt(r.scopeKey), t), Ge.get(r.scopeKey)?.persistViewPreferences());
  }
), yi = w(
  (n) => {
    const e = n(le);
    return e ? n(Dt(e.scopeKey)) : !0;
  },
  (n, e, t) => {
    const r = n(le);
    r && (e(Dt(r.scopeKey), t), Ge.get(r.scopeKey)?.persistViewPreferences());
  }
);
function At(n) {
  return n(le)?.scopeKey ?? null;
}
function Ft(n, e) {
  return `${n}\0${e}`;
}
const Ma = J((n) => w(
  (e) => {
    const t = At(e);
    return t ? e(Pt(Ft(t, n))) : !1;
  },
  (e, t, r) => {
    const o = At(e);
    o && t(Pt(Ft(o, n)), r);
  }
)), $n = w(/* @__PURE__ */ new Map()), Ra = w(
  (n) => {
    const e = At(n);
    return e ? n(tt(e)) : Fa;
  },
  (n, e, t) => {
    const r = At(n);
    if (!r) return;
    const o = tt(r);
    e(o, typeof t == "function" ? t(n(o)) : t);
  }
);
function Vn(n) {
  return {
    currentVersion: null,
    currentVersionTimestamp: n.updatedAt ?? 0,
    lastChangeActorId: n.lastWriterUserId ?? null
  };
}
function co(n, e, t, r) {
  const o = new Map(n), a = o.get(e);
  if (r) {
    if (a?.has(t)) return n;
    const l = new Set(a ?? []);
    l.add(t), o.set(e, l);
  } else {
    if (!a?.has(t)) return n;
    const l = new Set(a);
    l.delete(t), l.size === 0 ? o.delete(e) : o.set(e, l);
  }
  return o;
}
const uo = w(
  null,
  (n, e, t) => {
    const r = t.scopeKey ?? At(n);
    if (!r) return;
    let o = Ct.get(r);
    o || (o = /* @__PURE__ */ new Set(), Ct.set(r, o)), o.add(t.documentId), e(Pt(Ft(r, t.documentId)), t.unread);
    const a = n($n), l = co(a, t.orgId, t.documentId, t.unread);
    l !== a && e($n, l);
  }
), La = w(
  null,
  (n, e, t) => {
    const r = t.scopeKey ?? At(n);
    if (r)
      for (const o of t.docs) {
        const a = Bn(
          Vn(o),
          t.receipts.get(o.documentId) ?? null,
          t.currentUserId
        );
        n(Pt(Ft(r, o.documentId))) !== a && e(uo, { scopeKey: r, documentId: o.documentId, orgId: t.orgId, unread: a });
      }
  }
), po = w(
  null,
  (n, e, t) => {
    const r = t.scopeKey ?? At(n);
    if (!r) return;
    const o = tt(r), a = new Map(n(o));
    a.set(t.documentId, fn(a.get(t.documentId), t.receipt)), e(o, a), e(uo, { scopeKey: r, documentId: t.documentId, orgId: t.orgId, unread: !1 });
  }
), bi = w(
  null,
  (n, e, t) => {
    const r = [...Ge.values()].filter((a) => a.scope.orgId === t.orgId), o = r.filter((a) => a.uiCapabilities.readReceipts);
    if (o.length === 0) {
      if (r.length > 0) return;
      const a = yr(t.orgId), l = new Map(n(a));
      l.set(t.documentId, fn(l.get(t.documentId), t.receipt)), e(a, l);
      return;
    }
    for (const a of o)
      e(po, {
        ...t,
        scopeKey: a.scope.scopeKey
      });
  }
), gi = w(
  (n) => ao(n(Ea), n(jn))
), vi = w(
  (n) => so(n(jn), n(Ka))
), Oa = w((n) => {
  const e = n(Ra), t = n(_a);
  return wr(n(jn), (r) => {
    const o = e.get(r.documentId) ?? null;
    return {
      unread: Bn(Vn(r), o, t),
      hasReceipt: o !== null
    };
  });
}), xi = w(
  (n) => new Set(n(Oa).map(({ doc: e }) => e.documentId))
);
function $a(n, e) {
  const t = n.scopeKey, r = te(t), o = w(
    (O) => O(r).filter((E) => E.trashedAt == null),
    (O, E, z) => {
      E(r, typeof z == "function" ? z(O(r)) : z);
    }
  ), a = w((O) => O(r).filter((E) => E.trashedAt != null).sort((E, z) => (z.trashedAt ?? 0) - (E.trashedAt ?? 0))), l = gn(t), c = St(t), p = Nt(t), h = Un(t), y = kt(t), C = Ht(t), M = tt(t), T = w((O) => ao(O(y), O(o))), $ = w((O) => so(O(o), O(C))), oe = w((O) => e.readReceipts ? wr(
    O(o),
    (E) => {
      const z = O(M).get(E.documentId) ?? null;
      return {
        unread: Bn(Vn(E), z, O(h)),
        hasReceipt: z !== null
      };
    }
  ) : []), Ne = w((O) => new Set(
    O(oe).map(({ doc: E }) => E.documentId)
  )), ne = w(
    (O) => O(Tt(t)),
    (O, E, z) => {
      const K = z === "favorites" && !e.personalState || z === "updated" && !e.readReceipts ? "all" : z;
      E(Tt(t), K), Ge.get(t)?.persistViewPreferences();
    }
  ), A = w(
    (O) => O(Dt(t)),
    (O, E, z) => {
      E(Dt(t), e.readReceipts && z), Ge.get(t)?.persistViewPreferences();
    }
  ), g = w((O) => {
    const E = O(lo);
    return E?.scopeKey === t ? E : null;
  }), S = J((O) => w((E) => E(Pt(Ft(t, O)))));
  return {
    sharedDocuments: o,
    allSharedDocuments: r,
    trashedSharedDocuments: a,
    sharedFolders: l,
    typePlacements: He(t),
    itemPlacements: pn(t),
    pageTree: hn(t),
    pageFields: On(t),
    syncStatus: c,
    hasTeam: p,
    activeTeamUserId: h,
    favorites: y,
    changedDocumentIds: Ne,
    openedAt: C,
    receipts: M,
    favoriteDocuments: T,
    recentDocuments: $,
    changedDocuments: oe,
    treeFilter: ne,
    showUnreadBubbles: A,
    pendingFolder: g,
    unreadDocument: S
  };
}
function zn(n) {
  return typeof n == "string" && n.trim().length > 0;
}
function br(n, e) {
  const t = {
    ...e,
    metadataVersion: e.metadataVersion ?? n.metadataVersion,
    fileExtension: e.fileExtension ?? n.fileExtension,
    editorId: e.editorId ?? n.editorId
  };
  return !zn(e.title) && zn(n.title) ? { ...t, title: n.title, decryptFailed: !1 } : t;
}
function mo(n, e) {
  return !zn(e.name) && zn(n.name) ? { ...e, name: n.name, decryptFailed: !1 } : e;
}
function fo(n, e, t, r) {
  const o = new Map(n.map((l) => [t(l), l])), a = new Set(e.map(t));
  return [
    ...e.map((l) => {
      const c = o.get(t(l));
      return c ? r(c, l) : l;
    }),
    ...n.filter((l) => !a.has(t(l)))
  ];
}
function Vr(n, e) {
  if (e.length === 0) return n;
  const t = new Set(e.map((r) => r.documentId));
  return n.filter((r) => !t.has(r.documentId));
}
function Wr(n, e) {
  return fo(n, e, (t) => t.documentId, br);
}
function za(n, e) {
  return fo(n, e, (t) => t.folderId, mo);
}
function Ba(n) {
  const e = /* @__PURE__ */ new Set(), t = /* @__PURE__ */ new Map();
  for (const r of n) {
    if (r.parentFolderId || r.decryptFailed) continue;
    const o = dt(eo(r.title));
    if (!o) continue;
    t.set(r.documentId, o);
    let a = o;
    for (; a; )
      e.add(a), a = dt(a);
  }
  return {
    folderPaths: [...e].sort((r, o) => r.split("/").length - o.split("/").length),
    docParent: t
  };
}
function Ua(n, e, t, r) {
  return n.map((o, a) => {
    const l = dt(o);
    return {
      folderId: e.get(o),
      parentFolderId: l ? e.get(l) ?? null : null,
      name: Rn(o),
      sortOrder: a,
      createdBy: t,
      createdAt: r,
      updatedAt: r
    };
  });
}
async function ir(n) {
  return (await Promise.all(n)).find((e) => !e.ok) ?? { ok: !0 };
}
async function ja(n, e) {
  const t = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(`${n}:${e}`));
  return `fld_${[...new Uint8Array(t)].map((o) => o.toString(16).padStart(2, "0")).join("").slice(0, 24)}`;
}
class Va {
  constructor(e, t, r) {
    this.scope = e, this.dataSource = t, this.host = r;
    const o = r.personalState.status === "available";
    this.uiCapabilities = Object.freeze({
      personalState: o,
      // Read watermarks are personal UI only when the personal lane itself is
      // present; this keeps a partial host from exposing a misleading subset.
      readReceipts: o && r.documents.readReceipts.status === "available"
    }), this.atoms = $a(e, this.uiCapabilities);
  }
  scope;
  dataSource;
  host;
  atoms;
  uiCapabilities;
  dataUnsubscribe = null;
  personalStateUnsubscribe = null;
  receiptUnsubscribe = null;
  startPromise = null;
  /** A connection is under way that has not delivered the index yet. */
  indexAttemptOpen = !1;
  failedIndexAttempts = 0;
  migratedFolders = !1;
  disposed = !1;
  /**
   * A page's placement while its move is unanswered. The author receives its
   * own move broadcasts, so an earlier move's echo can land after a later
   * move's optimistic write; the latest local move wins until it is answered.
   */
  pendingMoves = /* @__PURE__ */ new Map();
  activate() {
    f.set(le, this.scope);
  }
  start() {
    return this.startPromise ??= this.startInternal().catch((e) => {
      throw this.startPromise = null, f.set(St(this.scope.scopeKey), "error"), e;
    }), this.startPromise;
  }
  dispose() {
    this.disposed || (this.disposed = !0, this.dataUnsubscribe?.(), this.personalStateUnsubscribe?.(), this.receiptUnsubscribe?.(), this.dataSource.dispose(), Ge.delete(this.scope.scopeKey), f.set(St(this.scope.scopeKey), "disconnected"), f.set(Nt(this.scope.scopeKey), !1), f.set(Wt(this.scope.scopeKey), !1), f.set(mn(this.scope.scopeKey), null));
  }
  persistViewPreferences() {
    const e = {
      treeFilter: f.get(Tt(this.scope.scopeKey)),
      showUnreadBubbles: f.get(Dt(this.scope.scopeKey))
    };
    this.host.documents.saveViewPreferences(this.scope.scopeKey, e).catch((t) => this.host.reportError?.(t, "Failed to save shared document preferences"));
  }
  hydrateViewPreferences(e) {
    const t = e?.treeFilter === "favorites" && this.uiCapabilities.personalState ? "favorites" : e?.treeFilter === "updated" && this.uiCapabilities.readReceipts ? "updated" : "all";
    f.set(Tt(this.scope.scopeKey), t), f.set(
      Dt(this.scope.scopeKey),
      this.uiCapabilities.readReceipts && e?.showUnreadBubbles !== !1
    );
  }
  async hydratePersonalState() {
    if (this.host.personalState.status === "unavailable") return;
    const e = this.host.personalState.capability, t = await e.snapshot(this.scope);
    this.disposed || (f.set(hr(this.scope.scopeKey), t.scope), f.set(
      kt(this.scope.scopeKey),
      t.rows.filter((r) => r.isFavorite).sort((r, o) => o.favoriteUpdatedAt - r.favoriteUpdatedAt).map((r) => r.itemId)
    ), f.set(
      Kn(this.scope.scopeKey),
      Object.fromEntries(t.rows.map((r) => [r.itemId, r.favoriteUpdatedAt]))
    ), f.set(
      Ht(this.scope.scopeKey),
      Object.fromEntries(t.rows.filter((r) => r.lastOpenedAt != null).map((r) => [r.itemId, r.lastOpenedAt]))
    ), this.personalStateUnsubscribe?.(), this.personalStateUnsubscribe = e.subscribe(
      this.scope,
      (r) => this.applyPersonalStateRow(r)
    ));
  }
  async registerDocument(e) {
    const t = this.otherProjectRefusal([
      e.documentId,
      e.parentKind === "item" ? null : e.parentFolderId
    ]);
    if (t) throw new Error(t);
    const r = Date.now(), o = e.sortOrder !== void 0 ? e.sortOrder : this.isPageTree() ? (await import("./collabPageTree-DUvCpMMn.js")).nextPageOrder(
      this.getAllDocuments(),
      f.get(He(this.scope.scopeKey)),
      this.getItemPlacements(),
      e.parentFolderId,
      e.parentKind ?? "page"
    ) : null, { sortOrder: a, ...l } = e, c = { ...l, ...o != null ? { sortOrder: o } : {} };
    return f.set(te(this.scope.scopeKey), (h) => [{
      ...c,
      ...c.metadata,
      teamProjectId: this.scope.indexConfig.teamProjectId ?? null,
      createdBy: "",
      createdAt: r,
      updatedAt: r
    }, ...h.filter((y) => y.documentId !== c.documentId)]), (await this.dataSource.command({ type: "register-document", ...c })).registrationAcked === !0;
  }
  async updateDocumentTitle(e, t) {
    const r = this.refusedWrite([e]);
    if (r) return r;
    const o = Date.now(), a = te(this.scope.scopeKey), l = f.get(a).find((h) => h.documentId === e), c = l ? { ...l, title: t, updatedAt: o } : null;
    c && f.set(a, (h) => [c, ...h.filter((y) => y.documentId !== e)]);
    const p = await this.settle(this.dataSource.command({ type: "update-document-title", documentId: e, title: t }), "Failed to update document title");
    return !p.ok && l && c && f.set(a, (h) => h.map((y) => y === c ? l : y)), p;
  }
  /**
   * Sets some of a plain page's own fields (null clears one). Shown at once and
   * put back if the store refuses; the store's next row is authoritative.
   */
  async updateDocumentFields(e, t) {
    if (!f.get(On(this.scope.scopeKey)))
      return { ok: !1, error: "Page fields are not available in this section yet." };
    const r = this.refusedWrite([e]);
    if (r) return r;
    const o = te(this.scope.scopeKey), a = f.get(o).find((p) => p.documentId === e);
    let l = null;
    if (a) {
      const p = wa(a.fields, t);
      l = { ...a, fields: p, updatedAt: Date.now() }, Object.keys(p).length === 0 && delete l.fields, f.set(o, (h) => h.map((y) => y === a ? l : y));
    }
    const c = await this.settle(this.dataSource.command({ type: "set-document-fields", documentId: e, fields: t }), "Failed to update page fields");
    return !c.ok && a && l && f.set(o, (p) => p.map((h) => h === l ? a : h)), c;
  }
  removeDocument(e, t = {}) {
    const r = this.refusedWrite([e]);
    if (r) return r;
    const o = te(this.scope.scopeKey), a = f.get(o).find((l) => l.documentId === e);
    return f.set(o, (l) => l.filter((c) => c.documentId !== e)), this.send({ type: "remove-document", documentId: e, ...t.purge ? { purge: !0 } : {} }).then((l) => (!l.ok && a && f.set(o, (c) => c.some((p) => p.documentId === e) ? c : [a, ...c]), l));
  }
  trashDocument(e, t = Date.now()) {
    const r = this.refusedWrite([e]);
    return r || (f.set(te(this.scope.scopeKey), (o) => o.map((a) => a.documentId === e ? { ...a, trashedAt: t, updatedAt: t } : a)), this.send({ type: "trash-document", documentId: e, trashedAt: t }));
  }
  restoreDocument(e) {
    const t = this.otherProjectRefusal([e]);
    if (t) return Promise.resolve({ ok: !1, error: t, restored: 0, movedToRoot: !1 });
    const r = Date.now(), o = this.getAllDocuments(), a = io(o, e), l = new Set(a), c = Da(o, e, l), p = new Map(o.filter((C) => l.has(C.documentId)).map((C) => [C.documentId, C.trashedAt ?? null])), h = te(this.scope.scopeKey);
    f.set(h, (C) => C.map((M) => l.has(M.documentId) ? { ...M, trashedAt: null, updatedAt: r } : M));
    const y = a.map((C) => this.send({ type: "restore-document", documentId: C }));
    return ir(y).then(async (C) => {
      if (!C.ok)
        return f.set(h, (T) => T.map(($) => p.has($.documentId) && $.trashedAt == null && $.updatedAt === r ? { ...$, trashedAt: p.get($.documentId) } : $)), { ...C, restored: 0, movedToRoot: !1 };
      if (!c) return { ok: !0, restored: a.length, movedToRoot: !1 };
      const M = await this.moveDocument(e, null);
      return { ...M, restored: a.length, movedToRoot: M.ok };
    });
  }
  emptyTrash() {
    const e = this.getAllDocuments().filter((t) => t.trashedAt != null);
    for (const t of e) this.removeDocument(t.documentId, { purge: !0 });
    return e.length;
  }
  moveDocument(e, t, r = {}) {
    const o = this.refusedWrite([e, r.parentKind === "item" ? null : t]);
    if (o) return o;
    const a = r.parentKind === "item" && t ? "item" : void 0, l = Symbol(e);
    let c = null;
    f.set(te(this.scope.scopeKey), (h) => h.map((y) => {
      if (y.documentId !== e) return y;
      const { parentKind: C, ...M } = y;
      c = { parentFolderId: y.parentFolderId, ...C ? { parentKind: C } : {}, sortOrder: y.sortOrder };
      const T = (y.parentFolderId ?? null) === t && (C ?? "page") === (a ?? "page"), $ = r.sortOrder !== void 0 ? r.sortOrder : T ? y.sortOrder ?? null : null;
      return this.pendingMoves.set(e, { placement: { parentFolderId: t, ...a ? { parentKind: a } : {}, sortOrder: $ }, token: l }), { ...M, parentFolderId: t, ...a ? { parentKind: a } : {}, sortOrder: $ };
    }));
    const p = (h) => {
      if (this.pendingMoves.get(e)?.token !== l) return h;
      this.pendingMoves.delete(e);
      const y = c;
      return !h.ok && y && f.set(te(this.scope.scopeKey), (C) => C.map((M) => {
        if (M.documentId !== e) return M;
        const { parentKind: T, ...$ } = M;
        return { ...$, ...y };
      })), h;
    };
    return this.send({
      type: "move-document",
      documentId: e,
      parentFolderId: t,
      ...r.parentKind ? { parentKind: r.parentKind } : {},
      ...r.sortOrder !== void 0 ? { sortOrder: r.sortOrder } : {},
      confirm: !0
    }).then(p);
  }
  /** `document` as the latest unanswered local move placed it, if there is one. */
  withPendingMove(e) {
    const t = this.pendingMoves.get(e.documentId);
    if (!t) return e;
    const { parentKind: r, ...o } = e;
    return { ...o, ...t.placement };
  }
  /**
   * Whether putting `movingId` under `parentId` closes a loop, walking up
   * through page parents and typed-page placements (ids never collide). An
   * unplaced typed page sits under its type, which the session cannot
   * resolve; the tree planner covers that case.
   */
  wouldCycle(e, t) {
    const r = [
      ...to(this.getAllDocuments()),
      ...this.getItemPlacements().map((o) => ({ folderId: o.itemId, parentFolderId: o.parentId ?? null }))
    ];
    return t !== null && zr(r, t, e);
  }
  async createFolder(e, t) {
    const r = crypto.randomUUID();
    if (this.isPageTree())
      return await this.registerDocument({ documentId: r, title: e, documentType: "markdown", parentFolderId: t }).catch((a) => this.reportCommandError(a, "Failed to create page")), r;
    const o = Date.now();
    return f.set(We(this.scope.scopeKey), (a) => [...a, {
      folderId: r,
      parentFolderId: t,
      name: e,
      sortOrder: o,
      createdBy: "",
      createdAt: o,
      updatedAt: o
    }]), await this.dataSource.command({
      type: "register-folder",
      folderId: r,
      name: e,
      parentFolderId: t,
      sortOrder: o
    }).catch((a) => this.reportCommandError(a, "Failed to create shared folder")), r;
  }
  async renameFolder(e, t) {
    if (this.isPageTree()) {
      await this.updateDocumentTitle(e, t);
      return;
    }
    f.set(We(this.scope.scopeKey), (r) => r.map((o) => o.folderId === e ? { ...o, name: t, updatedAt: Date.now() } : o)), await this.dataSource.command({ type: "rename-folder", folderId: e, name: t }).catch((r) => this.reportCommandError(r, "Failed to rename shared folder"));
  }
  async renameLegacyFolder(e, t) {
    const r = Xo(this.getAllDocuments(), e, t);
    for (const o of r) await this.updateDocumentTitle(o.documentId, o.newTitle);
    return r.length;
  }
  moveFolder(e, t) {
    if (this.isPageTree()) {
      this.movePage(e, t);
      return;
    }
    const r = this.getFolders();
    t && zr(r, t, e) || (f.set(We(this.scope.scopeKey), (o) => o.map((a) => a.folderId === e ? { ...a, parentFolderId: t, updatedAt: Date.now() } : a)), this.send({ type: "move-folder", folderId: e, parentFolderId: t }));
  }
  removeFolder(e) {
    if (this.isPageTree()) {
      this.removePage(e);
      return;
    }
    const t = new Set(mr(this.getFolders(), e));
    f.set(We(this.scope.scopeKey), (r) => r.filter((o) => !t.has(o.folderId))), f.set(te(this.scope.scopeKey), (r) => r.filter((o) => !(o.parentFolderId && t.has(o.parentFolderId)))), f.set(He(this.scope.scopeKey), (r) => r.filter((o) => !(o.parentFolderId && t.has(o.parentFolderId)))), this.send({ type: "remove-folder", folderId: e });
  }
  async refreshFolders() {
    return (this.dataSource.status() === "disconnected" || this.dataSource.status() === "error") && await this.dataSource.command({ type: "reconnect" }), (await this.dataSource.command({ type: "refresh-folders" })).folders !== null;
  }
  placeType(e, t, r) {
    const o = this.refusedWrite([r === "item" ? null : t]);
    return o || this.writeTypePlacement(e, t, Date.now(), r);
  }
  moveTypePlacement(e, t, r, o) {
    const a = this.refusedWrite([o === "item" ? null : t]);
    if (a) return a;
    const l = f.get(He(this.scope.scopeKey)).find((c) => c.typeId === e);
    return this.writeTypePlacement(e, t, r ?? l?.sortOrder ?? Date.now(), o);
  }
  async removeTypePlacement(e) {
    f.set(He(this.scope.scopeKey), (t) => t.filter((r) => r.typeId !== e)), await this.dataSource.command({ type: "remove-type-placement", typeId: e }).catch((t) => this.reportCommandError(t, "Failed to remove tracker type from the tree"));
  }
  isPageTree() {
    return f.get(hn(this.scope.scopeKey));
  }
  movePage(e, t, r = {}) {
    return this.wouldCycle(e, t) ? !1 : this.moveDocument(e, t, r);
  }
  pageRemovalCount(e) {
    return Ln(this.getAllDocuments(), f.get(He(this.scope.scopeKey)), e).childCount;
  }
  removePage(e) {
    const t = this.refusedWrite([e]);
    if (t) return t;
    const r = this.scope.scopeKey, o = Ln(this.getAllDocuments(), f.get(He(r)), e), a = o.relocate.map(({ documentId: h, parentId: y }) => this.moveDocument(h, y)), l = Date.now(), c = new Set(this.getAllDocuments().filter((h) => h.trashedAt != null).map((h) => h.documentId)), p = o.removedIds.filter((h) => !c.has(h)).map((h) => this.trashDocument(h, l));
    return ir([...a, ...p]);
  }
  setItemPlacement(e, t, r, o) {
    const a = this.refusedWrite([o === "item" ? null : t]);
    if (a) return a;
    if (this.wouldCycle(e, t))
      return Promise.resolve({ ok: !1, error: "cycle" });
    const l = Date.now(), c = this.getItemPlacements().find((y) => y.itemId === e), p = r ?? c?.sortOrder ?? l, h = {
      itemId: e,
      projectId: c?.projectId ?? this.scope.indexConfig.teamProjectId ?? null,
      parentId: t,
      ...o === "item" && t ? { parentKind: o } : {},
      sortOrder: p,
      createdBy: c?.createdBy ?? "",
      createdAt: c?.createdAt ?? l,
      updatedAt: l
    };
    return this.writeItemPlacement(e, h, {
      type: "set-item-placement",
      itemId: e,
      parentId: t,
      sortOrder: p,
      ...o ? { parentKind: o } : {}
    });
  }
  removeItemPlacement(e) {
    return this.writeItemPlacement(e, null, { type: "remove-item-placement", itemId: e });
  }
  /**
   * Optimistic write, settled by the data source: it resolves once the store
   * confirmed the change and rejects on a refusal or timeout. On a rejection
   * the previous row comes back, unless a later write already replaced ours.
   */
  async writeItemPlacement(e, t, r) {
    const o = pn(this.scope.scopeKey), a = f.get(o).find((c) => c.itemId === e) ?? null, l = (c) => (p) => [
      ...p.filter((h) => h.itemId !== e),
      ...c ? [c] : []
    ];
    f.set(o, l(t));
    try {
      return await this.dataSource.command(r), { ok: !0 };
    } catch (c) {
      return (f.get(o).find((h) => h.itemId === e) ?? null) === t && f.set(o, l(a)), { ok: !1, error: c instanceof Error ? c.message : String(c) };
    }
  }
  getItemPlacements() {
    return f.get(pn(this.scope.scopeKey));
  }
  /** Optimistic upsert; the server echoes the stored row back to its author. */
  async writeTypePlacement(e, t, r, o) {
    const a = Date.now(), l = this.getAllDocuments().find((h) => h.documentId === `${Zr}${e}`), c = o === "item" && t ? "item" : void 0, p = l && ((l.parentFolderId ?? null) !== t || l.parentKind !== c) ? [this.moveDocument(l.documentId, t, o ? { parentKind: o } : {})] : [];
    return f.set(He(this.scope.scopeKey), (h) => {
      const y = h.find((C) => C.typeId === e);
      return [...h.filter((C) => C.typeId !== e), {
        typeId: e,
        projectId: y?.projectId ?? this.scope.indexConfig.teamProjectId ?? null,
        parentFolderId: t,
        ...c ? { parentKind: c } : {},
        sortOrder: r,
        createdBy: y?.createdBy ?? "",
        createdAt: y?.createdAt ?? a,
        updatedAt: a
      }];
    }), ir([...p, this.settle(
      this.dataSource.command({
        type: "set-type-placement",
        typeId: e,
        parentFolderId: t,
        sortOrder: r,
        ...o ? { parentKind: o } : {},
        confirm: !0
      }),
      "Failed to place tracker type"
    )]);
  }
  toggleFavorite(e) {
    if (this.host.personalState.status === "unavailable") return;
    const t = this.host.personalState.capability, r = kt(this.scope.scopeKey), o = Kn(this.scope.scopeKey), a = f.get(r), l = f.get(o)[e] ?? 0, c = a.includes(e) ? a.filter((h) => h !== e) : [e, ...a], p = Date.now();
    f.set(r, c), f.set(o, { ...f.get(o), [e]: p }), t.setFavorite({
      scope: this.scope,
      itemId: e,
      isFavorite: c.includes(e),
      favoriteUpdatedAt: p
    }).then((h) => {
      h && this.applyPersonalStateRow(h);
    }).catch((h) => {
      f.get(o)[e] === p && (f.set(r, a), f.set(o, { ...f.get(o), [e]: l })), this.host.reportError?.(h, "Failed to save document favorite");
    });
  }
  recordOpened(e) {
    if (this.host.personalState.status === "unavailable") return;
    const t = this.host.personalState.capability, r = Ht(this.scope.scopeKey), o = f.get(r)[e] ?? null, a = Date.now();
    f.set(r, { ...f.get(r), [e]: a }), t.recordOpened({
      scope: this.scope,
      itemId: e,
      lastOpenedAt: a
    }).then((l) => {
      l && this.applyPersonalStateRow(l);
    }).catch((l) => {
      const c = f.get(r);
      if (c[e] !== a) return;
      const p = { ...c };
      o === null ? delete p[e] : p[e] = o, f.set(r, p), this.host.reportError?.(l, "Failed to record document open");
    });
  }
  async markDocumentViewed(e, t) {
    if (this.host.documents.readReceipts.status === "unavailable") return;
    const r = Math.max(Date.now(), t ?? 0);
    await this.host.documents.readReceipts.capability.markViewed({
      scope: this.scope,
      documentId: e,
      lastViewedAt: r
    }), f.set(po, {
      documentId: e,
      orgId: this.scope.orgId,
      scopeKey: this.scope.scopeKey,
      receipt: { lastSeenVersion: null, lastViewedAt: r }
    });
  }
  async markAllDocumentsViewed() {
    if (this.host.documents.readReceipts.status === "unavailable") return;
    const e = wr(this.getDocuments(), (t) => {
      const r = f.get(tt(this.scope.scopeKey)).get(t.documentId) ?? null;
      return {
        unread: Bn(
          Vn(t),
          r,
          this.scope.indexConfig.teamMemberId ?? null
        ),
        hasReceipt: r !== null
      };
    });
    await Promise.all(e.map(({ doc: t }) => this.markDocumentViewed(t.documentId, t.updatedAt ?? null)));
  }
  createDocument(e) {
    return this.host.documents.createDocument(e);
  }
  clearPendingFolder() {
    f.set(lo, null);
  }
  getDocuments() {
    return this.getAllDocuments().filter((e) => e.trashedAt == null);
  }
  searchPages(e) {
    return Ta(this.dataSource, this.getDocuments(), e);
  }
  getFolders() {
    return f.get(gn(this.scope.scopeKey));
  }
  getAllDocuments() {
    return f.get(te(this.scope.scopeKey));
  }
  async startInternal() {
    if (this.disposed) throw new Error("Collab docs session has been disposed");
    ro(this.scope) || f.set(Nt(this.scope.scopeKey), !0), f.set(Ir(this.scope.scopeKey), this.scope.orgId), f.set(Un(this.scope.scopeKey), this.scope.indexConfig.teamMemberId ?? null), this.dataUnsubscribe = this.dataSource.subscribe((a) => this.applyDataChange(a));
    const e = this.host.documents.readReceipts.status === "available" ? this.host.documents.readReceipts.capability : null, [t, r, , o] = await Promise.all([
      this.dataSource.snapshot(),
      this.host.documents.loadViewPreferences(this.scope.scopeKey),
      this.hydratePersonalState(),
      e?.snapshot(this.scope) ?? Promise.resolve([])
    ]);
    this.disposed || (this.applyDataChange({ type: "snapshot", snapshot: t }), this.hydrateViewPreferences(r), this.applyReceiptSnapshot(o), this.receiptUnsubscribe = e?.subscribe?.(
      this.scope,
      (a) => this.applyReceiptRow(a)
    ) ?? null);
  }
  applyDataChange(e) {
    const t = this.scope.scopeKey;
    switch (e.type) {
      case "snapshot": {
        e.snapshot.primaryProjectId !== void 0 && e.snapshot.primaryProjectId !== f.get(un(t)) && (f.set(un(t), e.snapshot.primaryProjectId), this.resplitStoredDocuments());
        const [r, o] = this.splitByProject(e.snapshot.items), a = new Set(r.map((c) => c.documentId)), l = new Set(o.map((c) => c.documentId));
        f.set(te(t), (c) => Wr(
          c.filter((p) => !l.has(p.documentId)),
          r.map((p) => this.withPendingMove(p))
        )), f.set(et(t), (c) => Wr(
          c.filter((p) => !a.has(p.documentId)),
          o
        )), f.set(We(t), (c) => za(c, e.snapshot.containers)), e.snapshot.typePlacements && f.set(He(t), e.snapshot.typePlacements), e.snapshot.itemPlacements && f.set(pn(t), e.snapshot.itemPlacements), e.snapshot.pageTree && f.set(hn(t), !0), f.set(On(t), e.snapshot.pageFields === !0), e.snapshot.indexLoaded && (this.indexAttemptOpen = !1, this.failedIndexAttempts = 0, f.set(mn(t), null), f.set(Wt(t), !0)), this.isPageTree() || this.migrateVirtualFolders();
        break;
      }
      case "items-upserted": {
        const [r, o] = this.splitByProject(e.items);
        f.set(te(t), (a) => {
          let l = Vr(a, o);
          for (const c of r) {
            const p = l.find((y) => y.documentId === c.documentId);
            l = [this.withPendingMove(p ? br(p, c) : c), ...l.filter((y) => y.documentId !== c.documentId)];
          }
          return l;
        }), f.set(et(t), (a) => {
          let l = Vr(a, r);
          for (const c of o) {
            const p = l.find((y) => y.documentId === c.documentId);
            l = [p ? br(p, c) : c, ...l.filter((y) => y.documentId !== c.documentId)];
          }
          return l;
        });
        break;
      }
      case "items-removed": {
        const r = new Set(e.itemIds);
        f.set(te(t), (o) => o.filter((a) => !r.has(a.documentId))), f.set(et(t), (o) => o.filter((a) => !r.has(a.documentId)));
        break;
      }
      case "containers-upserted":
        f.set(We(t), (r) => {
          let o = r;
          for (const a of e.containers) {
            const l = o.find((p) => p.folderId === a.folderId), c = l ? mo(l, a) : a;
            o = [...o.filter((p) => p.folderId !== a.folderId), c];
          }
          return o;
        });
        break;
      case "containers-removed": {
        const r = new Set(e.containerIds), o = new Set(e.itemIds);
        f.set(We(t), (a) => a.filter((l) => !r.has(l.folderId))), f.set(te(t), (a) => a.filter((l) => !o.has(l.documentId))), f.set(et(t), (a) => a.filter((l) => !o.has(l.documentId)));
        break;
      }
      case "status":
        f.set(St(t), e.status), this.observeIndexTransport(e.status);
    }
    this.recomputeUnread();
  }
  observeIndexTransport(e) {
    const t = this.scope.scopeKey;
    if (e === "connecting" || e === "syncing") {
      this.indexAttemptOpen = !0;
      return;
    }
    e !== "connected" && (f.set(Wt(t), !1), this.indexAttemptOpen && (this.indexAttemptOpen = !1, this.failedIndexAttempts += 1, this.failedIndexAttempts >= Aa && f.set(mn(t), "Your team's page index could not be reached.")));
  }
  /**
   * This scope's project's documents, then every other project's. A document
   * with no project belongs to the primary; with no project known for the
   * scope, nothing is split off (an older server, or before the first snapshot).
   */
  splitByProject(e) {
    const t = f.get(un(this.scope.scopeKey)), r = this.scope.indexConfig.teamProjectId ?? t;
    if (!r) return [e, []];
    const o = [], a = [];
    for (const l of e) {
      const c = l.teamProjectId ?? t;
      (c === null || c === r ? o : a).push(l);
    }
    return [o, a];
  }
  resplitStoredDocuments() {
    const e = this.scope.scopeKey, [t, r] = this.splitByProject([
      ...f.get(te(e)),
      ...f.get(et(e))
    ]);
    f.set(te(e), t), f.set(et(e), r);
  }
  /** Another project's page, when `documentId` names one and not one of this project's. */
  otherProjectPage(e) {
    return !e || this.getAllDocuments().some((t) => t.documentId === e) ? null : f.get(et(this.scope.scopeKey)).find((t) => t.documentId === e) ?? null;
  }
  /**
   * The refusal for a write that targets, or puts something under, another
   * project's page. The window holds those pages only to name them in links;
   * every write goes to the scope's own project. Null when the write may go.
   */
  otherProjectRefusal(e) {
    for (const t of e) {
      const r = this.otherProjectPage(t);
      if (r) return `"${r.title || r.documentId}" is a page in another project; changes stay in the current project.`;
    }
    return null;
  }
  refusedWrite(e) {
    const t = this.otherProjectRefusal(e);
    return t ? Promise.resolve({ ok: !1, error: t }) : null;
  }
  applyPersonalStateRow(e) {
    if (f.get(hr(this.scope.scopeKey)) !== e.scope) return;
    const t = kt(this.scope.scopeKey), r = Kn(this.scope.scopeKey), o = f.get(r);
    if (e.favoriteUpdatedAt >= (o[e.itemId] ?? 0)) {
      const a = f.get(t);
      f.set(t, e.isFavorite ? [e.itemId, ...a.filter((l) => l !== e.itemId)] : a.filter((l) => l !== e.itemId)), f.set(r, {
        ...o,
        [e.itemId]: e.favoriteUpdatedAt
      });
    }
    if (e.lastOpenedAt != null) {
      const a = Ht(this.scope.scopeKey), l = f.get(a);
      e.lastOpenedAt >= (l[e.itemId] ?? 0) && f.set(a, { ...l, [e.itemId]: e.lastOpenedAt });
    }
  }
  applyReceiptSnapshot(e) {
    const t = tt(this.scope.scopeKey), r = new Map(f.get(t));
    for (const o of e)
      r.set(o.entityId, fn(r.get(o.entityId), o));
    f.set(t, r), this.recomputeUnread();
  }
  applyReceiptRow(e) {
    const t = tt(this.scope.scopeKey), r = new Map(f.get(t));
    r.set(e.entityId, fn(r.get(e.entityId), e)), f.set(t, r), this.recomputeUnread();
  }
  recomputeUnread() {
    this.uiCapabilities.readReceipts && f.set(La, {
      orgId: this.scope.orgId,
      scopeKey: this.scope.scopeKey,
      docs: this.getDocuments(),
      receipts: f.get(tt(this.scope.scopeKey)),
      currentUserId: this.scope.indexConfig.teamMemberId ?? null
    });
  }
  /** Send a write; the outcome resolves once the data source answered, and a failure is also reported. */
  send(e) {
    return this.settle(this.dataSource.command(e), `Failed to ${e.type}`);
  }
  settle(e, t) {
    return e.then(
      () => ({ ok: !0 }),
      (r) => (this.reportCommandError(r, t), { ok: !1, error: r instanceof Error ? r.message : String(r) })
    );
  }
  reportCommandError(e, t) {
    this.host.reportError?.(e, t);
  }
  async migrateVirtualFolders() {
    if (this.migratedFolders) return;
    const { folderPaths: e, docParent: t } = Ba(this.getAllDocuments());
    if (e.length === 0) return;
    this.migratedFolders = !0;
    const r = /* @__PURE__ */ new Map();
    for (const a of e) r.set(a, await ja(this.scope.orgId, a));
    const o = Ua(
      e,
      r,
      this.scope.indexConfig.teamMemberId ?? "",
      Date.now()
    );
    f.set(We(this.scope.scopeKey), (a) => {
      const l = new Map(a.map((c) => [c.folderId, c]));
      for (const c of o) l.set(c.folderId, c);
      return [...l.values()];
    });
    for (const a of o)
      await this.dataSource.command({
        type: "register-folder",
        folderId: a.folderId,
        name: a.name,
        parentFolderId: a.parentFolderId ?? null,
        sortOrder: a.sortOrder
      }).catch((l) => this.reportCommandError(l, "Failed to migrate shared folder"));
    f.set(te(this.scope.scopeKey), (a) => a.map((l) => {
      const c = t.get(l.documentId), p = c ? r.get(c) : null;
      return p ? { ...l, parentFolderId: p } : l;
    }));
    for (const [a, l] of t) {
      const c = r.get(l);
      c && this.send({ type: "move-document", documentId: a, parentFolderId: c });
    }
  }
}
function Wa(n, e, t) {
  const r = Ge.get(n.scopeKey);
  if (r) return r;
  const o = new Va(n, e, t);
  return Ge.set(n.scopeKey, o), o;
}
const Ha = [3e3, 6e3, 12e3, 24e3, 3e4];
function wi(n, e) {
  const t = e.retryDelaysMs ?? Ha;
  let r = null, o = null, a = null, l = 0, c = !1, p = !1;
  const h = () => {
    a && clearTimeout(a), a = null;
  }, y = () => {
    const T = r;
    r = null, T && f.get(le)?.scopeKey === T.scope.scopeKey && f.set(le, null), T?.dispose(), e.onSessionChanged(null);
  }, C = (T) => {
    h(), r?.scope !== T && (r && y(), r = Wa(T, n.documents.dataSource, n)), r.activate(), e.onSessionChanged(r), r.start().catch(($) => e.onError?.($));
  }, M = async (T, $) => {
    try {
      const oe = await n.resolveScope();
      if (p || $ !== l) return;
      C(oe);
    } catch (oe) {
      if (p || $ !== l) return;
      const Ne = !(oe instanceof ta) || oe.retryable, ne = t[T];
      Ne && ne !== void 0 ? a = setTimeout(() => {
        a = null, M(T + 1, $);
      }, ne) : e.onError?.(oe);
    }
  };
  return {
    start() {
      c || p || (c = !0, o = n.onScopeChanged((T) => {
        p || (l += 1, h(), T ? C(T) : (y(), M(0, l)));
      }), M(0, l));
    },
    dispose() {
      p || (p = !0, l += 1, h(), o?.(), o = null, y());
    }
  };
}
function Ii(n) {
  return Ge.get(n) ?? null;
}
function Si(n) {
  return f.get(te(n)).filter((e) => e.trashedAt == null);
}
function ki(n) {
  return f.get(kr(n));
}
function Ci(n, e) {
  if (f.get(te(n)).some((r) => r.documentId === e)) return null;
  const t = f.get(et(n)).find((r) => r.documentId === e);
  return t ? { document: t, projectId: t.teamProjectId ?? f.get(un(n)) } : null;
}
function Ni(n) {
  return f.get(gn(n));
}
function Ti(n) {
  return f.get(kt(n));
}
const Di = (n) => Wt(n), Pi = (n) => mn(n);
function Ai(n) {
  return f.get(Wt(n));
}
function Fi(n, e) {
  f.set(Nt(n), e);
}
function _i(n) {
  Ge.get(n)?.dispose(), f.get(le)?.scopeKey === n && f.set(le, null);
  const t = Ct.get(n) ?? /* @__PURE__ */ new Set();
  Ct.delete(n);
  for (const r of t)
    Pt.remove(Ft(n, r)), [...Ct.values()].some((a) => a.has(r)) || Ma.remove(r);
  te.remove(n), et.remove(n), un.remove(n), kr.remove(n), We.remove(n), gn.remove(n), He.remove(n), pn.remove(n), hn.remove(n), On.remove(n), St.remove(n), Wt.remove(n), mn.remove(n), Nt.remove(n), Ir.remove(n), Un.remove(n), kt.remove(n), Kn.remove(n), Ht.remove(n), Tt.remove(n), Dt.remove(n), hr.remove(n), tt.remove(n);
}
function Ga(n, e, t) {
  const r = /* @__PURE__ */ new Set();
  if (e && r.add(e), t) {
    const o = t.toLowerCase();
    for (const [a, l] of n)
      l.email && l.email.toLowerCase() === o && r.add(a);
  }
  return r;
}
const Ya = "virtual://shared-home", Ei = "Shared Home";
function Ki(n) {
  return n === Ya;
}
function Hr(n, e) {
  const t = `${n ?? ""} ${e ?? ""}`.toLowerCase(), r = [
    [/diagram|excalidraw|drawing/, "#2dd4bf"],
    // teal
    [/mockup|wireframe/, "#f5a623"],
    // amber
    [/tracker|issue|bug|task/, "#a855f7"],
    // purple
    [/spreadsheet|sheet|revogrid|csv/, "#22c55e"],
    // green
    [/mind ?map/, "#ec4899"],
    // pink
    [/data ?model|prisma|schema|erd/, "#06b6d4"],
    // cyan
    [/upload|attachment|file/, "#8a94a6"],
    // gray
    [/text|code/, "#8a94a6"],
    // gray
    [/document|markdown|doc\b|note/, "#4a9eff"]
    // blue
  ];
  for (const [l, c] of r)
    if (l.test(t)) return c;
  let o = 0;
  for (let l = 0; l < t.length; l++)
    o = (o << 5) - o + t.charCodeAt(l), o |= 0;
  return `hsl(${Math.abs(o) % 360} 60% 60%)`;
}
const Mi = () => import("./collabPageTree-DUvCpMMn.js"), Gr = "lock";
function yn(n) {
  const e = n?.trim().toLowerCase();
  if (e)
    return e.startsWith(".") ? e : `.${e}`;
}
function Xa(n, e, t) {
  const r = n.replace(/\\/g, "/").split("/").at(-1)?.toLowerCase() ?? "", o = t.filter((c) => c.documentType === e).flatMap((c) => c.fileExtensions).map(yn).filter((c) => c !== void 0).sort((c, p) => p.length - c.length || c.localeCompare(p)).find((c) => r.endsWith(c));
  if (o) return o;
  const a = yn(e);
  if (a && r.endsWith(a)) return a;
  const l = r.lastIndexOf(".");
  return l > 0 ? r.slice(l) : void 0;
}
function ho(n) {
  return n.editor.kind === "lexical" ? "builtin.lexical" : n.editor.kind === "monaco" ? "builtin.monaco" : n.editor.extensionId ?? "unavailable";
}
function yo(n, e) {
  const t = n.metadataVersion === 2 ? "v2" : "legacy-inferred", r = yn(n.fileExtension) ?? Xa(n.title, n.documentType, e), o = e.find((a) => a.documentType === n.documentType && (!r || a.fileExtensions.some(
    (l) => yn(l) === r
  )));
  return {
    metadataVersion: 2,
    fileExtension: r,
    editorId: n.editorId?.trim() || (o ? ho(o) : void 0),
    source: t
  };
}
function Qa(n, e) {
  const t = n.title.replace(/\\/g, "/").split("/").at(-1) ?? "", r = yo(n, e).fileExtension ?? "";
  return { baseName: r && t.toLowerCase().endsWith(r.toLowerCase()) ? t.slice(0, -r.length) : t, suffix: r };
}
function Ja(n, e) {
  const t = n.trim();
  return e ? `${t.toLowerCase().endsWith(e.toLowerCase()) ? t.slice(0, -e.length) : t}${e}` : t;
}
function Cr(n, e) {
  const t = yo(n, e);
  if (n.decryptFailed)
    return {
      state: "unsupported",
      icon: Gr,
      typeLabel: "Locked document",
      metadata: t,
      reason: "The shared document metadata is locked and cannot be resolved."
    };
  const r = e.find((o) => o.documentType !== n.documentType || t.editorId && ho(o) !== t.editorId ? !1 : !t.fileExtension || o.fileExtensions.some(
    (a) => yn(a) === t.fileExtension
  ));
  return r && !r.capabilities.disabledReason ? {
    state: "ready",
    icon: r.icon,
    typeLabel: r.displayName,
    metadata: t,
    descriptor: r
  } : {
    state: "unsupported",
    icon: Gr,
    typeLabel: r?.displayName ?? "Unsupported document",
    metadata: t,
    descriptor: r,
    reason: r?.capabilities.disabledReason ?? "No host document type can open this shared document."
  };
}
function qa(n, e) {
  const t = [], r = (o, a) => {
    for (const l of o) {
      const c = "children" in l ? l.children ?? [] : [], p = { key: l.id, depth: a.length, ancestorKeys: a, hasChildren: c.length > 0 };
      if (l.type === "document") {
        const h = p.hasChildren && l.document.hasContent === !1;
        t.push({
          ...p,
          parentId: l.document.documentId,
          parentKind: "page",
          name: Ut(l.name, l.document.documentType),
          icon: h ? "folder" : Cr(l.document, e).icon,
          ...h ? { expandedIcon: "folder_open" } : {},
          selectable: l.document.decryptFailed !== !0
        });
      } else l.type === "item" ? t.push({
        ...p,
        parentId: l.itemId,
        parentKind: "item",
        name: l.name,
        icon: "description",
        ...l.typeLabel ? { hint: l.typeLabel } : {},
        selectable: !0
      }) : l.type === "type" ? t.push({
        ...p,
        parentId: null,
        parentKind: "page",
        name: l.name,
        icon: "table",
        ...l.count > 0 ? { hint: String(l.count) } : {},
        selectable: !1
      }) : t.push({
        ...p,
        parentId: l.folderId ?? null,
        parentKind: "page",
        name: l.name,
        icon: "folder",
        expandedIcon: "folder_open",
        selectable: !!l.folderId
      });
      r(c, [...a, l.id]);
    }
  };
  return r(n, []), t;
}
const Za = [];
function es(n) {
  const e = Qo(n).filter((r) => r.folderId !== null), t = [];
  return e.map((r, o) => {
    t.length = r.depth;
    const a = t.slice();
    return t[r.depth] = r.folderId, {
      key: r.folderId,
      parentId: r.folderId,
      parentKind: "page",
      name: r.name,
      depth: r.depth,
      icon: "folder",
      expandedIcon: "folder_open",
      selectable: !0,
      ancestorKeys: a,
      hasChildren: (e[o + 1]?.depth ?? -1) > r.depth
    };
  });
}
function Yr({
  isOpen: n,
  kind: e,
  documentDescriptor: t,
  folders: r,
  tree: o,
  documentTypeDescriptors: a = Za,
  rootLabel: l = "Team root",
  targetFolderId: c,
  targetParentKind: p = "page",
  onTargetFolderChange: h,
  onConfirm: y,
  onCancel: C
}) {
  const [M, T] = R(""), [$, oe] = R(/* @__PURE__ */ new Set()), Ne = jt(null), ne = jt(!1), A = L(() => n ? o ? qa(o, a) : es(r) : [], [a, r, n, o]), g = c === null ? null : A.find((D) => D.selectable && D.parentId === c && (!o || D.parentKind === p)) ?? null, S = g?.key ?? null, O = !o || o.length > 0, E = t?.displayName ?? "Document", z = t?.defaultExtension ?? "", K = e === "folder" ? "New Shared Folder" : `New Shared ${E}`, q = e === "folder" ? "folder" : "document", ut = e === "folder" ? "Folder name" : `Untitled ${E}`, Z = e === "folder" ? "create_new_folder" : t?.icon ?? "note_add", nt = `collab-create-${e}-title`, ge = `collab-create-${e}-name`, pt = `collab-create-${e}-location-label`;
  if (ye(() => {
    if (!n) {
      ne.current = !1;
      return;
    }
    if (ne.current) return;
    ne.current = !0, T("");
    const D = new Set(g?.ancestorKeys ?? []);
    g && D.add(g.key), oe(D), Ne.current?.focus();
  }, [n, g]), ye(() => {
    n && O && c !== null && !g && h(null, "page");
  }, [n, h, O, g, c]), !n) return null;
  const Te = (D) => {
    oe((X) => {
      const Se = new Set(X);
      return Se.has(D) ? Se.delete(D) : Se.add(D), Se;
    });
  }, Ye = new Map(A.map((D) => [D.key, D.name])), Me = A.filter((D) => D.ancestorKeys.every((X) => $.has(X))), Xe = g ? `${[...g.ancestorKeys, g.key].map((D) => Ye.get(D)).filter(Boolean).join(" / ")} /` : `${l} /`, Ue = (D) => {
    D.selectable ? h(D.parentId, D.parentKind) : D.hasChildren && Te(D.key);
  }, De = (D, X, Se, ie, Pe, at) => {
    const { option: ee, isExpanded: Qe = !1, onSelect: je } = at, W = ee ? !ee.selectable : !1;
    return /* @__PURE__ */ b(
      "div",
      {
        role: "treeitem",
        "aria-selected": ie,
        "aria-disabled": W || void 0,
        "aria-expanded": ee?.hasChildren ? Qe : void 0,
        tabIndex: 0,
        className: `collab-create-location-option relative flex items-center gap-1 px-2 py-1.5 rounded text-[13px] select-none ${W ? "cursor-default" : "cursor-pointer"} ${ie ? "bg-[var(--nim-primary)]/20 text-[var(--nim-text)]" : W ? "text-[var(--nim-text-faint)]" : "text-[var(--nim-text)] hover:bg-[var(--nim-bg-tertiary)]"}`,
        style: { paddingLeft: Se },
        "data-testid": `collab-create-location-option-${D}`,
        onClick: je,
        onDoubleClick: () => {
          ee?.hasChildren && Te(ee.key);
        },
        onKeyDown: (ce) => {
          (ce.key === "Enter" || ce.key === " ") && (ce.preventDefault(), je());
        },
        children: [
          ie && /* @__PURE__ */ s("span", { "aria-hidden": !0, className: "absolute left-0 top-1 bottom-1 w-0.5 rounded bg-[var(--nim-primary)]" }),
          ee && /* @__PURE__ */ s(
            "button",
            {
              type: "button",
              className: `w-4 h-4 inline-flex items-center justify-center text-[var(--nim-text-faint)] ${ee.hasChildren ? "cursor-pointer" : "cursor-default invisible"}`,
              "aria-label": Qe ? "Collapse" : "Expand",
              onClick: (ce) => {
                ce.stopPropagation(), ee.hasChildren && Te(ee.key);
              },
              children: /* @__PURE__ */ s(k, { icon: Qe ? "expand_more" : "chevron_right", size: 16 })
            }
          ),
          /* @__PURE__ */ s("span", { className: `inline-flex items-center justify-center ${ie ? "text-[var(--nim-primary)]" : "text-[var(--nim-text-muted)]"}`, children: Pe }),
          /* @__PURE__ */ s("span", { className: "flex-1 truncate", children: X }),
          ee?.hint ? /* @__PURE__ */ s("span", { className: "shrink-0 text-[11px] text-[var(--nim-text-faint)]", children: ee.hint }) : null
        ]
      },
      D
    );
  };
  return /* @__PURE__ */ s(
    "div",
    {
      className: "collab-create-dialog-overlay fixed inset-0 z-[10000] flex items-center justify-center bg-black/60",
      onClick: (D) => {
        D.target === D.currentTarget && C();
      },
      children: /* @__PURE__ */ b(
        "div",
        {
          className: "collab-create-dialog w-[460px] max-w-[92%] bg-[var(--nim-bg)] border border-[var(--nim-border)] rounded-xl shadow-2xl overflow-hidden",
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": nt,
          "data-testid": "collab-create-dialog",
          "data-component": "CollabCreateItemDialog",
          onClick: (D) => D.stopPropagation(),
          onKeyDown: (D) => {
            D.key === "Escape" && C();
          },
          children: [
            /* @__PURE__ */ b("div", { className: "collab-create-dialog-header flex items-start gap-3 px-5 pt-4 pb-3 border-b border-[var(--nim-border)]", children: [
              /* @__PURE__ */ s("div", { className: "w-7 h-7 rounded-md bg-[var(--nim-primary)]/15 text-[var(--nim-primary)] flex items-center justify-center shrink-0 mt-0.5", children: /* @__PURE__ */ s(k, { icon: Z, size: 18 }) }),
              /* @__PURE__ */ b("div", { className: "flex-1 min-w-0", children: [
                /* @__PURE__ */ s("h2", { id: nt, className: "text-[14px] font-semibold text-[var(--nim-text)] m-0 leading-tight", children: K }),
                /* @__PURE__ */ b("p", { className: "text-[12px] text-[var(--nim-text-faint)] m-0 mt-0.5 leading-snug", children: [
                  "Pick where this ",
                  q,
                  " should live in your team space."
                ] })
              ] }),
              /* @__PURE__ */ s(
                "button",
                {
                  type: "button",
                  onClick: C,
                  className: "text-[var(--nim-text-faint)] hover:text-[var(--nim-text)] hover:bg-[var(--nim-bg-tertiary)] w-6 h-6 rounded inline-flex items-center justify-center",
                  "aria-label": "Close",
                  children: /* @__PURE__ */ s(k, { icon: "close", size: 16 })
                }
              )
            ] }),
            /* @__PURE__ */ b("form", { onSubmit: (D) => {
              D.preventDefault();
              const X = M.trim();
              X && y(X);
            }, children: [
              /* @__PURE__ */ b("div", { className: "collab-create-dialog-body px-5 pt-3 pb-2", children: [
                /* @__PURE__ */ s(
                  "label",
                  {
                    id: `${ge}-label`,
                    htmlFor: ge,
                    className: "block text-[11px] uppercase tracking-wider font-semibold text-[var(--nim-text-faint)] mb-1.5",
                    children: e === "folder" ? "Folder name" : `${E} name`
                  }
                ),
                /* @__PURE__ */ b("div", { className: "flex items-center gap-1.5 px-2 bg-[var(--nim-bg-secondary)] border border-[var(--nim-border-subtle,var(--nim-border))] rounded-md mb-4 focus-within:border-[var(--nim-primary)]", children: [
                  /* @__PURE__ */ s(k, { icon: "edit", size: 14, className: "text-[var(--nim-text-faint)]" }),
                  /* @__PURE__ */ s(
                    "input",
                    {
                      ref: Ne,
                      id: ge,
                      type: "text",
                      className: "collab-create-name-input flex-1 bg-transparent border-none text-[var(--nim-text)] text-[13px] py-2 outline-none font-inherit",
                      placeholder: ut,
                      value: M,
                      "data-testid": "collab-create-name-input",
                      onChange: (D) => {
                        const X = D.target.value;
                        e === "document" && z && X.toLowerCase().endsWith(z.toLowerCase()) ? T(X.slice(0, -z.length)) : T(X);
                      }
                    }
                  ),
                  e === "document" && z && /* @__PURE__ */ s("span", { className: "collab-create-name-suffix text-[12px] text-[var(--nim-text-muted)] pr-1 shrink-0", children: z })
                ] }),
                /* @__PURE__ */ s(
                  "div",
                  {
                    id: pt,
                    className: "text-[11px] uppercase tracking-wider font-semibold text-[var(--nim-text-faint)] mb-1.5",
                    children: o ? "Location" : "Destination folder"
                  }
                ),
                /* @__PURE__ */ b(
                  "div",
                  {
                    className: "collab-create-location-picker collab-create-location-options nim-scrollbar bg-[var(--nim-bg-secondary)] border border-[var(--nim-border-subtle,var(--nim-border))] rounded-md p-1 mb-3 max-h-[240px] overflow-y-auto",
                    "data-testid": "collab-create-location-picker",
                    role: "tree",
                    "aria-labelledby": pt,
                    children: [
                      De("root", l, 8, S === null, /* @__PURE__ */ s(k, { icon: "workspaces", size: 18 }), {
                        onSelect: () => h(null, "page")
                      }),
                      Me.map((D) => {
                        const X = $.has(D.key);
                        return De(
                          D.key,
                          D.name,
                          8 + D.depth * 18,
                          D.key === S,
                          /* @__PURE__ */ s(k, { icon: X && D.expandedIcon ? D.expandedIcon : D.icon, size: 18 }),
                          { option: D, isExpanded: X, onSelect: () => Ue(D) }
                        );
                      })
                    ]
                  }
                ),
                /* @__PURE__ */ b("div", { className: "collab-create-destination-preview flex items-center gap-2 px-3 py-2 bg-[var(--nim-bg-secondary)] border border-[var(--nim-border-subtle,var(--nim-border))] rounded-md mb-3 text-[12px] text-[var(--nim-text-muted)]", children: [
                  /* @__PURE__ */ s(k, { icon: "place", size: 14, className: "text-[var(--nim-text-faint)]" }),
                  /* @__PURE__ */ s("span", { children: "Will be created as" }),
                  /* @__PURE__ */ s("span", { className: "text-[var(--nim-text)] font-medium truncate", title: Xe, children: Xe }),
                  /* @__PURE__ */ b(
                    "span",
                    {
                      className: "text-[var(--nim-primary)] truncate",
                      title: `${M || ut}${e === "document" ? z : ""}`,
                      children: [
                        M || ut,
                        e === "document" ? z : ""
                      ]
                    }
                  )
                ] })
              ] }),
              /* @__PURE__ */ b("div", { className: "collab-create-dialog-footer flex justify-end gap-2 px-5 py-3 border-t border-[var(--nim-border)]", children: [
                /* @__PURE__ */ s(
                  "button",
                  {
                    type: "button",
                    onClick: C,
                    className: "collab-create-cancel px-3 py-1.5 bg-transparent rounded-md text-[var(--nim-text-muted)] text-[13px] hover:bg-[var(--nim-bg-tertiary)] hover:text-[var(--nim-text)]",
                    children: "Cancel"
                  }
                ),
                /* @__PURE__ */ b(
                  "button",
                  {
                    type: "submit",
                    className: `collab-create-confirm px-3.5 py-1.5 rounded-md text-[13px] font-medium inline-flex items-center gap-1.5 ${M.trim() ? "bg-[var(--nim-primary)] text-[#0f1115] hover:bg-[var(--nim-primary-hover)] hover:text-white cursor-pointer" : "bg-[var(--nim-primary)] text-[#0f1115] opacity-50 cursor-not-allowed"}`,
                    disabled: !M.trim(),
                    children: [
                      /* @__PURE__ */ s(k, { icon: Z, size: 16 }),
                      "Create ",
                      e === "folder" ? "Folder" : E
                    ]
                  }
                )
              ] })
            ] })
          ]
        }
      )
    }
  );
}
const Gt = Go(null), ts = {};
function Ri({
  session: n,
  controller: e,
  children: t
}) {
  const r = L(() => ({
    scope: n.scope,
    host: n.host,
    session: n,
    controller: e ?? ts
  }), [n, e]);
  return /* @__PURE__ */ s(na, { store: f, children: /* @__PURE__ */ s(Gt.Provider, { value: r, children: t }) });
}
function Wn() {
  const n = bn(Gt);
  if (!n)
    throw new Error("Wiki UI must be rendered inside CollabDocsUIProvider");
  return n;
}
const bo = w([]), go = w([]);
function Li() {
  const n = bn(Gt), e = j(n?.session.atoms.allSharedDocuments ?? bo);
  return L(
    () => new Map(e.map((t) => [
      t.documentId,
      no(t.title, t.documentId)
    ])),
    [e]
  );
}
function Oi() {
  const n = bn(Gt);
  return j(n?.session.atoms.sharedFolders ?? go);
}
function $i(n, e) {
  const t = bn(Gt), r = j(t?.session.atoms.allSharedDocuments ?? bo), o = j(t?.session.atoms.sharedFolders ?? go);
  return L(() => {
    const a = n ? r.find((y) => y.documentId === n) ?? null : null, l = new Map(o.map((y) => [y.folderId, y])), c = [], p = /* @__PURE__ */ new Set();
    let h = a?.parentFolderId ?? e ?? null;
    for (; h && !p.has(h); ) {
      p.add(h);
      const y = l.get(h);
      if (!y) break;
      c.unshift({
        folderId: y.folderId,
        name: y.decryptFailed ? "Locked folder" : y.name
      }), h = y.parentFolderId ?? null;
    }
    return {
      documentTitle: a ? no(a.title, a.documentId) : null,
      folders: c
    };
  }, [n, r, e, o]);
}
const ns = w([]), rs = w([]), os = w([]), as = w(!1), ss = w("disconnected");
function zi() {
  const n = bn(Gt)?.session.atoms;
  return {
    documents: j(n?.allSharedDocuments ?? ns),
    typePlacements: j(n?.typePlacements ?? rs),
    itemPlacements: j(n?.itemPlacements ?? os),
    pageTree: j(n?.pageTree ?? as),
    syncStatus: j(n?.syncStatus ?? ss)
  };
}
function is(n) {
  return n.filter(
    (e) => e.capabilities.localCreate && e.capabilities.sharedCreate && e.creation !== void 0
  ).map((e) => ({ descriptor: e })).sort((e, t) => {
    const r = e.descriptor.documentType === "markdown" ? 0 : 1, o = t.descriptor.documentType === "markdown" ? 0 : 1;
    return r - o || e.descriptor.displayName.localeCompare(t.descriptor.displayName) || e.descriptor.defaultExtension.localeCompare(t.descriptor.defaultExtension);
  });
}
function ls({ items: n, onSelect: e }) {
  return /* @__PURE__ */ s("div", { className: "collab-new-document-menu min-w-[260px] max-w-[340px] rounded-md z-[10000] text-[13px] p-1 bg-nim-secondary border border-nim text-nim backdrop-blur-[10px] shadow-lg overflow-y-auto", children: n.map(({ descriptor: t }) => /* @__PURE__ */ b(
    "button",
    {
      type: "button",
      role: "menuitem",
      className: "collab-new-document-menu-item w-full flex items-start gap-2.5 px-3 py-2 rounded border-none bg-transparent transition-colors text-left text-nim hover:bg-nim-hover",
      onClick: () => e(t),
      children: [
        /* @__PURE__ */ s(k, { icon: t.icon, size: 18, className: "shrink-0 mt-0.5" }),
        /* @__PURE__ */ s("span", { className: "min-w-0 flex-1", children: /* @__PURE__ */ b("span", { className: "flex items-baseline justify-between gap-3", children: [
          /* @__PURE__ */ s("span", { className: "font-medium truncate", children: t.displayName }),
          /* @__PURE__ */ s("span", { className: "text-[11px] text-nim-faint shrink-0", children: t.defaultExtension })
        ] }) })
      ]
    },
    `${t.documentType}:${t.defaultExtension}:${t.editor.extensionId ?? t.editor.kind}`
  )) });
}
function cs(n) {
  return n.button === 0 && !n.metaKey && !n.ctrlKey && !n.shiftKey && !n.altKey;
}
function gr({ href: n, onClick: e, onContextMenu: t, ...r }) {
  if (n) {
    const o = /* @__PURE__ */ s(
      "a",
      {
        ...r,
        href: n,
        onClick: (a) => {
          a.stopPropagation(), cs(a) && (a.preventDefault(), e?.(a));
        },
        onContextMenu: t
      }
    );
    return t ? /* @__PURE__ */ b("span", { className: "shared-document-link-row group relative block", children: [
      o,
      /* @__PURE__ */ s(
        "button",
        {
          type: "button",
          className: "shared-document-actions absolute right-1 top-1/2 flex -translate-y-1/2 items-center justify-center rounded border-none bg-transparent p-0.5 text-[var(--nim-text-faint)] opacity-0 transition-opacity hover:bg-[var(--nim-bg-hover)] hover:text-[var(--nim-text)] focus-visible:opacity-100 group-hover:opacity-100",
          "aria-label": "Document actions",
          title: "More actions",
          onClick: (a) => {
            a.preventDefault(), a.stopPropagation(), t(a);
          },
          children: /* @__PURE__ */ s(k, { icon: "more_horiz", size: 16 })
        }
      )
    ] }) : o;
  }
  return /* @__PURE__ */ s("button", { ...r, type: "button", onClick: (o) => {
    o.stopPropagation(), e?.(o);
  }, onContextMenu: t });
}
function lr({
  isOpen: n,
  title: e,
  placeholder: t,
  defaultValue: r = "",
  suffix: o,
  confirmLabel: a = "Create",
  onConfirm: l,
  onCancel: c
}) {
  const [p, h] = R(r), y = jt(null);
  return ye(() => {
    n && (y.current?.focus(), y.current?.select());
  }, [n]), ye(() => h(r), [r]), n ? /* @__PURE__ */ s("div", { className: "input-modal-overlay nim-overlay", onClick: c, children: /* @__PURE__ */ s(
    "div",
    {
      className: "input-modal rounded-lg p-5 w-[400px] max-w-[90%] shadow-[0_10px_25px_rgba(0,0,0,0.2)] bg-[var(--nim-bg)] text-[var(--nim-text)]",
      onClick: (C) => C.stopPropagation(),
      children: /* @__PURE__ */ b("form", { onSubmit: (C) => {
        C.preventDefault(), p.trim() && l(p.trim());
      }, children: [
        /* @__PURE__ */ s("h3", { className: "input-modal-title m-0 mb-4 text-base font-semibold text-[var(--nim-text)]", children: e }),
        /* @__PURE__ */ b("div", { className: `input-modal-input-wrapper relative flex items-center mb-4 ${o ? "has-suffix" : ""}`, children: [
          /* @__PURE__ */ s(
            "input",
            {
              ref: y,
              type: "text",
              className: `input-modal-input nim-input text-sm ${o ? "pr-[120px]" : ""}`,
              placeholder: t,
              value: p,
              onChange: (C) => h(C.target.value),
              onKeyDown: (C) => {
                C.key === "Escape" && c();
              }
            }
          ),
          o ? /* @__PURE__ */ s("span", { className: "input-modal-suffix absolute right-3 text-sm text-[var(--nim-text-faint)] pointer-events-none select-none", children: o }) : null
        ] }),
        /* @__PURE__ */ b("div", { className: "input-modal-buttons flex justify-end gap-2", children: [
          /* @__PURE__ */ s("button", { type: "button", className: "input-modal-button input-modal-cancel nim-btn-secondary px-4 py-1.5 text-sm", onClick: c, children: "Cancel" }),
          /* @__PURE__ */ s("button", { type: "submit", className: "input-modal-button input-modal-confirm nim-btn-primary px-4 py-1.5 text-sm", disabled: !p.trim(), children: a })
        ] })
      ] })
    }
  ) }) : null;
}
function ds(n) {
  const e = n.replace(/\\/g, "/").replace(/\/$/, "");
  return e.slice(e.lastIndexOf("/") + 1);
}
function us(n) {
  let e = 0;
  for (let t = 0; t < n.length; t += 1)
    e = (e << 5) - e + n.charCodeAt(t), e &= e;
  return `hsl(${Math.abs(e) % 360}, 65%, 55%)`;
}
function ps({
  scopeKey: n,
  scopeName: e,
  scopePath: t,
  actions: r,
  subtitle: o,
  showAccent: a = !0,
  headerClassName: l = "",
  actionsClassName: c = ""
}) {
  const p = e ?? (ds(n) || "Wiki");
  return /* @__PURE__ */ b(Ie, { children: [
    a ? /* @__PURE__ */ s("div", { className: "workspace-color-accent h-[3px] w-full opacity-90 shrink-0", style: { backgroundColor: us(n) } }) : null,
    /* @__PURE__ */ b("div", { className: `workspace-summary-header px-3 pt-2.5 pb-2 border-b border-[var(--nim-border)] bg-[var(--nim-bg)] gap-2 min-h-14 shrink-0 ${l}`.trim(), children: [
      /* @__PURE__ */ b("div", { className: "workspace-summary-header-top flex items-start gap-2", children: [
        /* @__PURE__ */ b("div", { className: "workspace-summary-header-title-row flex items-baseline gap-2.5 min-w-0 flex-1", children: [
          /* @__PURE__ */ s("h3", { className: "workspace-summary-header-name m-0 text-[15px] font-bold text-[var(--nim-text)] overflow-hidden text-ellipsis whitespace-nowrap tracking-tight leading-tight", children: p }),
          o ? /* @__PURE__ */ s("span", { className: "workspace-summary-header-subtitle text-[13px] font-medium text-[var(--nim-text-muted)] opacity-70 whitespace-nowrap", children: o }) : null
        ] }),
        r ? /* @__PURE__ */ s("div", { className: `workspace-summary-header-actions flex items-center gap-1.5 shrink-0 ${c}`.trim(), children: r }) : null
      ] }),
      /* @__PURE__ */ s("div", { className: "workspace-summary-header-path mt-0.5 text-[11px] text-[var(--nim-text-muted)] overflow-hidden text-ellipsis whitespace-nowrap opacity-75 font-normal", title: n, children: t ?? n })
    ] })
  ] });
}
const Nr = be.createContext({ itemId: null, typeId: null });
function ms(n, e) {
  return (n?.listedTypes?.() ?? []).filter((t) => !e.has(t.typeId)).map((t) => ({ typeId: t.typeId, name: t.name, icon: t.icon || "table" })).sort((t, r) => t.name.localeCompare(r.name));
}
const vo = (n) => n ? { onDragOver: n.onDragOver, onDragLeave: n.onDragLeave, onDrop: n.onDrop } : {};
function xo(n, e) {
  return `The type '${n}' did not load: ${e}`;
}
const wo = ({ expanded: n, onToggle: e }) => /* @__PURE__ */ s(
  "span",
  {
    className: "file-tree-chevron",
    role: "button",
    "aria-label": n ? "Collapse" : "Expand",
    onClick: (t) => {
      t.stopPropagation(), e();
    },
    children: /* @__PURE__ */ s(k, { icon: n ? "keyboard_arrow_down" : "keyboard_arrow_right", size: 16 })
  }
), fs = ({ node: n, indent: e, expanded: t, onToggle: r, onOpen: o, onContextMenu: a, onDragStart: l, onDragEnd: c, drop: p }) => /* @__PURE__ */ b(
  "button",
  {
    type: "button",
    className: `collab-tree-type-row w-full flex items-center text-left file-tree-directory${be.useContext(Nr).typeId === n.typeId ? " active" : ""}${n.error ? " broken" : ""}${p?.className ?? ""}`,
    style: { paddingLeft: e },
    "data-testid": "collab-tree-type-row",
    "data-type-id": n.typeId,
    draggable: !n.error,
    ...vo(p),
    onDragStart: n.error ? void 0 : l,
    onDragEnd: n.error ? void 0 : c,
    onClick: (h) => n.error ? r() : o(vr(h)),
    onContextMenu: n.error ? void 0 : a,
    title: n.error ? xo(n.typeId, n.error) : n.path,
    children: [
      /* @__PURE__ */ s(wo, { expanded: t, onToggle: r }),
      /* @__PURE__ */ s("span", { className: `file-tree-icon ${n.error ? "text-[var(--nim-error)]" : "text-[var(--nim-purple)]"}`, children: /* @__PURE__ */ s(k, { icon: n.error ? "error" : "table", size: 16 }) }),
      /* @__PURE__ */ s("span", { className: "file-tree-name", children: n.name }),
      n.count > 0 && /* @__PURE__ */ s("span", { className: "collab-tree-type-count ml-1.5 mr-1 text-[11px] text-[var(--nim-text-faint)]", children: n.count })
    ]
  }
), hs = "__under_type__", Io = ({ node: n, position: e, indent: t, onOpen: r, actions: o }) => {
  const a = o?.rowDrop?.(n), l = (n.children?.length ?? 0) > 0 && !!o?.renderChildren, c = l && (o?.isExpanded?.(n) ?? !1), p = be.useContext(Nr).itemId === n.itemId, h = /* @__PURE__ */ s(
    "button",
    {
      type: "button",
      className: `collab-tree-item-row w-full flex items-center text-left file-tree-file${p ? " active" : ""}${a?.className ?? ""}`,
      style: { paddingLeft: t },
      "data-testid": "collab-tree-item-row",
      "data-item-id": n.itemId,
      ...vo(a),
      onClick: (y) => r(vr(y)),
      onContextMenu: o ? (y) => o.onContextMenu(y, n) : void 0,
      draggable: !!o,
      onDragStart: o ? (y) => {
        y.stopPropagation(), y.dataTransfer.effectAllowed = "move", y.dataTransfer.setData("text/plain", n.itemId), o.onDragStart(n);
      } : void 0,
      onDragEnd: o?.onDragEnd,
      title: n.typeError ? xo(n.typeId, n.typeError) : n.path,
      children: n.typeLabel ? /* @__PURE__ */ b(Ie, { children: [
        l ? /* @__PURE__ */ s(wo, { expanded: c, onToggle: () => o?.onToggle?.(n) }) : /* @__PURE__ */ s("span", { className: "file-tree-spacer" }),
        n.typeError ? /* @__PURE__ */ s("span", { className: "file-tree-icon text-[var(--nim-error)]", children: /* @__PURE__ */ s(k, { icon: "error", size: 16 }) }) : /* @__PURE__ */ s("span", { className: "file-tree-icon", children: /* @__PURE__ */ s(k, { icon: "description", size: 16 }) }),
        /* @__PURE__ */ s("span", { className: "file-tree-name", children: n.name }),
        /* @__PURE__ */ s("span", { className: "collab-tree-item-type ml-auto mr-1 pl-1.5 shrink-0 text-[11px] text-[var(--nim-text-faint)]", children: n.typeLabel })
      ] }) : /* @__PURE__ */ b(Ie, { children: [
        /* @__PURE__ */ s("span", { className: "collab-tree-item-number w-[18px] mr-1.5 shrink-0 text-right text-[11px] text-[var(--nim-text-faint)]", children: e }),
        /* @__PURE__ */ s("span", { className: "file-tree-name", children: n.name })
      ] })
    }
  );
  return l ? /* @__PURE__ */ b("div", { children: [
    h,
    c ? o.renderChildren(n.children, t + 16) : null
  ] }) : h;
}, ys = ({ node: n, indent: e, expanded: t, onToggle: r, onOpenType: o, onOpenItem: a, onContextMenu: l, onDragStart: c, onDragEnd: p, renderSubtypes: h, itemActions: y }) => {
  const C = n.children.filter((T) => T.type === "type"), M = n.children.filter((T) => T.type === "item");
  return /* @__PURE__ */ b("div", { children: [
    /* @__PURE__ */ s(
      fs,
      {
        node: n,
        indent: e,
        expanded: t,
        onToggle: r,
        onOpen: (T) => {
          t || r(), o(n.typeId, T);
        },
        onContextMenu: l,
        onDragStart: (T) => {
          T.stopPropagation(), T.dataTransfer.effectAllowed = "move", T.dataTransfer.setData("text/plain", n.typeId), c(n.typeId);
        },
        onDragEnd: p,
        drop: y?.rowDrop?.(n)
      }
    ),
    t ? /* @__PURE__ */ b(Ie, { children: [
      h(C),
      M.map((T, $) => /* @__PURE__ */ s(
        Io,
        {
          node: T,
          position: $ + 1,
          indent: e + 16,
          onOpen: (oe) => a(T.itemId, oe),
          actions: y
        },
        T.id
      ))
    ] }) : null
  ] });
}, bs = ({ x: n, y: e, types: t, onPlace: r, onClose: o }) => {
  const a = L(() => xr(n, e), [n, e]), l = cn({
    placement: "right-start",
    reference: a,
    open: !0,
    onOpenChange: (c) => {
      c || o();
    }
  });
  return /* @__PURE__ */ s(Vt, { children: /* @__PURE__ */ b(
    "div",
    {
      ref: l.refs.setFloating,
      style: l.floatingStyles,
      ...l.getFloatingProps(),
      className: "collab-place-type-menu min-w-[180px] max-h-[360px] overflow-y-auto rounded-md z-[10000] text-[13px] p-1 bg-nim-secondary border border-nim text-nim backdrop-blur-[10px] shadow-lg",
      children: [
        /* @__PURE__ */ s("div", { className: "px-3 pt-1 pb-0.5 text-[11px] text-[var(--nim-text-faint)]", children: "Place type..." }),
        t.length === 0 ? /* @__PURE__ */ s("div", { className: "px-3 py-1.5 text-[var(--nim-text-faint)]", children: "Every type is placed" }) : t.map((c) => /* @__PURE__ */ b(
          "button",
          {
            type: "button",
            className: "collab-place-type-option w-full flex items-center gap-2.5 px-3 py-1.5 rounded border-none bg-transparent cursor-pointer transition-colors text-left text-nim hover:bg-nim-hover",
            onClick: () => r(c.typeId),
            children: [
              /* @__PURE__ */ s(k, { icon: c.icon, size: 18 }),
              /* @__PURE__ */ s("span", { children: c.name })
            ]
          },
          c.typeId
        ))
      ]
    }
  ) });
}, cr = "w-full flex items-center gap-2.5 px-3 py-1.5 rounded border-none bg-transparent cursor-pointer transition-colors text-left text-nim hover:bg-nim-hover", gs = ({ x: n, y: e, onNewPage: t, onPlaceType: r, extraItems: o, onClose: a }) => {
  const l = L(() => xr(n, e), [n, e]), c = cn({
    placement: "right-start",
    reference: l,
    open: !0,
    onOpenChange: (p) => {
      p || a();
    }
  });
  return /* @__PURE__ */ s(Vt, { children: /* @__PURE__ */ b(
    "div",
    {
      ref: c.refs.setFloating,
      style: c.floatingStyles,
      ...c.getFloatingProps(),
      className: "collab-section-menu min-w-[180px] rounded-md z-[10000] text-[13px] p-1 bg-nim-secondary border border-nim text-nim backdrop-blur-[10px] shadow-lg",
      children: [
        /* @__PURE__ */ b("button", { type: "button", className: `collab-section-new-page ${cr}`, onClick: t, children: [
          /* @__PURE__ */ s(k, { icon: "note_add", size: 18 }),
          /* @__PURE__ */ s("span", { children: "New page" })
        ] }),
        r && /* @__PURE__ */ b("button", { type: "button", className: `collab-section-place-type ${cr}`, onClick: r, children: [
          /* @__PURE__ */ s(k, { icon: "table", size: 18 }),
          /* @__PURE__ */ s("span", { children: "Place type..." })
        ] }),
        o?.map((p) => /* @__PURE__ */ b(
          "button",
          {
            type: "button",
            className: `collab-section-${p.id} ${cr}`,
            onClick: () => {
              a(), p.onSelect();
            },
            children: [
              /* @__PURE__ */ s(k, { icon: p.icon, size: 18 }),
              /* @__PURE__ */ s("span", { children: p.label })
            ]
          },
          p.id
        ))
      ]
    }
  ) });
}, vs = {
  empty: "cloud_sync",
  favorites: "star",
  updated: "mark_email_read"
}, xs = ({ reason: n, personal: e, scopeAvailable: t, onNewPage: r }) => {
  const [o, a] = n === "favorites" ? ["No favorites yet.", "Star a document to pin it here."] : n === "updated" ? ["You're all caught up.", "No documents changed since you last viewed them."] : e ? ["No personal pages yet.", null] : t ? ["No shared documents yet.", "Create one here or share a local file to collaborate."] : ["No team connected to this workspace.", null];
  return /* @__PURE__ */ b("div", { className: "collab-tree-empty px-2 py-4 text-center", children: [
    /* @__PURE__ */ s(k, { icon: vs[n], size: 32, className: "text-nim-faint mb-2" }),
    /* @__PURE__ */ s("p", { className: "text-xs text-nim-faint m-0", children: o }),
    a && /* @__PURE__ */ s("p", { className: "text-xs text-nim-faint mt-1 m-0", children: a }),
    n === "empty" && t && r && /* @__PURE__ */ b(
      "button",
      {
        type: "button",
        className: "collab-empty-new-page mt-3 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md border border-[var(--nim-border)] bg-transparent text-xs text-[var(--nim-text)] cursor-pointer hover:bg-[var(--nim-bg-hover)]",
        onClick: r,
        children: [
          /* @__PURE__ */ s(k, { icon: "note_add", size: 14 }),
          "New page"
        ]
      }
    )
  ] });
}, ws = be.lazy(() => import("./CollabTrashDialog-BZBQEyyp.js")), Is = ({ sectionLabel: n }) => {
  const { session: e } = Wn(), t = j(e.atoms.trashedSharedDocuments), r = L(() => Pa(t).length, [t]), [o, a] = R(!1);
  return /* @__PURE__ */ b(Ie, { children: [
    /* @__PURE__ */ b(
      "button",
      {
        type: "button",
        className: "collab-sidebar-trash-entry shrink-0 flex items-center gap-2 mx-1.5 mb-1.5 px-2 py-1 rounded border-none bg-transparent cursor-pointer text-left text-[12px] text-[var(--nim-text-faint)] hover:bg-[var(--nim-bg-hover)] hover:text-[var(--nim-text)]",
        "aria-label": `${n} Trash${r > 0 ? `, ${r} item${r === 1 ? "" : "s"}` : ""}`,
        onClick: () => a(!0),
        children: [
          /* @__PURE__ */ s(k, { icon: "delete", size: 16 }),
          /* @__PURE__ */ s("span", { className: "flex-1", children: "Trash" }),
          r > 0 && /* @__PURE__ */ s("span", { className: "collab-sidebar-trash-count text-[11px] tabular-nums", children: r })
        ]
      }
    ),
    o && /* @__PURE__ */ s(be.Suspense, { fallback: null, children: /* @__PURE__ */ s(ws, { sectionLabel: n, onClose: () => a(!1) }) })
  ] });
};
function Ss(n) {
  return n.type === "type" || n.type === "item" ? n.id : n.path;
}
function So(n, e) {
  if (!e) return null;
  for (const t of n) {
    if (t.type === "item" && t.itemId === e) return e;
    const r = "children" in t ? t.children : void 0;
    if (r?.length && So(r, e)) return e;
  }
  return null;
}
function ko(n, e) {
  for (const t of n) {
    if (e.itemId && t.type === "item" && t.itemId === e.itemId || e.typeId && t.type === "type" && t.typeId === e.typeId || e.documentId && t.type === "document" && t.document.documentId === e.documentId) return [];
    const r = "children" in t ? t.children : void 0;
    if (!r?.length) continue;
    const o = ko(r, e);
    if (o) return [Ss(t), ...o];
  }
  return null;
}
function Co(n, e) {
  for (const t of n) {
    if (e.kind === "type") {
      if (t.type === "type" && t.typeId === e.pageId) return t;
    } else {
      if (t.type === "document" && t.document.documentId === e.pageId)
        return t;
      if (t.type === "item" && t.itemId === e.pageId)
        return t;
    }
    const r = "children" in t ? t.children : void 0, o = r?.length ? Co(r, e) : null;
    if (o) return o;
  }
  return null;
}
const ks = 3e3;
function Cs({
  request: n,
  tree: e,
  run: t,
  onHandled: r,
  onMissing: o
}) {
  ye(() => {
    if (!n) return;
    const a = Co(e, n);
    if (!a) {
      const l = setTimeout(() => {
        r?.(), o();
      }, ks);
      return () => clearTimeout(l);
    }
    r?.(), t(a, n.action);
  }, [n, e]);
}
const Be = ({ icon: n, label: e, trailing: t, disabled: r, danger: o, fill: a, className: l, title: c, onClick: p }) => /* @__PURE__ */ b(
  "button",
  {
    type: "button",
    className: `${l ?? ""} w-full flex items-center gap-2.5 px-3 py-1.5 rounded border-none bg-transparent cursor-pointer transition-colors text-left hover:bg-nim-hover disabled:opacity-50 disabled:cursor-not-allowed ${o ? "text-[var(--nim-error)]" : "text-nim"}`,
    disabled: r,
    title: c,
    onClick: p,
    children: [
      /* @__PURE__ */ s(k, { icon: n, size: 18, fill: a }),
      /* @__PURE__ */ s("span", { className: "flex-1", children: e }),
      t && /* @__PURE__ */ s("span", { className: "ml-3 text-[11px] text-[var(--nim-text-faint)]", children: t })
    ]
  }
), Ns = ({ documentId: n, className: e }) => {
  const { session: t } = Wn();
  return j(t.atoms.unreadDocument(n)) ? /* @__PURE__ */ s(
    "span",
    {
      className: `doc-unread-dot inline-flex items-center justify-center shrink-0 text-[var(--nim-primary)]${e ? ` ${e}` : ""}`,
      title: "New activity",
      "aria-label": "Unread",
      children: /* @__PURE__ */ s(k, { icon: "circle", size: 8, fill: !0 })
    }
  ) : null;
};
function It(n) {
  return n <= 0 ? "0" : n === 1 ? "1" : n <= 5 ? "2-5" : n <= 20 ? "6-20" : "21+";
}
function Ts(n) {
  return n <= 3 ? "1-3" : n <= 10 ? "4-10" : n <= 30 ? "11-30" : "31+";
}
function No(n) {
  return n?.trim().toLowerCase().replace(/[^a-z0-9_-]+/g, "_") || "unknown";
}
function ct(n, e) {
  n.trackEvent?.("collab_document_action", {
    surface: n.surface ?? "desktop",
    action: e.action,
    actorType: "user",
    documentType: No(e.documentType),
    entryPoint: e.entryPoint
  });
}
const Ds = "application/x-nimbalyst-collab-document";
function Bi(n) {
  if (!n) return null;
  try {
    const e = JSON.parse(n);
    if (typeof e != "object" || e === null) return null;
    const { orgId: t, documentId: r, title: o } = e;
    return typeof t != "string" || !t || typeof r != "string" || !r ? null : {
      orgId: t,
      documentId: r,
      title: typeof o == "string" ? o : r
    };
  } catch {
    return null;
  }
}
const Xr = "A page cannot move inside one of its own child pages.", Ps = { onDragOver: () => {
}, onDragLeave: () => {
}, onDrop: () => {
}, className: "" }, As = w([]), Fs = w(!1), vn = () => import("./CollabPageMenu-D0TmMc7O.js"), _s = () => import("./collabPageTree-DUvCpMMn.js"), Es = be.lazy(() => vn().then((n) => ({ default: n.CollabPageMenuHead }))), Ks = be.lazy(() => vn().then((n) => ({ default: n.CollabPageDeleteEntry }))), Ms = be.lazy(() => vn().then((n) => ({ default: n.CollabItemMenu }))), Rs = be.lazy(() => vn().then((n) => ({ default: n.CollabPageHistoryEntry }))), Ls = be.lazy(() => import("./CollabPageMoveDialog-BxLrFkWM.js")), Os = {
  connected: { label: "Team synced", dotClass: "bg-green-500" },
  syncing: { label: "Syncing...", dotClass: "bg-blue-500 animate-pulse" },
  connecting: { label: "Connecting...", dotClass: "bg-yellow-500 animate-pulse" },
  disconnected: { label: "Disconnected", dotClass: "bg-gray-500" },
  error: { label: "Sync error", dotClass: "bg-red-500" }
}, Qr = ({ status: n, personal: e }) => {
  const { label: t, dotClass: r } = e ? { label: "On this device", dotClass: "bg-gray-500" } : Os[n];
  return /* @__PURE__ */ b("span", { className: "inline-flex items-center gap-1.5", children: [
    /* @__PURE__ */ s("span", { className: `inline-block w-1.5 h-1.5 rounded-full shrink-0 ${r}` }),
    /* @__PURE__ */ s("span", { children: t })
  ] });
};
function $s() {
  return {
    available: !1,
    binding: null,
    busyAction: null,
    hasResolvedBinding: !0,
    openLocalSource: async () => !1,
    relinkLocalSource: async () => !1,
    clearLocalSource: async () => !1,
    reuploadFromLocalSource: async () => !1
  };
}
const Ui = ({
  activeDocumentId: n,
  activeItemId: e = null,
  activeTypeId: t = null,
  sectionEntries: r,
  scopeName: o,
  scopePath: a,
  headerActions: l,
  extraSectionMenuItems: c,
  onSelectFolder: p,
  registerCreateMenu: h,
  typeResolver: y,
  onArchiveItem: C,
  sectionTitle: M,
  collapsed: T = !1,
  onToggleCollapsed: $,
  onSetPageType: oe,
  pageActionRequest: Ne,
  onPageActionHandled: ne
}) => {
  const { scope: A, host: g, session: S, controller: O } = Wn(), E = j(S.atoms.typePlacements), z = j(S.atoms.itemPlacements ?? As), K = j(S.atoms.pageTree ?? Fs), [q, ut] = R(null);
  ye(() => {
    if (!K || q) return;
    let i = !0;
    return vn(), _s().then((u) => {
      i && ut(u);
    }).catch((u) => g.reportError?.(u, "Failed to load the page tree")), () => {
      i = !1;
    };
  }, [g, K, q]);
  const Z = ro(A), nt = L(
    () => y ? { placements: E, resolver: y } : void 0,
    [E, y]
  ), ge = L(
    () => new Set(E.map((i) => i.typeId)),
    [E]
  ), pt = L(
    () => ms(y, ge),
    [y, ge]
  ), [Te, Ye] = R(null), [Me, Xe] = R(null), [Ue, De] = R("page"), [ae, D] = R(null), [X, Se] = R(null), [ie, Pe] = R(null), [at, ee] = R(null), Qe = qr(
    (i) => g.documents?.onDocumentTypesChanged?.(i) ?? (() => {
    }),
    () => g.documents?.documentTypes() ?? [],
    () => g.documents?.documentTypes() ?? []
  ), je = g.documents?.documentTypes() ?? [], W = j(S.atoms.sharedDocuments), ce = j(S.atoms.allSharedDocuments), Q = j(S.atoms.sharedFolders), Je = j(S.atoms.syncStatus), re = A.orgId, mt = j(S.atoms.hasTeam) || Z, rt = j(S.atoms.treeFilter), ft = j(S.atoms.showUnreadBubbles), xn = j(S.atoms.favorites), _t = j(S.atoms.changedDocumentIds), { personalState: ue, readReceipts: Re } = S.uiCapabilities, ve = L(() => new Set(xn), [xn]), Le = rt === "favorites" && ue ? "favorites" : rt === "updated" && Re ? "updated" : "all", Yt = L(() => [
    { key: "all", label: "All", icon: null },
    ...ue ? [{ key: "favorites", label: "Favorites", icon: "star" }] : [],
    ...Re ? [{ key: "updated", label: "Updated", icon: "circle" }] : []
  ], [ue, Re]), [Et, ht] = R(!1), [I, N] = R(null), [Oe, pe] = R(/* @__PURE__ */ new Set()), [Ae, $e] = R(null), [st, m] = R(null), [x, P] = R(null), [H, ke] = R(null), [xe, we] = R(null), [wn, Ce] = R(!1), [Kt, Mt] = R(null), [fe, qe] = R(null), In = fe ? Qa(fe, je) : { baseName: "", suffix: "" }, [Xt, Sn] = R(!1), [kn, Cn] = R(null), Qt = j(S.atoms.pendingFolder), [Fe, Hn] = R(null), [_e, Jt] = R(null), [ot, Ee] = R(null), [Nn, qt] = R(!1), he = _((i, u) => {
    g.notify?.({ level: "warning", title: i, message: u, duration: 5e3 });
  }, [g]), ze = _((i) => {
    he("Could not update the tree", i instanceof Error ? i.message : String(i));
  }, [he]), se = L(
    () => K ? q?.buildCollabPageTree(W, {
      resolver: y,
      typePlacements: E,
      itemPlacements: z
    }) ?? [] : ar(W, Q, nt),
    [z, K, q, W, Q, E, y, nt]
  ), Gn = L(() => {
    const i = /* @__PURE__ */ new Set(), u = (d) => {
      for (const v of d)
        v.type === "type" && v.children.forEach((F) => {
          F.type === "type" && i.add(F.typeId);
        }), "children" in v && v.children && u(v.children);
    };
    return u(se), i;
  }, [se]), Tn = L(() => Le === "favorites" ? W.filter((i) => ve.has(i.documentId)) : Le === "updated" ? W.filter((i) => _t.has(i.documentId)) : W, [W, Le, ve, _t]), Tr = L(
    () => Le !== "all" ? K ? q?.buildCollabPageTree(Tn) ?? [] : Jo(ar(Tn, Q)) : K ? se : ar(Tn, Q, nt),
    [Tn, Q, Le, nt, K, q, se]
  ), it = L(() => {
    const i = /* @__PURE__ */ new Set(), u = (d) => {
      for (const v of d)
        v.type === "type" || v.type === "item" || (i.add(v.path), (v.type === "folder" || v.type === "document") && u(v.children ?? []));
    };
    return u(se), i;
  }, [se]), Yn = L(
    () => W.find((i) => i.documentId === n) ?? null,
    [n, W]
  ), Rt = L(
    () => e ?? So(se, n ?? null),
    [n, e, se]
  ), To = L(() => ({ itemId: Rt, typeId: t }), [Rt, t]), lt = L(
    () => new Map(Q.map((i) => [i.folderId, i])),
    [Q]
  ), Ve = L(() => {
    const i = /* @__PURE__ */ new Map(), u = (d, v) => {
      const F = i.get(d);
      if (F !== void 0) return F;
      const B = lt.get(d);
      if (!B || v.has(d)) return "";
      v.add(d);
      const U = B.parentFolderId ? u(B.parentFolderId, v) : "", me = sn(U, B.name);
      return i.set(d, me), me;
    };
    for (const d of Q) u(d.folderId, /* @__PURE__ */ new Set());
    return i;
  }, [Q, lt]), Dn = _(
    (i) => K ? Br(i, Q) : qo(i),
    [K, Q]
  ), Zt = _(
    (i) => Br(i, Q),
    [Q]
  ), V = _((i) => Je === "connected" ? !0 : (he(
    "Shared documents are offline",
    `Cannot ${i} while shared document sync is ${Je}. Reconnect to the team before changing shared document metadata.`
  ), !1), [he, Je]), Do = L(
    () => I ? xr(I.x, I.y) : null,
    [I]
  ), Xn = cn({
    placement: "right-start",
    reference: Do,
    open: I !== null,
    onOpenChange: (i) => {
      i || N(null);
    }
  }), Lt = cn({
    placement: "bottom-end",
    open: Et,
    onOpenChange: ht
  }), Ze = cn({
    placement: "bottom-start"
  }), en = L(
    () => is(je),
    // The subscription value changes whenever the host registry changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Qe]
  ), Qn = en.find(({ descriptor: i }) => i.documentType === "markdown")?.descriptor, Ot = (i, u = "page") => {
    De(u), Mt(i), Qn && we(Qn), N(null), Xe(null), T && $?.();
  }, Po = _(() => {
    ht(!1), re && S.markAllDocumentsViewed();
  }, [S, re]), Ao = _((i) => {
    const u = ve.has(i.documentId);
    S.toggleFavorite(i.documentId), ct(g, {
      action: u ? "favorite_disabled" : "favorite_enabled",
      documentType: i.documentType,
      entryPoint: "sidebar"
    });
  }, [ve, g, S]), Fo = _((i) => {
    re && (S.markDocumentViewed(i.documentId, i.updatedAt ?? null), ct(g, {
      action: "marked_read",
      documentType: i.documentType,
      entryPoint: "sidebar"
    }));
  }, [g, S, re]);
  ye(() => {
    if (Sn(!1), Cn(null), N(null), qe(null), P(null), ke(null), $e(null), m(null), pe(/* @__PURE__ */ new Set()), qt(!1), !g.documents?.loadTreeState) {
      Sn(!0), Cn(A.scopeKey);
      return;
    }
    let i = !1;
    return g.documents.loadTreeState(A.scopeKey).then((u) => {
      if (i) return;
      const d = Array.isArray(u?.expandedFolders) ? u.expandedFolders.map((v) => eo(v)).filter(Boolean) : [];
      pe(new Set(d)), qt(
        u?.userTouched === !0 || d.length > 0
      ), Sn(!0), Cn(A.scopeKey);
    }).catch(() => {
      i || (Sn(!0), Cn(A.scopeKey));
    }), () => {
      i = !0;
    };
  }, [g.documents, A.scopeKey]), ye(() => {
    !Xt || kn !== A.scopeKey || !g.documents?.saveTreeState || g.documents.saveTreeState(A.scopeKey, {
      expandedFolders: Array.from(Oe),
      userTouched: Nn
    }).catch((i) => {
      console.warn("[CollabSidebar] Failed to persist tree state:", i);
    });
  }, [Oe, Xt, g.documents, kn, Nn, A.scopeKey]), ye(() => {
    if (!Yn) return;
    const i = Dn(Yn), u = [];
    let d = dt(i);
    for (; d; )
      u.unshift(d), d = dt(d);
    u.length !== 0 && pe((v) => {
      const F = new Set(v);
      let B = !1;
      for (const U of u)
        F.has(U) || (F.add(U), B = !0);
      return B ? F : v;
    });
  }, [Yn, Dn]);
  const Dr = jt(null);
  ye(() => {
    const i = Rt ? `item:${Rt}` : t ? `type:${t}` : n ? `document:${n}` : null;
    if (!i || Dr.current === i) return;
    const u = ko(se, { itemId: Rt, typeId: t, documentId: n ?? null });
    u && (Dr.current = i, u.length !== 0 && pe((d) => u.every((v) => d.has(v)) ? d : /* @__PURE__ */ new Set([...d, ...u])));
  }, [n, Rt, t, se]);
  const $t = _((i, u) => {
    i.preventDefault(), i.stopPropagation(), u.type === "folder" && ($e(u.path), m(u.folderId ?? null)), N({ x: i.clientX, y: i.clientY, node: u });
  }, []), Pr = _(async (i) => {
    if (!re) {
      g.notify?.({ level: "warning", title: "No team configured", message: "This workspace is not connected to a team, so no shareable link is available.", duration: 4e3 });
      return;
    }
    const u = g.artifactUrl?.({
      kind: "document",
      scope: A,
      documentId: i.documentId,
      teamProjectId: i.teamProjectId
    });
    if (u)
      try {
        await navigator.clipboard.writeText(u), ct(g, {
          action: "link_copied",
          documentType: i.documentType,
          entryPoint: "sidebar"
        }), g.notify?.({ level: "info", title: "Link copied", message: "Paste it anywhere to open this document.", duration: 3e3 });
      } catch (d) {
        console.error("[CollabSidebar] Failed to copy link:", d), g.notify?.({ level: "error", title: "Copy failed", message: "Could not write the link to the clipboard." });
      }
  }, [g, A, re]), Jn = _((i, u) => {
    const d = K ? Ln(ce, E, i.documentId).childCount : 0;
    if (d > 0) {
      if (!V("move this page to Trash")) return;
      const v = `${d} child page${d === 1 ? "" : "s"}`;
      N(null), sr("Move page to Trash", `Move "${Ut(u, i.documentType)}" and its ${v} to Trash? Types and typed pages inside show in their usual place until you restore it.`).then((F) => {
        F && (S.removePage(i.documentId), g.trackEvent?.("collab_folder_deleted", {
          actorType: "user",
          source: "sidebar",
          documentCountBucket: It(d),
          subfolderCountBucket: It(0)
        }));
      });
      return;
    }
    V("move this document to Trash") && (S.trashDocument(i.documentId), ct(g, {
      action: "trashed",
      documentType: i.documentType,
      entryPoint: "context_menu"
    }), N(null));
  }, [ce, V, g, K, S, E]), qn = _(() => {
    if (!I) return;
    if (I.node.type === "document") {
      Jn(I.node.document, I.node.name);
      return;
    }
    if (I.node.type !== "folder") {
      N(null);
      return;
    }
    const i = I.node.folderId;
    if (!i) {
      N(null);
      return;
    }
    if (!V("delete this folder")) return;
    const u = new Set(mr(Q, i)), d = u.size - 1, v = ce.filter(
      (U) => U.parentFolderId && u.has(U.parentFolderId)
    ).length, F = [];
    v > 0 && F.push(`${v} document${v === 1 ? "" : "s"}`), d > 0 && F.push(`${d} subfolder${d === 1 ? "" : "s"}`);
    const B = F.length > 0 ? ` and its ${F.join(" and ")}` : "";
    N(null), sr("Delete shared folder", `Delete shared folder "${I.node.name}"${B}? This cannot be undone.`).then((U) => {
      U && (S.removeFolder(i), g.trackEvent?.("collab_folder_deleted", {
        actorType: "user",
        source: "sidebar",
        documentCountBucket: It(v),
        subfolderCountBucket: It(d)
      }), st === i && (m(null), $e(null)));
    });
  }, [ce, V, I, g, st, S, Q, Jn]), Ar = _((i) => {
    V("remove this type from the tree") && S.removeTypePlacement(i).catch(ze);
  }, [V, ze, S]);
  Cs({
    request: Ne,
    tree: se,
    onHandled: ne,
    onMissing: () => he("Page not found", "This page is not in the sidebar, so the action did not run."),
    run: (i, u) => {
      if (T && (u === "rename" || u === "moveTo") && $?.(), i.type === "type") {
        u === "removeFromTree" ? Ar(i.typeId) : u === "moveTo" && Gn.has(i.typeId) ? he("Cannot move this type", "It is shown inside the type it extends.") : u === "moveTo" && Pe({ kind: "type", node: i });
        return;
      }
      if (i.type === "item") {
        u === "newPageInside" ? Ot(i.itemId, "item") : u === "moveTo" ? Pe({ kind: "item", node: i }) : u === "backUnderType" && vt(i.itemId, { underType: !0 });
        return;
      }
      const { document: d } = i;
      u === "newPageInside" ? Ot(d.documentId) : u === "rename" ? qe(d) : u === "moveTo" ? Pe({ kind: "page", document: d }) : u === "trash" && Jn(d, i.name);
    }
  });
  const _o = _(async (i) => {
    if (!re) {
      g.notify?.({ level: "warning", title: "No team configured", message: "This workspace is not connected to a team, so no shareable link is available.", duration: 4e3 });
      return;
    }
    const u = g.artifactUrl?.({ kind: "folder", scope: A, folderId: i });
    if (u)
      try {
        await navigator.clipboard.writeText(u), g.trackEvent?.("collab_folder_link_copied", { actorType: "user", entryPoint: "sidebar" }), g.notify?.({ level: "info", title: "Folder link copied", message: "Paste it anywhere to open this folder.", duration: 3e3 });
      } catch (d) {
        console.error("[CollabSidebar] Failed to copy folder link:", d), g.notify?.({ level: "error", title: "Copy failed", message: "Could not write the link to the clipboard." });
      }
  }, [g, A, re]), Eo = _(async (i) => {
    if (!x || !V("rename this folder")) return;
    const u = i.trim();
    if (!u || u === x.name) {
      P(null), N(null);
      return;
    }
    await S.renameFolder(x.folderId, u), g.trackEvent?.("collab_folder_renamed", {
      actorType: "user",
      source: "sidebar"
    }), P(null), N(null);
  }, [V, x, g, S]), Ko = _(async (i) => {
    if (!H || !V("rename this folder")) return;
    const u = i.trim();
    if (!u || u === H.name) {
      ke(null), N(null);
      return;
    }
    await S.renameLegacyFolder(H.path, u), g.trackEvent?.("collab_folder_renamed", {
      actorType: "user",
      source: "legacy_folder"
    }), ke(null), N(null);
  }, [V, g, H, S]), zt = _((i) => {
    qt(!0), pe((u) => {
      const d = new Set(u);
      return d.has(i) ? d.delete(i) : d.add(i), d;
    });
  }, []);
  ye(() => {
    if (!Xt || kn !== A.scopeKey || Nn || W.length === 0) return;
    const i = /* @__PURE__ */ new Set();
    for (const u of W) {
      const d = Dn(u);
      let v = dt(d);
      for (; v; )
        i.add(v), v = dt(v);
    }
    i.size !== 0 && pe((u) => {
      let d = !1;
      const v = new Set(u);
      for (const F of i)
        v.has(F) || (v.add(F), d = !0);
      return d ? v : u;
    });
  }, [Xt, kn, A.scopeKey, W, Dn, Nn]), ye(() => {
    if (!Qt || Qt.scopeKey !== A.scopeKey || Qt.orgId !== A.orgId) return;
    const i = lt.get(Qt.folderId);
    if (!i) return;
    const u = [], d = /* @__PURE__ */ new Set();
    let v = i;
    for (; v && !d.has(v.folderId); ) {
      d.add(v.folderId);
      const F = Ve.get(v.folderId);
      F && u.push(F), v = v.parentFolderId ? lt.get(v.parentFolderId) : void 0;
    }
    pe((F) => {
      const B = new Set(F);
      for (const U of u) B.add(U);
      return B;
    }), qt(!0), m(i.folderId), $e(Ve.get(i.folderId) ?? null), S.clearPendingFolder();
  }, [lt, Ve, Qt, A, S]);
  const Bt = _(() => {
    if (K && I?.node.type === "item") {
      Mt(I.node.itemId), De("item");
      return;
    }
    const i = I?.node.type === "folder" ? I.node.folderId ?? null : K && I?.node.type === "document" ? I.node.document.documentId : void 0;
    if (K && i === void 0 && (e || n)) {
      Mt(e ?? n ?? null), De(e ? "item" : "page");
      return;
    }
    Mt(Zo(i, st)), De("page");
  }, [n, e, I, K, st]), Zn = _(() => {
    Bt(), Ce(!0), N(null);
  }, [Bt]), Mo = _((i) => {
    Bt(), Ze.refs.setReference(i), Ze.setIsOpen(!0), N(null);
  }, [Bt, Ze.refs, Ze.setIsOpen]), Pn = jt({ applyCreationBaseTarget: Bt, openCreateFolderDialog: Zn });
  Pn.current = { applyCreationBaseTarget: Bt, openCreateFolderDialog: Zn };
  const Ro = en.map(({ descriptor: i }) => `${i.documentType}:${i.defaultExtension}`).join("|");
  ye(() => {
    if (!h) return;
    const i = en.find(
      ({ descriptor: u }) => u.documentType === "markdown"
    );
    return h({
      destination: Ae,
      primaryTrailing: i?.descriptor.defaultExtension,
      onPrimary: () => {
        Pn.current.applyCreationBaseTarget(), i && we(i.descriptor);
      },
      onNewFolder: () => Pn.current.openCreateFolderDialog(),
      pageTree: K,
      // Markdown is the primary action, so it is not repeated in the list.
      items: en.filter(({ descriptor: u }) => u.documentType !== "markdown").map(({ descriptor: u }) => ({
        id: `${u.documentType}:${u.defaultExtension}`,
        label: u.displayName,
        icon: u.icon,
        trailing: u.defaultExtension,
        onSelect: () => {
          Pn.current.applyCreationBaseTarget(), we(u);
        }
      }))
    }), () => h(null);
  }, [h, Ro, Ae, K]);
  const Lo = _((i) => {
    i.capabilities.sharedCreate && (Ze.setIsOpen(!1), we(i));
  }, [Ze.setIsOpen]), Oo = _(async (i) => {
    if (!V("create folders")) return;
    const u = i.trim();
    if (!u) return;
    const d = Kt, v = d ? Ve.get(d) ?? "" : "", F = sn(v, u);
    if (it.has(F)) {
      he("Name already in use", `A document or folder named "${F}" already exists.`);
      return;
    }
    const B = await S.createFolder(u, d);
    g.trackEvent?.("collab_folder_created", {
      actorType: "user",
      source: "sidebar",
      nested: d !== null
    }), pe((U) => {
      const me = new Set(U);
      return me.add(F), v && me.add(v), me;
    }), $e(F), m(B), Ce(!1), N(null);
  }, [V, Kt, it, Ve, g, S, he]), $o = _((i, u = "page") => {
    Mt(i), De(u);
  }, []), zo = _(async (i) => {
    if (!V("create documents")) return;
    const u = xe;
    if (!u) return;
    const d = Kt, v = d !== null && Ue === "item", F = v ? `item:${d}` : d ? Ve.get(d) ?? "" : "";
    try {
      await S.createDocument({
        scope: A,
        descriptor: u,
        requestedName: i,
        parentFolderId: d,
        ...v ? { parentKind: "item" } : {},
        sourceContent: u.creation?.defaultContent ?? ""
      });
    } catch (B) {
      g.reportError?.(B, "Could not create shared document");
      return;
    }
    F && pe((B) => {
      const U = new Set(B);
      return U.add(F), U;
    }), $e(v ? null : F || null), m(v ? null : d), we(null), De("page"), N(null);
  }, [V, xe, Kt, Ue, Ve, g, A, S]), Bo = _(async (i) => {
    if (!fe || !V("rename this document")) return;
    const u = Rn(i.trim()) || i.trim(), d = Ja(u, In.suffix);
    if (!d) {
      qe(null), N(null);
      return;
    }
    if (K) {
      const me = Ut(d, fe.documentType);
      if (me === fe.title) {
        qe(null), N(null);
        return;
      }
      if (q?.pageNameConflict(se, fe, fe.parentFolderId ?? null, fe.parentKind, me)) {
        he("Name already in use", `A page named "${me}" already exists here.`);
        return;
      }
      await S.updateDocumentTitle(fe.documentId, me), ct(g, { action: "renamed", documentType: fe.documentType, entryPoint: "sidebar" }), qe(null), N(null);
      return;
    }
    const v = fe.parentFolderId ?? null, F = v ? Ve.get(v) ?? "" : "", B = sn(F, d), U = Zt(fe);
    if (!B || B === U) {
      qe(null), N(null);
      return;
    }
    if (it.has(B)) {
      he("Name already in use", `A document or folder named "${B}" already exists.`);
      return;
    }
    await S.updateDocumentTitle(fe.documentId, B), ct(g, {
      action: "renamed",
      documentType: fe.documentType,
      entryPoint: "sidebar"
    }), qe(null), N(null);
  }, [V, In.suffix, fe, it, Ve, g, K, q, S, he, Zt, se]), tn = _(async (i, u, d, v = {}) => {
    if (!V("move this document")) return;
    const F = ce.find((U) => U.documentId === i.documentId);
    if (K && F && q) {
      const U = q.movePageInTree(S, se, F, u, v);
      if (U === "taken" && he("Name already in use", `A page named "${Ut(F.title, F.documentType)}" already exists there.`), U === "cycle" && he("Cannot move page", Xr), U !== "moved") return;
      ct(g, { action: "moved", documentType: F.documentType, entryPoint: "sidebar" }), d && pe((me) => new Set(me).add(d));
      return;
    }
    const B = sn(d, i.name);
    if (!(!B || B === i.sourcePath)) {
      if (it.has(B)) {
        he("Name already in use", `A document or folder named "${B}" already exists.`);
        return;
      }
      S.moveDocument(i.documentId, u), await S.updateDocumentTitle(i.documentId, B), ct(g, {
        action: "moved",
        documentType: F?.documentType,
        entryPoint: "sidebar"
      }), d ? (pe((U) => {
        const me = new Set(U);
        return me.add(d), me;
      }), $e(d), m(u)) : ($e(null), m(null));
    }
  }, [ce, V, it, g, K, q, S, he, se]), nn = _(async (i, u) => {
    const d = Fe;
    Ee(null), Hn(null), d && await tn(d, i, u);
  }, [Fe, tn]), yt = _((i) => {
    if (!Fe) return !1;
    const u = sn(i, Fe.name);
    return !u || u === Fe.sourcePath ? !1 : !it.has(u) || u === Fe.sourcePath;
  }, [Fe, it]), bt = _((i) => {
    if (!_e || i === _e.folderId) return !1;
    const u = lt.get(_e.folderId);
    return !(u && (u.parentFolderId ?? null) === i || i && new Set(mr(Q, _e.folderId)).has(i));
  }, [_e, lt, Q]), er = _((i, u) => {
    if (_e) {
      if (!bt(i)) {
        Ee(null), Jt(null);
        return;
      }
      if (!V("move this folder")) {
        Ee(null), Jt(null);
        return;
      }
      S.moveFolder(_e.folderId, i), g.trackEvent?.("collab_folder_moved", {
        actorType: "user",
        source: "sidebar",
        toRoot: i === null
      }), u && pe((d) => new Set(d).add(u)), Ee(null), Jt(null);
    }
  }, [bt, V, _e, g, S]), gt = _((i) => {
    if (!ae) return !1;
    const u = E.find((d) => d.typeId === ae);
    return !!u && (u.parentFolderId ?? null) !== i;
  }, [ae, E]), rn = _((i, u) => {
    const d = ae;
    Ee(null), D(null), !(!d || !V("move this type")) && (S.moveTypePlacement(d, i).catch(ze), u && pe((v) => new Set(v).add(u)));
  }, [V, ae, ze, S]), Uo = _((i) => {
    const u = Te?.parentFolderId ?? null, d = Te?.parentKind;
    if (Ye(null), !V("place this type")) return;
    S.placeType(i, u, d).catch(ze);
    const v = u ? d === "item" ? `item:${u}` : Ve.get(u) : null;
    qt(!0), pe((F) => {
      const B = new Set(F).add(`type:${i}`);
      return v && B.add(v), B;
    });
  }, [V, Ve, Te, ze, S]), vt = _((i, u) => {
    if (!V("move this page")) return;
    const d = q?.moveItemInTree(S, se, i, u);
    d === "cycle" ? he("Cannot move page", Xr) : d?.then((v) => {
      v.ok || ze(new Error(v.error));
    });
  }, [V, q, ze, S, he, se]), Fr = _((i) => {
    const u = z.find((d) => d.itemId === i);
    return u ? u.parentId ?? null : hs;
  }, [z]), _r = _((i, u) => ae ? gt(i) : X ? Fr(X.itemId) !== i : !Fe || i && ea(W, Fe.documentId).includes(i) ? !1 : yt(u), [yt, gt, Fe, X, ae, Fr, W]), jo = _((i, u) => {
    if (ae) {
      rn(i, u);
      return;
    }
    const d = X;
    if (Se(null), Ee(null), d) {
      vt(d.itemId, { parentId: i, parentKind: "page" }), u && pe((v) => new Set(v).add(u));
      return;
    }
    nn(i, u);
  }, [X, ae, nn, rn, vt]), tr = _((i) => {
    q?.applyPageTreeWrite(S, i, ze);
  }, [q, ze, S]), xt = _(() => {
    D(null), Se(null), Hn(null), Ee(null), ee(null);
  }, []), Er = _((i, u, d) => {
    if (xt(), i.kind === "unplace-item") {
      vt(i.itemId, { underType: !0 });
      return;
    }
    if (V(i.kind === "type" ? "move this type" : "move this page")) {
      for (const v of i.renumber ?? []) tr(v);
      if (i.kind === "page") {
        const v = ce.find((F) => F.documentId === i.documentId);
        tn(
          { documentId: i.documentId, sourcePath: v ? Zt(v) : "", name: v?.title ?? "" },
          i.parentId,
          null,
          { parentKind: i.parentKind, sortOrder: i.sortOrder }
        );
      } else
        tr(i);
      u === "inside" && pe((v) => new Set(v).add(d.type === "item" ? d.id : d.path));
    }
  }, [ce, tr, V, xt, vt, Zt, tn]), An = _((i) => q ? q.pageTreeRowDrop({
    tree: se,
    dragged: ae ? { kind: "type", typeId: ae } : X ? { kind: "item", itemId: X.itemId, typeId: X.typeId } : Fe ? { kind: "page", documentId: Fe.documentId } : null,
    documents: ce,
    dropIndicator: at,
    dropTargetPath: ot,
    setDropIndicator: ee,
    setDropTargetPath: Ee,
    onDropPlan: Er
  }, i) : Ps, [ce, Fe, X, ae, at, ot, Er, q, se]), Kr = jt(() => null), nr = L(() => K ? {
    onContextMenu: (i, u) => $t(i, u),
    onDragStart: Se,
    onDragEnd: xt,
    rowDrop: An,
    isExpanded: (i) => Oe.has(i.id),
    onToggle: (i) => zt(i.id),
    renderChildren: (i, u) => Kr.current(i, (u - 8) / 16)
  } : void 0, [xt, Oe, $t, K, An, zt]), on = _((i, u = 0) => i.map((d) => {
    const v = u * 16 + 8;
    if (d.type === "item")
      return K ? /* @__PURE__ */ s(
        Io,
        {
          node: d,
          position: 0,
          indent: v,
          onOpen: (Y) => g.openArtifact({ kind: "tracker", scope: A, trackerId: d.itemId }, "sidebar", Y),
          actions: nr
        },
        d.id
      ) : null;
    if (d.type === "type")
      return /* @__PURE__ */ s(
        ys,
        {
          node: d,
          indent: v,
          expanded: Oe.has(d.id),
          onToggle: () => zt(d.id),
          onOpenType: (Y, an) => g.openArtifact({ kind: "type", scope: A, typeId: Y }, "sidebar", an),
          onOpenItem: (Y, an) => g.openArtifact({ kind: "tracker", scope: A, trackerId: Y }, "sidebar", an),
          onContextMenu: (Y) => $t(Y, d),
          onDragStart: D,
          onDragEnd: xt,
          renderSubtypes: (Y) => on(Y, u + 1),
          itemActions: nr
        },
        d.id
      );
    if (d.type === "folder") {
      const Y = Oe.has(d.path), an = Ae === d.path, Ho = ot === d.path;
      return /* @__PURE__ */ b("div", { children: [
        /* @__PURE__ */ b(
          "button",
          {
            className: `w-full flex items-center text-left file-tree-directory${an ? " selected" : ""}${Ho ? " drag-over" : ""}`,
            style: { paddingLeft: v },
            draggable: !!d.folderId,
            onDragStart: (de) => {
              d.folderId && (de.stopPropagation(), de.dataTransfer.effectAllowed = "move", de.dataTransfer.setData("text/plain", d.folderId), Jt({ folderId: d.folderId, name: d.name }));
            },
            onDragEnd: () => {
              Jt(null), Ee(null);
            },
            onClick: () => {
              zt(d.path), $e(d.path), m(d.folderId ?? null), p?.(d.folderId ?? null);
            },
            onContextMenu: (de) => $t(de, d),
            onDragOver: (de) => {
              (ae ? d.folderId && gt(d.folderId) : _e ? bt(d.folderId ?? null) : yt(d.path)) && (de.preventDefault(), de.stopPropagation(), de.dataTransfer.dropEffect = "move", ot !== d.path && Ee(d.path));
            },
            onDragLeave: (de) => {
              de.stopPropagation();
              const or = de.relatedTarget;
              or && de.currentTarget.contains(or) || ot === d.path && Ee(null);
            },
            onDrop: (de) => {
              if (ae) {
                if (!d.folderId || !gt(d.folderId)) return;
                de.preventDefault(), de.stopPropagation(), rn(d.folderId, d.path);
                return;
              }
              if (_e) {
                if (!bt(d.folderId ?? null)) return;
                de.preventDefault(), de.stopPropagation(), er(d.folderId ?? null, d.path);
                return;
              }
              yt(d.path) && (de.preventDefault(), de.stopPropagation(), nn(d.folderId ?? null, d.path));
            },
            title: d.path,
            children: [
              /* @__PURE__ */ s("span", { className: "file-tree-chevron", children: /* @__PURE__ */ s(
                k,
                {
                  icon: Y ? "keyboard_arrow_down" : "keyboard_arrow_right",
                  size: 16
                }
              ) }),
              /* @__PURE__ */ s("span", { className: "file-tree-icon", children: /* @__PURE__ */ s(k, { icon: Y ? "folder_open" : "folder", size: 18 }) }),
              /* @__PURE__ */ s("span", { className: "file-tree-name", children: d.name })
            ]
          }
        ),
        Y ? on(d.children, u + 1) : null
      ] }, d.id);
    }
    const F = d.document.documentId === n;
    if (d.document.decryptFailed === !0)
      return /* @__PURE__ */ b(
        "button",
        {
          type: "button",
          disabled: !0,
          "data-testid": "collab-sidebar-locked-doc",
          className: "w-full flex items-center text-left file-tree-file opacity-60 cursor-not-allowed",
          style: { paddingLeft: v },
          title: "This document's title is encrypted with a key your account does not currently have. Ask a team admin to refresh / rewrap your key envelope, then reopen the workspace.",
          children: [
            /* @__PURE__ */ s("span", { className: "file-tree-spacer" }),
            /* @__PURE__ */ s("span", { className: "file-tree-icon", children: /* @__PURE__ */ s(k, { icon: "lock", size: 16 }) }),
            /* @__PURE__ */ s("span", { className: "file-tree-name italic text-[var(--nim-text-faint)]", children: "Encrypted document (key unavailable)" })
          ]
        },
        d.id
      );
    const U = ve.has(d.document.documentId), me = Cr(d.document, je), Fn = (d.children?.length ?? 0) > 0, _n = Fn && Oe.has(d.path), { className: Vo = "", ...Wo } = K ? An(d) : {}, $r = /* @__PURE__ */ b(
      gr,
      {
        href: g.surface === "web_console" ? g.artifactUrl?.({ kind: "document", scope: A, documentId: d.document.documentId, teamProjectId: d.document.teamProjectId }) : null,
        className: `group w-full flex items-center text-left file-tree-file${F ? " active" : ""}${Vo}`,
        style: { paddingLeft: v },
        ...Wo,
        onClick: (Y) => {
          $e(dt(d.path)), g.openArtifact({
            kind: "document",
            scope: A,
            documentId: d.document.documentId,
            teamProjectId: d.document.teamProjectId
          }, "sidebar", vr(Y));
        },
        onContextMenu: (Y) => $t(Y, d),
        draggable: !0,
        onDragStart: (Y) => {
          Y.dataTransfer.effectAllowed = "copyMove", Y.dataTransfer.setData("text/plain", d.document.documentId), Y.dataTransfer.setData(
            Ds,
            JSON.stringify({
              orgId: A.orgId,
              documentId: d.document.documentId,
              title: d.name
            })
          ), Hn({
            documentId: d.document.documentId,
            sourcePath: d.path,
            name: d.name
          });
        },
        onDragEnd: xt,
        title: d.path,
        children: [
          Fn ? /* @__PURE__ */ s(
            "span",
            {
              className: "file-tree-chevron",
              role: "button",
              "aria-label": _n ? "Collapse" : "Expand",
              onClick: (Y) => {
                Y.preventDefault(), Y.stopPropagation(), zt(d.path);
              },
              children: /* @__PURE__ */ s(k, { icon: _n ? "keyboard_arrow_down" : "keyboard_arrow_right", size: 16 })
            }
          ) : /* @__PURE__ */ s("span", { className: "file-tree-spacer" }),
          /* @__PURE__ */ s("span", { className: "file-tree-icon", children: Fn && d.document.hasContent === !1 ? /* @__PURE__ */ s(k, { icon: _n ? "folder_open" : "folder", size: 18 }) : /* @__PURE__ */ s(k, { icon: me.icon, size: 16 }) }),
          /* @__PURE__ */ s("span", { className: "file-tree-name", children: K ? Ut(d.name, d.document.documentType) : d.name }),
          ue && /* @__PURE__ */ s(
            "span",
            {
              role: "button",
              tabIndex: -1,
              "aria-label": U ? "Unfavorite" : "Favorite",
              "aria-pressed": U,
              title: U ? "Unfavorite" : "Favorite",
              className: `collab-fav-star ml-auto mr-0.5 flex items-center justify-center cursor-pointer transition-opacity ${U ? "text-[var(--nim-warning)] opacity-100" : "text-[var(--nim-text-faint)] opacity-0 group-hover:opacity-70 hover:!opacity-100"}`,
              onClick: (Y) => {
                Y.preventDefault(), Y.stopPropagation(), S.toggleFavorite(d.document.documentId);
              },
              children: /* @__PURE__ */ s(k, { icon: "star", size: 14, fill: U })
            }
          ),
          Re && ft && /* @__PURE__ */ s(Ns, { documentId: d.document.documentId, className: "mr-1" })
        ]
      },
      d.id
    );
    return Fn ? /* @__PURE__ */ b("div", { children: [
      $r,
      _n ? on(d.children ?? [], u + 1) : null
    ] }, d.id) : $r;
  }), [
    K,
    nr,
    An,
    xt,
    n,
    yt,
    bt,
    gt,
    _e,
    ae,
    rn,
    ot,
    Oe,
    $t,
    nn,
    er,
    Ae,
    zt,
    ve,
    ue,
    Re,
    ft,
    Qe,
    je,
    g,
    S,
    A
  ]);
  Kr.current = on, Ae && Rn(Ae);
  const G = I?.node.type === "document" ? I.node.document : null, Ke = (O.useLocalOrigin ?? $s)(
    A.scopeKey,
    G?.documentId,
    G?.documentType
  ), Mr = /* @__PURE__ */ b(Ie, { children: [
    l,
    Re && /* @__PURE__ */ s(
      "button",
      {
        ref: Lt.refs.setReference,
        ...Lt.getReferenceProps(),
        type: "button",
        className: "workspace-action-button bg-transparent border-none p-1.5 cursor-pointer rounded text-[var(--nim-text-faint)] flex items-center justify-center transition-all duration-200 relative hover:bg-[var(--nim-bg-hover)] hover:text-[var(--nim-text)]",
        title: "Shared document options",
        "aria-label": "Shared document options",
        onClick: () => {
          ht((i) => !i), N(null);
        },
        children: /* @__PURE__ */ s(k, { icon: "more_horiz", size: 16 })
      }
    )
  ] }), Rr = M ? /* @__PURE__ */ b(Ie, { children: [
    /* @__PURE__ */ s("h3", { className: "collab-sidebar-section-title m-0 text-[11px] font-semibold uppercase tracking-wide text-[var(--nim-text-muted)]", children: M }),
    /* @__PURE__ */ s("span", { className: "text-[11px] text-[var(--nim-text-faint)] whitespace-nowrap", children: /* @__PURE__ */ s(Qr, { status: Je, personal: Z }) })
  ] }) : null, Lr = (i) => {
    mt && (i.preventDefault(), N(null), Xe({ x: i.clientX, y: i.clientY }));
  }, Or = Me && /* @__PURE__ */ s(
    gs,
    {
      x: Me.x,
      y: Me.y,
      onNewPage: () => Ot(null),
      onPlaceType: y ? () => {
        Xe(null), T && $?.(), Ye({ ...Me, parentFolderId: null });
      } : void 0,
      extraItems: c,
      onClose: () => Xe(null)
    }
  ), rr = M ? /* @__PURE__ */ b(
    "div",
    {
      className: "collab-sidebar-section-header flex items-center gap-2 px-3 pt-2 pb-1.5 border-b border-[var(--nim-border)] shrink-0",
      "data-testid": `collab-sidebar-section-${Z ? "personal" : "team"}`,
      onContextMenu: Lr,
      children: [
        $ ? /* @__PURE__ */ b(
          "button",
          {
            type: "button",
            className: "collab-sidebar-section-toggle flex items-center gap-2 min-w-0 -ml-1 pl-0.5 pr-1 py-0 bg-transparent border-none rounded cursor-pointer hover:bg-[var(--nim-bg-hover)]",
            "aria-expanded": !T,
            onClick: $,
            children: [
              /* @__PURE__ */ s(k, { icon: T ? "chevron_right" : "expand_more", size: 16, className: "text-[var(--nim-text-faint)]" }),
              Rr
            ]
          }
        ) : Rr,
        !T && /* @__PURE__ */ s("div", { className: "ml-auto flex items-center gap-1", children: Mr })
      ]
    }
  ) : null;
  return rr && T ? /* @__PURE__ */ b(
    "div",
    {
      className: "collab-sidebar collab-sidebar-collapsed w-full flex flex-col bg-nim-secondary border-r border-nim",
      "data-testid": Z ? "collab-sidebar-personal" : "collab-sidebar",
      children: [
        rr,
        Or
      ]
    }
  ) : /* @__PURE__ */ b(
    "div",
    {
      className: "collab-sidebar w-full h-full flex flex-col bg-nim-secondary border-r border-nim overflow-hidden",
      "data-testid": Z ? "collab-sidebar-personal" : "collab-sidebar",
      children: [
        rr ?? /* @__PURE__ */ s(
          ps,
          {
            scopeKey: A.scopeKey,
            scopeName: o,
            scopePath: a,
            subtitle: /* @__PURE__ */ s(Qr, { status: Je, personal: Z }),
            actionsClassName: "gap-1",
            actions: Mr
          }
        ),
        Yt.length > 1 && /* @__PURE__ */ s("div", { className: "collab-tree-filter px-3 py-2 border-b border-[var(--nim-border)] shrink-0", children: /* @__PURE__ */ s("div", { className: "flex bg-[var(--nim-bg-secondary)] border border-[var(--nim-border)] rounded-md p-0.5", children: Yt.map((i) => {
          const u = Le === i.key;
          return /* @__PURE__ */ b(
            "button",
            {
              type: "button",
              className: `flex-1 flex items-center justify-center gap-1 text-[11.5px] py-1 px-1.5 rounded transition-colors ${u ? "bg-[var(--nim-bg-tertiary)] text-[var(--nim-text)]" : "text-[var(--nim-text-faint)] hover:text-[var(--nim-text-muted)]"}`,
              "aria-pressed": u,
              onClick: () => f.set(S.atoms.treeFilter, i.key),
              children: [
                i.icon && /* @__PURE__ */ s(
                  k,
                  {
                    icon: i.icon,
                    size: 13,
                    fill: i.key === "favorites" && u,
                    className: u ? "text-[var(--nim-warning)]" : void 0
                  }
                ),
                i.label
              ]
            },
            i.key
          );
        }) }) }),
        /* @__PURE__ */ b(
          "div",
          {
            className: `collab-sidebar-tree flex-1 overflow-y-auto px-1.5 py-2 transition-colors ${ot === "__root__" ? "bg-nim-hover" : ""}`,
            onContextMenu: (i) => {
              i.target.closest(".file-tree-directory, .file-tree-file") || Lr(i);
            },
            onDragOver: (i) => {
              !(K ? _r(null, null) : ae ? gt(null) : _e ? bt(null) : yt(null)) || i.target.closest(".file-tree-directory, .file-tree-file") || (i.preventDefault(), i.dataTransfer.dropEffect = "move", ot !== "__root__" && Ee("__root__"));
            },
            onDragLeave: (i) => {
              if (i.target.closest(".file-tree-directory, .file-tree-file")) return;
              const d = i.relatedTarget;
              d && i.currentTarget.contains(d) || ot === "__root__" && Ee(null);
            },
            onDrop: (i) => {
              if (!i.target.closest(".file-tree-directory, .file-tree-file")) {
                if (K) {
                  if (!_r(null, null)) return;
                  i.preventDefault(), jo(null, null);
                  return;
                }
                if (ae) {
                  if (!gt(null)) return;
                  i.preventDefault(), rn(null, null);
                  return;
                }
                if (_e) {
                  if (!bt(null)) return;
                  i.preventDefault(), er(null, null);
                  return;
                }
                yt(null) && (i.preventDefault(), nn(null, null));
              }
            },
            children: [
              r,
              (() => {
                if (!Xt || (Je === "connecting" || Je === "syncing") || K && !q)
                  return /* @__PURE__ */ b("div", { className: "px-2 py-4 text-center", "data-testid": "collab-sidebar-loading", children: [
                    /* @__PURE__ */ s(
                      k,
                      {
                        icon: "cloud_sync",
                        size: 32,
                        className: "text-nim-faint mb-2 animate-pulse"
                      }
                    ),
                    /* @__PURE__ */ s("p", { className: "text-xs text-nim-faint m-0", children: "Loading shared documents..." })
                  ] });
                const u = se.length === 0 ? "empty" : Tr.length > 0 || Le === "all" ? null : Le;
                return u ? /* @__PURE__ */ s(
                  xs,
                  {
                    reason: u,
                    personal: Z,
                    scopeAvailable: mt,
                    onNewPage: Qn ? () => Ot(null) : void 0
                  }
                ) : /* @__PURE__ */ s(Nr.Provider, { value: To, children: /* @__PURE__ */ s("div", { children: on(Tr) }) });
              })()
            ]
          }
        ),
        mt && /* @__PURE__ */ s(Is, { sectionLabel: M ?? (Z ? "Personal" : "Team") }),
        Re && Lt.isOpen && /* @__PURE__ */ s(Vt, { children: /* @__PURE__ */ b(
          "div",
          {
            ref: Lt.refs.setFloating,
            style: Lt.floatingStyles,
            ...Lt.getFloatingProps(),
            className: "min-w-[224px] rounded-md z-[10000] text-[13px] p-1 bg-nim-secondary border border-nim text-nim backdrop-blur-[10px] shadow-lg",
            children: [
              /* @__PURE__ */ b(
                "button",
                {
                  type: "button",
                  className: "w-full flex items-center gap-2.5 px-3 py-1.5 rounded border-none bg-transparent cursor-pointer transition-colors text-left text-nim hover:bg-nim-hover",
                  onClick: () => f.set(S.atoms.showUnreadBubbles, !ft),
                  children: [
                    /* @__PURE__ */ s(k, { icon: "notifications", size: 18 }),
                    /* @__PURE__ */ s("span", { className: "flex-1", children: "Show unread bubbles" }),
                    /* @__PURE__ */ s(
                      k,
                      {
                        icon: ft ? "toggle_on" : "toggle_off",
                        size: 20,
                        className: ft ? "text-[var(--nim-primary)]" : "text-[var(--nim-text-faint)]"
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ b(
                "button",
                {
                  type: "button",
                  className: "w-full flex items-center gap-2.5 px-3 py-1.5 rounded border-none bg-transparent cursor-pointer transition-colors text-left text-nim hover:bg-nim-hover disabled:opacity-50 disabled:cursor-not-allowed",
                  disabled: !re || _t.size === 0,
                  onClick: Po,
                  children: [
                    /* @__PURE__ */ s(k, { icon: "done_all", size: 18 }),
                    /* @__PURE__ */ s("span", { children: "Mark all as read" })
                  ]
                }
              )
            ]
          }
        ) }),
        Ze.isOpen && /* @__PURE__ */ s(Vt, { children: /* @__PURE__ */ s(
          "div",
          {
            ref: Ze.refs.setFloating,
            style: Ze.floatingStyles,
            ...Ze.getFloatingProps(),
            className: "z-[10000]",
            children: /* @__PURE__ */ s(
              ls,
              {
                items: en,
                onSelect: Lo
              }
            )
          }
        ) }),
        I && /* @__PURE__ */ s(Vt, { children: /* @__PURE__ */ s(
          "div",
          {
            ref: Xn.refs.setFloating,
            style: Xn.floatingStyles,
            ...Xn.getFloatingProps(),
            className: "min-w-[160px] rounded-md z-[10000] text-[13px] p-1 bg-nim-secondary border border-nim text-nim backdrop-blur-[10px] shadow-lg",
            children: /* @__PURE__ */ s(be.Suspense, { fallback: null, children: I.node.type === "folder" ? /* @__PURE__ */ b(Ie, { children: [
              /* @__PURE__ */ b(
                "button",
                {
                  type: "button",
                  className: "w-full flex items-center gap-2.5 px-3 py-1.5 rounded border-none bg-transparent cursor-pointer transition-colors text-left text-nim hover:bg-nim-hover",
                  onClick: (i) => Mo(i.currentTarget),
                  children: [
                    /* @__PURE__ */ s(k, { icon: "note_add", size: 18 }),
                    /* @__PURE__ */ s("span", { children: "New Document" })
                  ]
                }
              ),
              /* @__PURE__ */ b(
                "button",
                {
                  type: "button",
                  className: "w-full flex items-center gap-2.5 px-3 py-1.5 rounded border-none bg-transparent cursor-pointer transition-colors text-left text-nim hover:bg-nim-hover",
                  onClick: Zn,
                  children: [
                    /* @__PURE__ */ s(k, { icon: "create_new_folder", size: 18 }),
                    /* @__PURE__ */ s("span", { children: "New Folder" })
                  ]
                }
              ),
              y && /* @__PURE__ */ b(
                "button",
                {
                  type: "button",
                  className: "collab-place-type-action w-full flex items-center gap-2.5 px-3 py-1.5 rounded border-none bg-transparent cursor-pointer transition-colors text-left text-nim hover:bg-nim-hover disabled:opacity-50 disabled:cursor-not-allowed",
                  disabled: !I.node.folderId,
                  onClick: () => {
                    I.node.type !== "folder" || !I.node.folderId || (Ye({ x: I.x, y: I.y, parentFolderId: I.node.folderId }), N(null));
                  },
                  children: [
                    /* @__PURE__ */ s(k, { icon: "table", size: 18 }),
                    /* @__PURE__ */ s("span", { children: "Place type..." })
                  ]
                }
              ),
              /* @__PURE__ */ b(
                "button",
                {
                  type: "button",
                  className: "w-full flex items-center gap-2.5 px-3 py-1.5 rounded border-none bg-transparent cursor-pointer transition-colors text-left text-nim hover:bg-nim-hover disabled:opacity-50 disabled:cursor-not-allowed",
                  onClick: () => {
                    if (I.node.type !== "folder") return;
                    const { folderId: i } = I.node;
                    if (i) {
                      const u = lt.get(i);
                      u && P(u);
                    } else
                      ke({ path: I.node.path, name: I.node.name });
                    N(null);
                  },
                  children: [
                    /* @__PURE__ */ s(k, { icon: "edit", size: 18 }),
                    /* @__PURE__ */ s("span", { children: "Rename" })
                  ]
                }
              ),
              /* @__PURE__ */ b(
                "button",
                {
                  type: "button",
                  className: "w-full flex items-center gap-2.5 px-3 py-1.5 rounded border-none bg-transparent cursor-pointer transition-colors text-left text-nim hover:bg-nim-hover disabled:opacity-50 disabled:cursor-not-allowed",
                  disabled: !re || !I.node.folderId,
                  title: re ? void 0 : "No team is connected to this workspace",
                  onClick: () => {
                    const i = I.node.type === "folder" ? I.node.folderId : void 0;
                    N(null), i && _o(i);
                  },
                  children: [
                    /* @__PURE__ */ s(k, { icon: "link", size: 18 }),
                    /* @__PURE__ */ s("span", { children: "Copy Link" })
                  ]
                }
              ),
              /* @__PURE__ */ s("div", { className: "my-1 border-t border-[var(--nim-border)]" }),
              /* @__PURE__ */ b(
                "button",
                {
                  type: "button",
                  className: "w-full flex items-center gap-2.5 px-3 py-1.5 rounded border-none bg-transparent cursor-pointer transition-colors text-left text-[var(--nim-error)] hover:bg-nim-hover disabled:opacity-50 disabled:cursor-not-allowed",
                  disabled: !I.node.folderId,
                  onClick: qn,
                  children: [
                    /* @__PURE__ */ s(k, { icon: "delete", size: 18 }),
                    /* @__PURE__ */ s("span", { children: "Delete" })
                  ]
                }
              )
            ] }) : I.node.type === "type" ? /* @__PURE__ */ b(Ie, { children: [
              K && /* @__PURE__ */ s(
                Be,
                {
                  className: "collab-type-move-to",
                  icon: "drive_file_move",
                  label: "Move to...",
                  disabled: Gn.has(I.node.typeId),
                  title: Gn.has(I.node.typeId) ? "Shown inside the type it extends" : void 0,
                  onClick: () => {
                    I.node.type === "type" && Pe({ kind: "type", node: I.node }), N(null);
                  }
                }
              ),
              /* @__PURE__ */ b(
                "button",
                {
                  type: "button",
                  className: "collab-remove-type-placement w-full flex items-center gap-2.5 px-3 py-1.5 rounded border-none bg-transparent cursor-pointer transition-colors text-left text-nim hover:bg-nim-hover",
                  onClick: () => {
                    I.node.type === "type" && (N(null), Ar(I.node.typeId));
                  },
                  children: [
                    /* @__PURE__ */ s(k, { icon: "playlist_remove", size: 18 }),
                    /* @__PURE__ */ s("span", { children: "Remove from tree" })
                  ]
                }
              ),
              /* @__PURE__ */ s(
                Rs,
                {
                  onClick: () => {
                    if (I.node.type !== "type") return;
                    const { typeId: i } = I.node;
                    N(null), g.openArtifact({ kind: "type", scope: A, typeId: i }, "history");
                  }
                }
              )
            ] }) : I.node.type === "item" ? /* @__PURE__ */ s(
              Ms,
              {
                onNewPageInside: () => {
                  I.node.type === "item" && Ot(I.node.itemId, "item");
                },
                onPlaceType: y ? () => {
                  I.node.type === "item" && (Ye({ x: I.x, y: I.y, parentFolderId: I.node.itemId, parentKind: "item" }), N(null));
                } : void 0,
                placed: I.node.placed === !0,
                onMoveTo: () => {
                  I.node.type === "item" && Pe({ kind: "item", node: I.node }), N(null);
                },
                onBackUnderType: () => {
                  I.node.type === "item" && vt(I.node.itemId, { underType: !0 }), N(null);
                },
                onHistory: () => {
                  if (I.node.type !== "item") return;
                  const { itemId: i } = I.node;
                  N(null), g.openArtifact({ kind: "tracker", scope: A, trackerId: i }, "history");
                },
                onArchive: C ? () => {
                  if (I.node.type !== "item") return;
                  const { itemId: i, name: u } = I.node;
                  N(null), sr(
                    "Archive page",
                    `Archive "${u}"? It leaves the Wiki and its type's table, with its comments and sessions kept. Restore it from its tracker's Archived view.`,
                    "Archive"
                  ).then((d) => {
                    d && C(i).catch(ze);
                  });
                } : void 0
              }
            ) : /* @__PURE__ */ b(Ie, { children: [
              K && G ? /* @__PURE__ */ s(
                Es,
                {
                  onNewPageInside: () => Ot(G.documentId),
                  onSetType: oe ? () => {
                    N(null), oe(G);
                  } : void 0,
                  onPlaceType: y ? () => {
                    Ye({ x: I.x, y: I.y, parentFolderId: G.documentId }), N(null);
                  } : void 0,
                  onRename: () => {
                    qe(G), N(null);
                  },
                  onMoveTo: () => {
                    Pe({ kind: "page", document: G }), N(null);
                  },
                  onCopyLink: () => {
                    N(null), Pr(G);
                  },
                  copyLinkDisabled: !re
                }
              ) : /* @__PURE__ */ s(
                Be,
                {
                  icon: "open_in_new",
                  label: "Open",
                  onClick: () => {
                    G && (g.openArtifact({ kind: "document", scope: A, documentId: G.documentId, teamProjectId: G.teamProjectId }, "sidebar"), N(null));
                  }
                }
              ),
              ue && G && /* @__PURE__ */ s(
                Be,
                {
                  icon: "star",
                  fill: ve.has(G.documentId),
                  label: ve.has(G.documentId) ? "Unfavorite" : "Favorite",
                  onClick: () => {
                    Ao(G), N(null);
                  }
                }
              ),
              Re && /* @__PURE__ */ s(
                Be,
                {
                  icon: "mark_email_read",
                  label: "Mark as read",
                  disabled: !re || !G || !_t.has(G.documentId),
                  onClick: () => {
                    G && (Fo(G), N(null));
                  }
                }
              ),
              !K && /* @__PURE__ */ s(
                Be,
                {
                  icon: "link",
                  label: "Copy Link",
                  disabled: !re,
                  title: re ? void 0 : "No team is connected to this workspace",
                  onClick: () => {
                    G && (N(null), Pr(G));
                  }
                }
              ),
              /* @__PURE__ */ s(
                Be,
                {
                  icon: "history",
                  label: "View History",
                  disabled: !re,
                  title: re ? void 0 : "No team is connected to this workspace",
                  onClick: () => {
                    !G || !re || (N(null), g.openArtifact({ kind: "document", scope: A, documentId: G.documentId, teamProjectId: G.teamProjectId }, "history"));
                  }
                }
              ),
              !K && /* @__PURE__ */ s(
                Be,
                {
                  icon: "edit",
                  label: "Rename",
                  onClick: () => {
                    G && (qe(G), N(null));
                  }
                }
              ),
              Ke.available ? /* @__PURE__ */ b(Ie, { children: [
                /* @__PURE__ */ s(
                  Be,
                  {
                    icon: "draft",
                    label: "Open Local Source",
                    disabled: !Ke.hasResolvedBinding || Ke.busyAction !== null,
                    onClick: () => {
                      N(null), Ke.openLocalSource();
                    }
                  }
                ),
                /* @__PURE__ */ s(
                  Be,
                  {
                    icon: "upload",
                    label: "Re-upload From Local",
                    disabled: !Ke.binding || Ke.busyAction !== null,
                    onClick: () => {
                      N(null), Ke.reuploadFromLocalSource();
                    }
                  }
                ),
                /* @__PURE__ */ s(
                  Be,
                  {
                    icon: "link",
                    label: Ke.binding ? "Relink Local Source..." : "Link Local Source...",
                    disabled: Ke.busyAction !== null,
                    onClick: () => {
                      N(null), Ke.relinkLocalSource();
                    }
                  }
                ),
                Ke.binding && /* @__PURE__ */ s(
                  Be,
                  {
                    icon: "link_off",
                    label: "Clear Local Source",
                    disabled: Ke.busyAction !== null,
                    onClick: () => {
                      N(null), Ke.clearLocalSource();
                    }
                  }
                )
              ] }) : null,
              K && G ? /* @__PURE__ */ s(
                Ks,
                {
                  childCount: Ln(ce, E, G.documentId).childCount,
                  onDelete: qn
                }
              ) : /* @__PURE__ */ s(Be, { icon: "delete", danger: !0, label: "Move to Trash", onClick: qn })
            ] }) })
          }
        ) }),
        ie && /* @__PURE__ */ s(be.Suspense, { fallback: null, children: /* @__PURE__ */ s(
          Ls,
          {
            name: ie.kind === "page" ? Ut(ie.document.title, ie.document.documentType) : ie.node.name,
            tree: se,
            movingNodeId: ie.kind === "page" ? `document:${ie.document.documentId}` : ie.node.id,
            rootLabel: Z ? "Personal" : "Team",
            underTypeLabel: ie.kind === "item" ? `Under ${y?.typeName(ie.node.typeId) ?? "its type"}` : void 0,
            onConfirm: (i) => {
              const u = ie;
              if (Pe(null), u.kind === "item") {
                vt(u.node.itemId, i);
                return;
              }
              if ("underType" in i) return;
              const { parentId: d, parentKind: v } = i;
              if (u.kind === "type") {
                V("move this type") && S.moveTypePlacement(u.node.typeId, d, void 0, v).catch(ze);
                return;
              }
              const { document: F } = u;
              tn(
                { documentId: F.documentId, sourcePath: Zt(F), name: F.title },
                d,
                null,
                { parentKind: v }
              );
            },
            onCancel: () => Pe(null)
          }
        ) }),
        Or,
        Te && /* @__PURE__ */ s(
          bs,
          {
            x: Te.x,
            y: Te.y,
            types: pt,
            onPlace: Uo,
            onClose: () => Ye(null)
          }
        ),
        /* @__PURE__ */ s(
          Yr,
          {
            isOpen: xe !== null,
            kind: "document",
            documentDescriptor: xe ?? void 0,
            folders: Q,
            tree: K ? se : void 0,
            documentTypeDescriptors: je,
            rootLabel: K ? Z ? "Personal" : "Team" : void 0,
            targetFolderId: Kt,
            targetParentKind: Ue,
            onTargetFolderChange: $o,
            onConfirm: zo,
            onCancel: () => {
              we(null), De("page"), N(null);
            }
          }
        ),
        /* @__PURE__ */ s(
          Yr,
          {
            isOpen: wn,
            kind: "folder",
            folders: Q,
            targetFolderId: Kt,
            onTargetFolderChange: Mt,
            onConfirm: Oo,
            onCancel: () => {
              Ce(!1), N(null);
            }
          }
        ),
        /* @__PURE__ */ s(
          lr,
          {
            isOpen: fe !== null,
            title: "Rename Shared Document",
            placeholder: "Document name",
            defaultValue: In.baseName,
            suffix: K && fe?.documentType === "markdown" ? void 0 : In.suffix,
            confirmLabel: "Rename",
            onConfirm: Bo,
            onCancel: () => {
              qe(null), N(null);
            }
          }
        ),
        /* @__PURE__ */ s(
          lr,
          {
            isOpen: x !== null,
            title: "Rename Shared Folder",
            placeholder: "Folder name",
            defaultValue: x?.name ?? "",
            confirmLabel: "Rename",
            onConfirm: Eo,
            onCancel: () => {
              P(null), N(null);
            }
          }
        ),
        /* @__PURE__ */ s(
          lr,
          {
            isOpen: H !== null,
            title: "Rename Shared Folder",
            placeholder: "Folder name",
            defaultValue: H?.name ?? "",
            confirmLabel: "Rename",
            onConfirm: Ko,
            onCancel: () => {
              ke(null), N(null);
            }
          }
        )
      ]
    }
  );
}, zs = [
  { id: "home", icon: "home", label: "Home" },
  { id: "search", icon: "manage_search", label: "Search" },
  { id: "types", icon: "category", label: "Types" }
], ji = ({ active: n, onOpenHome: e, onOpenSearch: t, onOpenTypes: r }) => {
  const o = { home: e, search: t, types: r };
  return /* @__PURE__ */ s("div", { className: "pages-section-entries mb-1 border-b border-[var(--nim-border)] pb-1", role: "group", "aria-label": "Section", children: zs.filter((a) => o[a.id]).map((a) => /* @__PURE__ */ b(
    "button",
    {
      type: "button",
      className: `pages-section-entry file-tree-file w-full flex items-center text-left${n === a.id ? " active" : ""}`,
      style: { paddingLeft: 8 },
      "data-entry": a.id,
      "aria-current": n === a.id ? "page" : void 0,
      onClick: (l) => o[a.id]?.({ newTab: l.metaKey || l.ctrlKey }),
      children: [
        /* @__PURE__ */ s("span", { className: "file-tree-spacer" }),
        /* @__PURE__ */ s("span", { className: "file-tree-icon", children: /* @__PURE__ */ s(k, { icon: a.icon, size: 16 }) }),
        /* @__PURE__ */ s("span", { className: "file-tree-name", children: a.label })
      ]
    },
    a.id
  )) });
};
function Vi({
  value: n,
  onChange: e,
  placeholder: t,
  label: r,
  className: o = "",
  autoFocus: a = !1
}) {
  const l = r ?? t, c = n.trim().length > 0;
  return /* @__PURE__ */ b("div", { className: `collab-search-input relative ${o}`, children: [
    /* @__PURE__ */ s(
      "input",
      {
        type: "text",
        className: "collab-search-input-field nim-input w-full pl-3 pr-9 py-2 text-[13px] text-[var(--nim-text)] bg-[var(--nim-bg-secondary)] border border-[var(--nim-border)] rounded outline-none transition-colors duration-150 placeholder:text-[var(--nim-text-faint)] focus:border-[var(--nim-primary)] focus:bg-[var(--nim-bg)]",
        placeholder: t,
        value: n,
        onChange: (p) => e(p.target.value),
        "aria-label": l,
        autoFocus: a
      }
    ),
    c && /* @__PURE__ */ s(
      "button",
      {
        type: "button",
        className: "collab-search-input-clear absolute right-2 top-1/2 -translate-y-1/2 flex items-center justify-center w-5 h-5 rounded text-[var(--nim-text-muted)] bg-transparent border-none cursor-pointer transition-colors duration-150 hover:bg-[var(--nim-bg-hover)] hover:text-[var(--nim-text)]",
        onClick: () => e(""),
        "aria-label": `Clear ${l.toLowerCase()}`,
        title: "Clear search",
        children: /* @__PURE__ */ s("svg", { width: "12", height: "12", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ s("path", { d: "M4 4L12 12M12 4L4 12", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" }) })
      }
    )
  ] });
}
function Bs(n) {
  const e = n.trim().split(/\s+/).filter(Boolean);
  return e.length === 0 ? "?" : e.slice(0, 2).map((t) => t[0]?.toUpperCase()).join("");
}
function Us(n) {
  let e = 0;
  for (let t = 0; t < n.length; t += 1) e = n.charCodeAt(t) + ((e << 5) - e);
  return `hsl(${Math.abs(e) % 360}, 55%, 45%)`;
}
function Jr({ identity: n, showName: e = !1, size: t = 20 }) {
  if (!n) return null;
  const r = n.includes("@") ? n : null, o = r ? n.split("@")[0] : n;
  return /* @__PURE__ */ b("div", { className: "flex items-center gap-1.5 min-w-0", title: r ? `${o} (${r})` : o, children: [
    /* @__PURE__ */ s(
      "div",
      {
        className: "shrink-0 rounded-full flex items-center justify-center text-white font-medium",
        style: { width: t, height: t, fontSize: t * 0.45, backgroundColor: Us(r || o) },
        children: Bs(o)
      }
    ),
    e ? /* @__PURE__ */ s("span", { className: "text-xs text-[var(--nim-text-muted)] truncate", children: o }) : null
  ] });
}
function dr(n) {
  const e = Math.max(0, Date.now() - n), t = Math.floor(e / 6e4);
  if (t < 1) return "just now";
  if (t < 60) return `${t}m ago`;
  const r = Math.floor(t / 60);
  if (r < 24) return `${r}h ago`;
  const o = Math.floor(r / 24);
  return o < 7 ? `${o}d ago` : new Date(n).toLocaleDateString();
}
const js = be.lazy(() => import("./SharedDocsItemMenu-_LgKzlqr.js").then((n) => ({ default: n.SharedDocsItemMenu }))), Vs = [
  { id: "all", label: "All", icon: "apps" },
  { id: "favorites", label: "Favorites", icon: "star" },
  { id: "review", label: "Unread", icon: "mark_email_unread" },
  { id: "recent", label: "Recently opened", icon: "history" },
  { id: "sharedWithMe", label: "Shared with me", icon: "call_received" },
  { id: "sharedByMe", label: "Shared by me", icon: "call_made" }
], Ws = /* @__PURE__ */ new Set([
  "lastEdited",
  "viewedByMe",
  "needsReview"
]);
function ur(n) {
  return Rn(n.title) || n.title || "Untitled";
}
function ln(n, e, t) {
  if (!n) return "Unknown";
  if (t.has(n)) return "You";
  const r = e.get(n);
  return r?.name ? r.name : r?.email ? r.email.split("@")[0] : "Unknown";
}
const Wi = ({ folderId: n, onSelectFolder: e, onCreateDocument: t, title: r, headerActions: o }) => {
  const { scope: a, host: l, session: c } = Wn(), p = qr(
    (m) => l.documents?.onDocumentTypesChanged?.(m) ?? (() => {
    }),
    () => l.documents?.documentTypes() ?? [],
    () => l.documents?.documentTypes() ?? []
  ), h = l.documents?.documentTypes() ?? [], y = j(c.atoms.sharedDocuments), C = j(c.atoms.sharedFolders), M = j(c.atoms.favorites), T = j(c.atoms.changedDocumentIds), $ = j(c.atoms.openedAt), oe = j(c.atoms.receipts), Ne = j(c.atoms.activeTeamUserId), ne = a.orgId, { personalState: A, readReceipts: g } = c.uiCapabilities, S = L(() => Vs.filter((m) => m.id === "favorites" || m.id === "recent" ? A : m.id === "review" ? g : !0), [A, g]), O = L(() => new Set(M), [M]), E = L(() => {
    const m = /* @__PURE__ */ new Map();
    for (const x of C)
      m.set(x.folderId, x.decryptFailed ? "Locked" : x.name);
    return m;
  }, [C]), [z, K] = R("all"), [q, ut] = R(""), [Z, nt] = R(
    g ? "needsReview" : "lastEdited"
  ), [ge, pt] = R("desc"), [Te, Ye] = R("list"), [Me, Xe] = R(/* @__PURE__ */ new Set()), [Ue, De] = R(/* @__PURE__ */ new Set()), [ae, D] = R(/* @__PURE__ */ new Set()), [X, Se] = R(null), ie = _((m, x, P) => {
    if (m.preventDefault(), m.stopPropagation(), P) {
      const H = P.getBoundingClientRect();
      Se({ x: H.left, y: H.bottom, target: x });
    } else
      Se({ x: m.clientX, y: m.clientY, target: x });
  }, []), Pe = be.useRef(!1), at = be.useRef("");
  ye(() => {
    Pe.current || (Pe.current = !0, l.trackEvent?.("collab_home_opened", {
      surface: l.surface ?? "desktop",
      entryPoint: "navigation",
      hasDocuments: y.some((m) => !m.decryptFailed),
      ...g ? { unreadCountBucket: It(T.size) } : {},
      ...A ? { favoriteCountBucket: It(M.length) } : {}
    }));
  }, [
    y,
    M.length,
    l,
    A,
    g,
    T.size
  ]);
  const [ee, Qe] = R(/* @__PURE__ */ new Map());
  ye(() => {
    if (!ne) {
      Qe(/* @__PURE__ */ new Map());
      return;
    }
    let m = !1;
    const x = async () => {
      try {
        const H = await l.getMembers(ne);
        if (m) return;
        const ke = /* @__PURE__ */ new Map();
        for (const xe of H)
          ke.set(xe.memberId, { name: xe.name ?? void 0, email: xe.email ?? void 0 });
        Qe(ke);
      } catch (H) {
        console.warn("[SharedDocsListView] Failed to load the team member directory:", H), m || Qe(/* @__PURE__ */ new Map());
      }
    };
    x();
    const P = l.onMembersChanged?.(() => {
      x();
    });
    return () => {
      m = !0, P?.();
    };
  }, [l, ne]);
  const je = a.indexConfig.userEmail ?? null, W = L(
    () => Ga(ee, Ne, je),
    [ee, Ne, je]
  ), ce = be.useRef(null);
  ye(() => {
    const m = (x) => {
      (x.metaKey || x.ctrlKey) && x.key.toLowerCase() === "k" && (x.preventDefault(), ce.current?.focus());
    };
    return window.addEventListener("keydown", m), () => window.removeEventListener("keydown", m);
  }, []);
  const Q = _(
    (m) => Cr(m, h),
    [h, p]
  ), Je = L(() => {
    const m = y.filter((x) => !x.decryptFailed);
    switch (z) {
      case "favorites":
        return m.filter((x) => O.has(x.documentId));
      case "review":
        return m.filter((x) => T.has(x.documentId));
      case "recent":
        return m.filter((x) => ($[x.documentId] ?? 0) > 0);
      case "sharedWithMe":
        return m.filter((x) => x.createdBy && !W.has(x.createdBy));
      case "sharedByMe":
        return m.filter((x) => x.createdBy && W.has(x.createdBy));
      default:
        return m;
    }
  }, [y, z, O, T, $, W]), re = L(
    () => y.filter((m) => !m.decryptFailed && T.has(m.documentId)).length,
    [y, T]
  ), mt = "__root__", rt = L(() => y.filter((m) => !m.decryptFailed), [y]), ft = L(() => {
    const m = /* @__PURE__ */ new Map();
    for (const x of rt) {
      const P = Q(x).typeLabel;
      m.has(P) || m.set(P, { value: P, label: P, color: Hr(P, x.documentType) });
    }
    return [...m.values()].sort((x, P) => x.label.localeCompare(P.label));
  }, [rt, Q]), xn = L(() => {
    const m = /* @__PURE__ */ new Map();
    for (const x of rt)
      x.createdBy && (m.has(x.createdBy) || m.set(x.createdBy, { value: x.createdBy, label: ln(x.createdBy, ee, W) }));
    return [...m.values()].sort((x, P) => x.label.localeCompare(P.label));
  }, [rt, ee, W]), _t = L(() => {
    const m = /* @__PURE__ */ new Map();
    for (const x of rt) {
      const P = x.parentFolderId ?? mt;
      if (!m.has(P)) {
        const H = x.parentFolderId ? E.get(x.parentFolderId) ?? "Unknown folder" : "No folder";
        m.set(P, { value: P, label: H });
      }
    }
    return [...m.values()].sort((x, P) => x.label.localeCompare(P.label));
  }, [rt, E]), ue = q.trim().toLowerCase(), Re = !!e, ve = Re && z === "all" && !ue && Me.size === 0 && Ue.size === 0, Le = L(() => ve ? /* @__PURE__ */ new Set([n ?? mt]) : n && !Re ? /* @__PURE__ */ new Set([n]) : ae, [Re, ve, n, ae]), Yt = L(() => {
    if (!ve) return [];
    const m = n ?? null;
    return C.filter((x) => (x.parentFolderId ?? null) === m).sort((x, P) => x.name.localeCompare(P.name));
  }, [ve, n, C]), Et = L(() => Je.filter((m) => !(ue && !ur(m).toLowerCase().includes(ue) || Me.size > 0 && !Me.has(Q(m).typeLabel) || Ue.size > 0 && !(m.createdBy && Ue.has(m.createdBy)) || Le.size > 0 && !Le.has(m.parentFolderId ?? mt))), [Je, ue, Me, Ue, Le, Q]);
  ye(() => {
    if (!ue) {
      at.current = "";
      return;
    }
    const m = window.setTimeout(() => {
      at.current !== ue && (at.current = ue, l.trackEvent?.("collab_home_searched", {
        surface: l.surface ?? "desktop",
        queryLengthBucket: Ts(ue.length),
        resultCountBucket: It(Et.length)
      }));
    }, 500);
    return () => window.clearTimeout(m);
  }, [Et.length, l, ue]);
  const ht = _(
    (m, x) => {
      m((P) => {
        const H = new Set(P);
        return H.has(x) ? H.delete(x) : H.add(x), H;
      });
    },
    []
  ), I = L(() => {
    const m = ge === "asc" ? 1 : -1, x = (P) => {
      switch (Z) {
        case "name":
          return ur(P).toLowerCase();
        case "type":
          return Q(P).typeLabel.toLowerCase();
        case "createdBy":
          return ln(P.createdBy, ee, W).toLowerCase();
        case "lastEdited":
          return P.updatedAt ?? 0;
        case "viewedByMe":
          return oe.get(P.documentId)?.lastViewedAt ?? 0;
        case "folder":
          return (P.parentFolderId ? E.get(P.parentFolderId) ?? "" : "").toLowerCase();
        case "needsReview":
          return T.has(P.documentId) ? 1 : 0;
        default:
          return 0;
      }
    };
    return [...Et].sort((P, H) => {
      const ke = x(P), xe = x(H);
      let we;
      return typeof ke == "number" && typeof xe == "number" ? we = ke - xe : we = String(ke).localeCompare(String(xe)), we === 0 && (we = (P.updatedAt ?? 0) - (H.updatedAt ?? 0)), we * m;
    });
  }, [Et, Z, ge, Q, ee, W, oe, E, T]), N = _((m) => {
    nt((x) => x === m ? (pt((P) => P === "asc" ? "desc" : "asc"), m) : (pt(Ws.has(m) ? "desc" : "asc"), m));
  }, []), Oe = _((m) => {
    l.openArtifact({
      kind: "document",
      scope: a,
      documentId: m.documentId,
      teamProjectId: m.teamProjectId
    }, "home");
  }, [l, a]), pe = _((m) => {
    if (!ne) return;
    const x = l.artifactUrl?.({
      kind: "document",
      scope: a,
      documentId: m.documentId,
      teamProjectId: m.teamProjectId
    });
    x && (navigator.clipboard?.writeText(x), l.trackEvent?.("collab_document_action", {
      surface: l.surface ?? "desktop",
      action: "link_copied",
      actorType: "user",
      documentType: No(m.documentType),
      entryPoint: "home"
    }));
  }, [l, ne, a]), Ae = y.filter((m) => !m.decryptFailed).length, $e = Hs[Z], st = L(() => {
    if (ue)
      return {
        icon: "search_off",
        title: `No matches for “${ue}”`,
        detail: "Search covers document names. Clear the search to see everything shared with you."
      };
    if (Ae === 0)
      return {
        icon: "folder_shared",
        title: "No shared documents yet",
        detail: "Documents your team shares appear here, and stay live for everyone who has them open."
      };
    const m = S.find((x) => x.id === z)?.label;
    return z !== "all" && m ? {
      icon: "filter_list_off",
      title: `Nothing in ${m}`,
      detail: `There are ${Ae} shared documents in All.`
    } : n ? {
      icon: "folder_open",
      title: "This folder is empty",
      detail: `Nothing is filed here yet. ${Ae} shared documents live elsewhere in this project.`
    } : {
      icon: "filter_list_off",
      title: "No documents match these filters",
      detail: `Clear a filter to see the other ${Ae} shared documents.`
    };
  }, [n, z, Ae, ue, S]);
  return /* @__PURE__ */ b("div", { className: "shared-docs-list-view h-full flex flex-col min-h-0 bg-nim select-text", children: [
    /* @__PURE__ */ b("div", { className: "shared-docs-list-header flex items-center gap-3 px-4 py-2.5 border-b border-nim shrink-0", children: [
      /* @__PURE__ */ s("div", { className: "shared-docs-list-title flex items-center gap-2 shrink-0", children: r ?? /* @__PURE__ */ b(Ie, { children: [
        /* @__PURE__ */ s(k, { icon: "groups", size: 20, className: "text-[var(--nim-text-muted)]" }),
        /* @__PURE__ */ s("span", { className: "text-[15px] font-semibold text-[var(--nim-text)]", children: "Shared" })
      ] }) }),
      /* @__PURE__ */ b("div", { className: "shared-docs-list-search flex items-center gap-2 flex-1 max-w-[520px] mx-auto rounded-md px-3 py-1.5 bg-[var(--nim-bg-secondary)] border border-[var(--nim-border)] focus-within:border-[var(--nim-primary)]", children: [
        /* @__PURE__ */ s(k, { icon: "search", size: 17, className: "text-[var(--nim-text-muted)]" }),
        /* @__PURE__ */ s(
          "input",
          {
            ref: ce,
            className: "flex-1 bg-transparent border-none outline-none text-[13px] text-[var(--nim-text)] placeholder:text-[var(--nim-text-faint)]",
            placeholder: "Search shared documents",
            value: q,
            onChange: (m) => ut(m.target.value),
            "aria-label": "Search shared documents"
          }
        ),
        /* @__PURE__ */ s("kbd", { className: "shrink-0 text-[10.5px] text-[var(--nim-text-faint)] border border-[var(--nim-border)] rounded px-1 py-0.5", children: "⌘K" })
      ] }),
      o,
      t ? /* @__PURE__ */ b(
        "button",
        {
          type: "button",
          className: "shared-docs-list-new flex items-center gap-1.5 shrink-0 px-2.5 py-1.5 rounded-md border border-[var(--nim-border)] bg-transparent text-[12px] text-[var(--nim-text)] cursor-pointer hover:bg-[var(--nim-bg-hover)]",
          "data-testid": "shared-docs-new-document",
          onClick: t,
          title: "New doc",
          children: [
            /* @__PURE__ */ s(k, { icon: "add", size: 17 }),
            "New doc"
          ]
        }
      ) : null,
      /* @__PURE__ */ b("div", { className: "shared-docs-view-toggle flex items-center rounded-md border border-[var(--nim-border)] overflow-hidden shrink-0", children: [
        /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            className: `flex items-center justify-center px-1.5 py-1 border-none cursor-pointer ${Te === "list" ? "bg-[var(--nim-bg-active)] text-[var(--nim-text)]" : "bg-transparent text-[var(--nim-text-muted)]"}`,
            onClick: () => Ye("list"),
            title: "List view",
            "aria-label": "List view",
            "aria-pressed": Te === "list",
            children: /* @__PURE__ */ s(k, { icon: "format_list_bulleted", size: 17 })
          }
        ),
        /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            className: "flex items-center justify-center px-1.5 py-1 border-none cursor-not-allowed bg-transparent text-[var(--nim-text-faint)] opacity-50",
            title: "Grid view (coming soon)",
            "aria-label": "Grid view (coming soon)",
            disabled: !0,
            children: /* @__PURE__ */ s(k, { icon: "grid_view", size: 17 })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ b("div", { className: "shared-docs-segments flex items-center gap-2 px-4 py-2 border-b border-nim shrink-0", children: [
      /* @__PURE__ */ s("div", { className: "flex items-center gap-1.5 flex-1 min-w-0 overflow-x-auto", children: S.map((m) => {
        const x = z === m.id;
        return /* @__PURE__ */ b(
          "button",
          {
            type: "button",
            className: `shared-docs-segment flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[12.5px] cursor-pointer border whitespace-nowrap ${x ? "bg-[var(--nim-bg-active)] text-[var(--nim-text)] border-[var(--nim-border)]" : "bg-transparent text-[var(--nim-text-muted)] border-transparent hover:bg-[var(--nim-bg-hover)]"}`,
            onClick: () => K(m.id),
            "aria-pressed": x,
            "data-segment": m.id,
            children: [
              /* @__PURE__ */ s(k, { icon: m.icon, size: 15, fill: m.id === "favorites" && x }),
              /* @__PURE__ */ s("span", { className: "shared-docs-segment-label", children: m.label }),
              m.id === "review" && re > 0 && /* @__PURE__ */ s("span", { className: "shared-docs-segment-badge text-[10.5px] font-semibold rounded-full px-1.5 py-px bg-[var(--nim-primary)] text-white", children: re })
            ]
          },
          m.id
        );
      }) }),
      /* @__PURE__ */ b("div", { className: "flex items-center gap-1.5 shrink-0", children: [
        /* @__PURE__ */ s(
          pr,
          {
            label: "Type",
            icon: "category",
            options: ft,
            selected: Me,
            onToggle: (m) => ht(Xe, m),
            onClear: () => Xe(/* @__PURE__ */ new Set())
          }
        ),
        /* @__PURE__ */ s(
          pr,
          {
            label: "People",
            icon: "group",
            options: xn,
            selected: Ue,
            onToggle: (m) => ht(De, m),
            onClear: () => De(/* @__PURE__ */ new Set())
          }
        ),
        n ? (
          /**
           * A routed folder page is scoped by its URL, and the URL wins (see
           * `scopedFolders`). The checkbox menu is multi-select and has no
           * route to clear to, so rendering it here would give the reader
           * three controls — pick another folder, uncheck this one, Clear all
           * — that all mutate state the list ignores. Moving between folders
           * belongs to the tree and the breadcrumb, which route.
           */
          /* @__PURE__ */ b(
            "span",
            {
              className: "shared-docs-facet shared-docs-facet-scope flex items-center gap-1 px-2.5 py-1 rounded-md text-[12px] border whitespace-nowrap bg-[var(--nim-bg-active)] text-[var(--nim-text)] border-[var(--nim-border)]",
              "data-facet": "folder",
              "data-facet-scope": "route",
              title: "This page shows one folder. Use the breadcrumb to open another.",
              children: [
                /* @__PURE__ */ s(k, { icon: "folder", size: 15 }),
                E.get(n) ?? "Unknown folder"
              ]
            }
          )
        ) : /* @__PURE__ */ s(
          pr,
          {
            label: "Folder",
            icon: "folder",
            options: _t,
            selected: ae,
            onToggle: (m) => ht(D, m),
            onClear: () => D(/* @__PURE__ */ new Set())
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ s("div", { className: "shared-docs-table flex-1 overflow-y-auto min-h-0", children: I.length === 0 && Yt.length === 0 ? /* @__PURE__ */ b("div", { className: "shared-docs-empty flex flex-col items-center justify-center h-full text-center px-6 py-16", children: [
      /* @__PURE__ */ s(k, { icon: st.icon, size: 34, className: "text-[var(--nim-text-faint)]" }),
      /* @__PURE__ */ s("p", { className: "mt-3 mb-0 text-[14px] font-medium text-[var(--nim-text)]", children: st.title }),
      /* @__PURE__ */ s("p", { className: "mt-1 mb-0 max-w-[26rem] text-[13px] leading-relaxed text-[var(--nim-text-muted)]", children: st.detail })
    ] }) : /* @__PURE__ */ b("table", { className: "w-full border-collapse text-[13px]", children: [
      /* @__PURE__ */ s("thead", { children: /* @__PURE__ */ b("tr", { className: "shared-docs-thead sticky top-0 z-10 bg-nim border-b border-nim text-[11px] uppercase tracking-wide text-[var(--nim-text-muted)]", children: [
        g && /* @__PURE__ */ s(wt, { label: "Unread", column: "needsReview", icon: "mark_email_unread", sortColumn: Z, sortDirection: ge, onSort: N, className: "w-8" }),
        A && /* @__PURE__ */ s("th", { className: "w-8 px-2 py-2" }),
        /* @__PURE__ */ s(wt, { label: "Name", column: "name", sortColumn: Z, sortDirection: ge, onSort: N }),
        /* @__PURE__ */ s(wt, { label: "Type", column: "type", sortColumn: Z, sortDirection: ge, onSort: N }),
        /* @__PURE__ */ s(wt, { label: "Created by", column: "createdBy", sortColumn: Z, sortDirection: ge, onSort: N }),
        /* @__PURE__ */ s(wt, { label: "Last edited", column: "lastEdited", sortColumn: Z, sortDirection: ge, onSort: N }),
        g && /* @__PURE__ */ s(wt, { label: "Viewed by me", column: "viewedByMe", sortColumn: Z, sortDirection: ge, onSort: N }),
        !ve && /* @__PURE__ */ s(wt, { label: "Folder", column: "folder", sortColumn: Z, sortDirection: ge, onSort: N })
      ] }) }),
      /* @__PURE__ */ b("tbody", { children: [
        Yt.map((m) => {
          const x = m.decryptFailed ? "Locked folder" : m.name;
          return /* @__PURE__ */ b(
            "tr",
            {
              className: "shared-docs-row shared-docs-folder-row group cursor-pointer border-b border-[var(--nim-border)] hover:bg-[var(--nim-bg-hover)]",
              onClick: () => e?.(m.folderId),
              onContextMenu: (P) => ie(P, { kind: "folder", folder: m }),
              "data-folder-id": m.folderId,
              children: [
                g && /* @__PURE__ */ s("td", { className: "px-2 py-2" }),
                A && /* @__PURE__ */ s("td", { className: "px-2 py-2" }),
                /* @__PURE__ */ s("td", { className: "px-2 py-2 align-middle", children: /* @__PURE__ */ b("div", { className: "flex items-center gap-2.5 min-w-0", children: [
                  /* @__PURE__ */ s("span", { className: "shrink-0 w-6 h-6 rounded-md flex items-center justify-center text-[var(--nim-text-muted)] bg-[var(--nim-bg-secondary)]", children: /* @__PURE__ */ s(k, { icon: "folder", size: 16 }) }),
                  /* @__PURE__ */ s(
                    gr,
                    {
                      className: "truncate text-[13.5px] text-[var(--nim-text)] no-underline",
                      href: l.artifactUrl?.({ kind: "folder", scope: a, folderId: m.folderId }),
                      onClick: () => e?.(m.folderId),
                      children: x
                    }
                  ),
                  /* @__PURE__ */ s("span", { className: "shared-docs-row-actions ml-auto flex items-center gap-0.5 opacity-0 group-hover:opacity-100 pl-2", children: /* @__PURE__ */ s(En, { icon: "more_horiz", title: "More actions", onClick: (P) => ie(P, { kind: "folder", folder: m }, P.currentTarget) }) })
                ] }) }),
                /* @__PURE__ */ s("td", { className: "px-2 py-2 align-middle whitespace-nowrap text-[12.5px] text-[var(--nim-text-muted)]", children: "Folder" }),
                /* @__PURE__ */ s("td", { className: "px-2 py-2 align-middle whitespace-nowrap", children: /* @__PURE__ */ s(Jr, { identity: ln(m.createdBy, ee, W), showName: !0, size: 20 }) }),
                /* @__PURE__ */ s("td", { className: "px-2 py-2 align-middle whitespace-nowrap text-[12.5px] text-[var(--nim-text-muted)]", children: m.updatedAt ? dr(m.updatedAt) : /* @__PURE__ */ s("span", { className: "text-[var(--nim-text-faint)]", children: "—" }) }),
                g && /* @__PURE__ */ s("td", { className: "px-2 py-2" })
              ]
            },
            m.folderId
          );
        }),
        I.map((m) => {
          const x = Q(m), P = Hr(x.typeLabel, m.documentType), H = O.has(m.documentId), ke = T.has(m.documentId), xe = m.lastWriterUserId, we = oe.get(m.documentId)?.lastViewedAt ?? 0, wn = m.parentFolderId ? E.get(m.parentFolderId) : void 0;
          return /* @__PURE__ */ b(
            "tr",
            {
              className: "shared-docs-row group cursor-pointer border-b border-[var(--nim-border)] hover:bg-[var(--nim-bg-hover)]",
              onClick: () => Oe(m),
              onContextMenu: (Ce) => ie(Ce, { kind: "document", document: m }),
              "data-document-id": m.documentId,
              children: [
                g && /* @__PURE__ */ s("td", { className: "px-2 py-2 align-middle text-center", children: ke ? /* @__PURE__ */ s(
                  "span",
                  {
                    className: "shared-docs-review-dot inline-block w-2 h-2 rounded-full bg-[var(--nim-primary)] align-middle",
                    title: "Changed since you last viewed",
                    "aria-label": "Unread"
                  }
                ) : null }),
                A && /* @__PURE__ */ s("td", { className: "px-2 py-2 align-middle", children: /* @__PURE__ */ s(
                  "button",
                  {
                    type: "button",
                    className: `shared-docs-star flex items-center justify-center bg-transparent border-none cursor-pointer p-0.5 rounded transition-opacity ${H ? "text-[var(--nim-warning)] opacity-100" : "text-[var(--nim-text-faint)] opacity-0 group-hover:opacity-80 hover:!opacity-100"}`,
                    title: H ? "Unfavorite" : "Favorite",
                    "aria-label": H ? "Unfavorite" : "Favorite",
                    "aria-pressed": H,
                    onClick: (Ce) => {
                      Ce.stopPropagation(), c.toggleFavorite(m.documentId);
                    },
                    children: /* @__PURE__ */ s(k, { icon: "star", size: 16, fill: H })
                  }
                ) }),
                /* @__PURE__ */ s("td", { className: "px-2 py-2 align-middle", children: /* @__PURE__ */ b("div", { className: "flex items-center gap-2.5 min-w-0", children: [
                  /* @__PURE__ */ s("span", { className: "shrink-0 w-6 h-6 rounded-md flex items-center justify-center", style: { color: P, backgroundColor: `color-mix(in srgb, ${P} 14%, transparent)` }, children: /* @__PURE__ */ s(k, { icon: x.icon, size: 16 }) }),
                  /* @__PURE__ */ s(gr, { className: "truncate text-[13.5px] text-[var(--nim-text)] no-underline", href: l.surface === "web_console" ? l.artifactUrl?.({ kind: "document", scope: a, documentId: m.documentId, teamProjectId: m.teamProjectId }) : null, onClick: () => Oe(m), children: ur(m) }),
                  /* @__PURE__ */ b("span", { className: "shared-docs-row-actions ml-auto flex items-center gap-0.5 opacity-0 group-hover:opacity-100 pl-2", children: [
                    /* @__PURE__ */ s(En, { icon: "open_in_new", title: "Open", onClick: (Ce) => {
                      Ce.stopPropagation(), Oe(m);
                    } }),
                    /* @__PURE__ */ s(En, { icon: "link", title: "Copy link", onClick: (Ce) => {
                      Ce.stopPropagation(), pe(m);
                    } }),
                    /* @__PURE__ */ s(En, { icon: "more_horiz", title: "More actions", onClick: (Ce) => ie(Ce, { kind: "document", document: m }, Ce.currentTarget) })
                  ] })
                ] }) }),
                /* @__PURE__ */ s("td", { className: "px-2 py-2 align-middle whitespace-nowrap", children: /* @__PURE__ */ b(
                  "span",
                  {
                    className: "shared-docs-type-chip inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-[11.5px] font-medium",
                    style: { color: P, backgroundColor: `color-mix(in srgb, ${P} 14%, transparent)` },
                    children: [
                      /* @__PURE__ */ s(k, { icon: x.icon, size: 13 }),
                      x.typeLabel
                    ]
                  }
                ) }),
                /* @__PURE__ */ s("td", { className: "px-2 py-2 align-middle whitespace-nowrap", children: /* @__PURE__ */ s(Jr, { identity: ln(m.createdBy, ee, W), showName: !0, size: 20 }) }),
                /* @__PURE__ */ s("td", { className: "px-2 py-2 align-middle whitespace-nowrap text-[12.5px] text-[var(--nim-text-muted)]", children: m.updatedAt ? /* @__PURE__ */ b("span", { children: [
                  dr(m.updatedAt),
                  xe && /* @__PURE__ */ b("span", { className: "text-[var(--nim-text-faint)]", children: [
                    " · ",
                    ln(xe, ee, W)
                  ] })
                ] }) : /* @__PURE__ */ s("span", { className: "text-[var(--nim-text-faint)]", children: "—" }) }),
                g && /* @__PURE__ */ s("td", { className: "px-2 py-2 align-middle whitespace-nowrap text-[12.5px]", children: we > 0 ? /* @__PURE__ */ s("span", { className: "text-[var(--nim-text-muted)]", children: dr(we) }) : /* @__PURE__ */ b("span", { className: "flex items-center gap-1 text-[var(--nim-warning)]", children: [
                  /* @__PURE__ */ s(k, { icon: "visibility_off", size: 14 }),
                  "Never"
                ] }) }),
                !ve && /* @__PURE__ */ s("td", { className: "px-2 py-2 align-middle whitespace-nowrap", children: wn ? /* @__PURE__ */ b("span", { className: "shared-docs-folder-chip inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-[11.5px] text-[var(--nim-text-muted)] bg-[var(--nim-bg-secondary)] border border-[var(--nim-border)]", children: [
                  /* @__PURE__ */ s(k, { icon: "folder", size: 13 }),
                  wn
                ] }) : /* @__PURE__ */ s("span", { className: "text-[var(--nim-text-faint)] text-[12px]", children: "—" }) })
              ]
            },
            m.documentId
          );
        })
      ] })
    ] }) }),
    /* @__PURE__ */ b("div", { className: "shared-docs-list-footer flex items-center gap-2 px-4 py-1.5 border-t border-nim shrink-0 text-[11.5px] text-[var(--nim-text-muted)]", children: [
      /* @__PURE__ */ b("span", { children: [
        I.length,
        " of ",
        Ae,
        " documents"
      ] }),
      g && re > 0 && /* @__PURE__ */ b(Ie, { children: [
        /* @__PURE__ */ s("span", { className: "text-[var(--nim-text-faint)]", children: "·" }),
        /* @__PURE__ */ b("span", { children: [
          re,
          " unread"
        ] })
      ] }),
      /* @__PURE__ */ s("span", { className: "text-[var(--nim-text-faint)]", children: "·" }),
      /* @__PURE__ */ b("span", { children: [
        "Sorted by ",
        $e
      ] })
    ] }),
    /* @__PURE__ */ s(be.Suspense, { fallback: null, children: /* @__PURE__ */ s(js, { state: X, onClose: () => Se(null), onOpenFolder: e }) })
  ] });
}, Hs = {
  name: "name",
  type: "type",
  createdBy: "created by",
  lastEdited: "last edited",
  viewedByMe: "viewed by me",
  folder: "folder",
  needsReview: "unread"
}, wt = ({ label: n, column: e, sortColumn: t, sortDirection: r, onSort: o, align: a = "left", icon: l, className: c }) => {
  const p = t === e, h = p ? r === "asc" ? "arrow_upward" : "arrow_downward" : "unfold_more";
  return /* @__PURE__ */ s("th", { className: `px-2 py-2 font-medium ${a === "right" ? "text-right" : "text-left"} ${c ?? ""}`, children: /* @__PURE__ */ b(
    "button",
    {
      type: "button",
      className: `shared-docs-th-btn inline-flex items-center gap-1 bg-transparent border-none cursor-pointer uppercase tracking-wide text-[11px] ${p ? "text-[var(--nim-primary)]" : "text-[var(--nim-text-muted)] hover:text-[var(--nim-text)]"} ${a === "right" ? "flex-row-reverse" : ""}`,
      onClick: () => o(e),
      title: l ? `Sort by ${n}` : void 0,
      "aria-label": l ? `Sort by ${n}` : void 0,
      children: [
        l ? /* @__PURE__ */ s(k, { icon: l, size: 15, fill: p }) : /* @__PURE__ */ b(Ie, { children: [
          n,
          /* @__PURE__ */ s(k, { icon: h, size: 14 })
        ] }),
        l && p && /* @__PURE__ */ s(k, { icon: r === "asc" ? "arrow_upward" : "arrow_downward", size: 11 })
      ]
    }
  ) });
}, pr = ({ label: n, icon: e, options: t, selected: r, onToggle: o, onClear: a }) => {
  const [l, c] = R(!1), p = r.size, { refs: h, floatingStyles: y, context: C } = ia({
    open: l,
    onOpenChange: c,
    placement: "bottom-end",
    middleware: [ca(6), da({ padding: 8 }), ua({ padding: 8 }), ya()],
    whileElementsMounted: la
  }), M = pa(C), T = ma(C), $ = fa(C, { role: "menu" }), { getReferenceProps: oe, getFloatingProps: Ne } = ha([M, T, $]);
  return /* @__PURE__ */ b(Ie, { children: [
    /* @__PURE__ */ b(
      "button",
      {
        ref: h.setReference,
        ...oe(),
        type: "button",
        className: `shared-docs-facet flex items-center gap-1 px-2.5 py-1 rounded-md text-[12px] cursor-pointer border whitespace-nowrap ${p > 0 ? "bg-[var(--nim-bg-active)] text-[var(--nim-text)] border-[var(--nim-border)]" : "bg-transparent text-[var(--nim-text-muted)] border-[var(--nim-border)] hover:bg-[var(--nim-bg-hover)]"}`,
        "data-facet": n.toLowerCase(),
        "aria-label": `Filter by ${n}`,
        children: [
          /* @__PURE__ */ s(k, { icon: e, size: 15 }),
          n,
          p > 0 && /* @__PURE__ */ s("span", { className: "shared-docs-facet-count text-[10.5px] font-semibold rounded-full px-1.5 py-px bg-[var(--nim-primary)] text-white", children: p }),
          /* @__PURE__ */ s(k, { icon: "expand_more", size: 15 })
        ]
      }
    ),
    l && /* @__PURE__ */ s(Vt, { children: /* @__PURE__ */ b(
      "div",
      {
        ref: h.setFloating,
        style: y,
        ...Ne(),
        className: "shared-docs-facet-menu z-50 min-w-[200px] max-h-[320px] overflow-y-auto rounded-md border border-[var(--nim-border)] bg-[var(--nim-bg-secondary)] shadow-lg py-1",
        children: [
          /* @__PURE__ */ b("div", { className: "flex items-center justify-between px-3 py-1.5", children: [
            /* @__PURE__ */ s("span", { className: "text-[11px] uppercase tracking-wide text-[var(--nim-text-muted)]", children: n }),
            p > 0 && /* @__PURE__ */ s(
              "button",
              {
                type: "button",
                className: "text-[11px] text-[var(--nim-primary)] bg-transparent border-none cursor-pointer hover:underline",
                onClick: a,
                children: "Clear"
              }
            )
          ] }),
          t.length === 0 ? /* @__PURE__ */ s("div", { className: "px-3 py-2 text-[12px] text-[var(--nim-text-faint)]", children: "No options" }) : t.map((ne) => {
            const A = r.has(ne.value);
            return /* @__PURE__ */ b(
              "button",
              {
                type: "button",
                role: "menuitemcheckbox",
                "aria-checked": A,
                className: "shared-docs-facet-option w-full flex items-center gap-2 px-3 py-1.5 text-left text-[12.5px] bg-transparent border-none cursor-pointer text-[var(--nim-text)] hover:bg-[var(--nim-bg-hover)]",
                onClick: () => o(ne.value),
                children: [
                  /* @__PURE__ */ s("span", { className: `shrink-0 w-4 h-4 rounded border flex items-center justify-center ${A ? "bg-[var(--nim-primary)] border-[var(--nim-primary)]" : "border-[var(--nim-border)]"}`, children: A && /* @__PURE__ */ s(k, { icon: "check", size: 12, className: "text-white" }) }),
                  ne.color && /* @__PURE__ */ s("span", { className: "shrink-0 w-2 h-2 rounded-full", style: { backgroundColor: ne.color } }),
                  /* @__PURE__ */ s("span", { className: "truncate", children: ne.label })
                ]
              },
              ne.value
            );
          })
        ]
      }
    ) })
  ] });
}, En = ({ icon: n, title: e, onClick: t }) => /* @__PURE__ */ s(
  "button",
  {
    type: "button",
    className: "flex items-center justify-center p-1 rounded bg-transparent border-none cursor-pointer text-[var(--nim-text-muted)] hover:text-[var(--nim-text)] hover:bg-[var(--nim-bg-active)]",
    title: e,
    "aria-label": e,
    onClick: t,
    children: /* @__PURE__ */ s(k, { icon: n, size: 15 })
  }
), Hi = () => import("./index-Cvf5KU8K.js"), Gi = async () => ({
  ...await import("./index-oTjo-Svn.js"),
  ...await import("./index-CeYqruww.js")
});
export {
  us as $,
  po as A,
  wa as B,
  Be as C,
  Ns as D,
  bi as E,
  Sa as F,
  Ua as G,
  is as H,
  lr as I,
  xi as J,
  Oa as K,
  wr as L,
  Ea as M,
  hi as N,
  wi as O,
  ba as P,
  Wa as Q,
  Ba as R,
  Ei as S,
  Ka as T,
  hs as U,
  Ra as V,
  Vn as W,
  Ma as X,
  $n as Y,
  gi as Z,
  Ci as _,
  Ja as a,
  Ii as a0,
  Ti as a1,
  ki as a2,
  Si as a3,
  Ni as a4,
  yo as a5,
  Ki as a6,
  Ai as a7,
  li as a8,
  Mi as a9,
  Hr as aA,
  jn as aB,
  kr as aC,
  ci as aD,
  Di as aE,
  Pi as aF,
  di as aG,
  yi as aH,
  ui as aI,
  ii as aJ,
  zi as aK,
  $i as aL,
  Li as aM,
  Oi as aN,
  pi as aO,
  Hi as aa,
  Gi as ab,
  Ca as ac,
  br as ad,
  mo as ae,
  oi as af,
  si as ag,
  Ur as ah,
  dn as ai,
  ka as aj,
  Bi as ak,
  lo as al,
  _i as am,
  ai as an,
  vi as ao,
  La as ap,
  Wr as aq,
  za as ar,
  Ga as as,
  ri as at,
  Ta as au,
  ao as av,
  so as aw,
  Na as ax,
  Fi as ay,
  uo as az,
  Cr as b,
  dr as c,
  Ds as d,
  Yr as e,
  Gt as f,
  Qa as g,
  Ri as h,
  ls as i,
  Vi as j,
  Ui as k,
  Pa as l,
  ji as m,
  Ya as n,
  ps as o,
  io as p,
  Wi as q,
  Da as r,
  No as s,
  Gr as t,
  Wn as u,
  le as v,
  mi as w,
  _a as x,
  fi as y,
  Mn as z
};
//# sourceMappingURL=docs-ui-uhJGZagS.js.map
